/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    var _2ClickIframePrivacy = new function () {
        var m = {noCookies: !1};
        this.types = new Array({
            type: "video",
            class: "privacy-video",
            description: "Zum Aktivieren des Videos bitte auf den Link klicken. Durch das Aktivieren von eingebetteten Videos werden Daten an den jeweiligen Anbieter übermittelt. Weitere Informationen können unserer Datenschutzerklärung entnommen werden.<br />"
        }, {
            type: "map",
            class: "privacy-map",
            description: "Zum Aktivieren der eingebetteten Karte bitte auf den Link klicken. Durch das Aktivieren werden Daten an den jeweiligen Anbieter übermittelt. Weitere Informationen können unserer Datenschutzerklärung entnommen werden.<br />"
        }, {
            type: "calendar",
            class: "privacy-calendar",
            description: "Zum Aktivieren des eingebetteten Kalenders bitte auf den Link klicken. Durch das Aktivieren werden Daten an den jeweiligen Anbieter übermittelt. Weitere Informationen können unserer Datenschutzerklärung entnommen werden.<br />"
        }), this.EnableContent = function (e, n) {
            m.noCookies || function (e, n, t) {
                var i = new Date;
                i.setTime(i.getTime() + 864e5 * t), document.cookie = e + "=" + n + ";path=/;expires=" + i.toGMTString()
            }("_2ClickIPEnable-" + e, "1", 1);
            var t, i = document.querySelectorAll("div." + n + "-msg p");
            for (t = 0; t < i.length; t++) i[t].parentNode.removeChild(i[t]);
            for (i = document.querySelectorAll("div." + n + "-msg"), t = 0; t < i.length; t++) {
                for (var r = i[t].parentNode; i[t].firstChild;) r.insertBefore(i[t].firstChild, i[t]);
                r.removeChild(i[t])
            }
            for (i = document.getElementsByClassName(n), t = 0; t < i.length; t++) i[t].src = i[t].title
        }, this.init = function (e) {
            for (void 0 !== e.noCookies && (m.noCookies = e.noCookies), Array.isArray(e.CustomTypes) && (this.types = e.CustomTypes), i = 0; i < this.types.length; i++) {
                var n, t = document.getElementsByClassName(this.types[i].class);
                if (c = "_2ClickIPEnable-" + this.types[i].type, void 0, (d = document.cookie.match("(^|;) ?" + c + "=([^;]*)(;|$)")) && d[2]) for (n = 0; n < t.length; n++) t[n].src = t[n].title; else for (n = 0; n < t.length; n++) r = t[n], s = document.createElement("div"), o = this.types[i].type, a = this.types[i].class, l = this.types[i].description, r.parentNode.insertBefore(s, r), s.className = "privacy-msg " + a + "-msg", s.style.width = r.clientWidth + "px", s.style.height = r.clientHeight + "px", s.innerHTML = "<p>" + l + '<a href="#foo" onclick="_2ClickIframePrivacy.EnableContent(\'' + o + "', '" + a + "'); return false;\">Inhalt anzeigen</a></p>", s.appendChild(r)
            }
            var r, s, o, a, l, c, d
        }
    };


    /* Add to Homescreen v3.2.3 ~ (c) 2015 Matteo Spinelli ~ @license: http://cubiq.org/license */
    (function (window, document) {
        var _eventListener = "addEventListener" in window;
        var _DOMReady = false;
        if (document.readyState === "complete") {
            _DOMReady = true
        } else if (_eventListener) {
            window.addEventListener("load", loaded, false)
        }

        function loaded() {
            window.removeEventListener("load", loaded, false);
            _DOMReady = true
        }

        var _reSmartURL = /\/ath(\/)?$/;
        var _reQueryString = /([\?&]ath=[^&]*$|&ath=[^&]*(&))/;
        var _instance;

        function ath(options) {
            _instance = _instance || new ath.Class(options);
            return _instance
        }

        ath.intl = {
            cs_cs: {
                ios: "Pro přidáni této webové aplikace na úvodní obrazovku: stlačte %icon a pak <strong>Přidat na úvodní obrazovku</strong>.",
                android: 'Pro přidáni této webové aplikace na úvodní obrazovku otevřete menu nastavení prohlížeče a stlačte <strong>Přidat na úvodní obrazovku</strong>. <small>K menu se dostanete stlačením hardwaroveho tlačítka, když ho vaše zařízení má, nebo stlačením pravé horní menu ikony <span class="ath-action-icon">icon</span>.</small>'
            },
            de_de: {
                ios: "<strong>Tipp</strong> Um diese Website zum Home-Bildschirm hinzuzufügen, tippen Sie hier %icon und dann auf <strong>„Zum Home-Bildschirm“</strong>.",
                android: "<strong>Tipp</strong> Um diese Website zum Home-Bildschirm hinzuzufügen, öffnen Sie bitte die Browser Optionen und klicken Sie auf:<br /><strong>„Zum Startbildschirm hinzufügen“</strong><br /><small>Die Browser Optionen sind oben rechts anwählbar unter diesem Symbol: %icon</small>"
            },
            da_dk: {
                ios: "For at tilføje denne web app til hjemmeskærmen: Tryk %icon og derefter <strong>Føj til hjemmeskærm</strong>.",
                android: "For at tilføje denne web app til hjemmeskærmen, åbn browser egenskaber menuen og tryk på <strong>Føj til hjemmeskærm</strong>. <small>Denne menu kan tilgås ved at trykke på menu knappen, hvis din enhed har en, eller ved at trykke på det øverste højre menu ikon %icon.</small>"
            },
            el_gr: {
                ios: "Για να προσθέσετε την εφαρμογή στην αρχική οθόνη: πατήστε το %icon και μετά <strong>Πρόσθεσε στην αρχική οθόνη</strong>.",
                android: "Για να προσθέσετε την εφαρμογή στην αρχική οθόνη, ανοίξτε τις επιλογές του browser σας και πατήστε το <strong>Προσθήκη στην αρχική οθόνη</strong>. <small>Μπορείτε να έχετε πρόσβαση στο μενού, πατώντας το κουμπί του μενού του κινητού σας ή το πάνω δεξιά κουμπί του μενού %icon.</small>"
            },
            en_us: {
                ios: "To add this web app to the home screen: tap %icon and then <strong>Add to Home Screen</strong>.",
                android: "To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>"
            },
            es_es: {
                ios: "Para añadir esta aplicación web a la pantalla de inicio: pulsa %icon y selecciona <strong>Añadir a pantalla de inicio</strong>.",
                android: "Para añadir esta aplicación web a la pantalla de inicio, abre las opciones y pulsa <strong>Añadir a pantalla inicio</strong>. <small>El menú se puede acceder pulsando el botón táctil en caso de tenerlo, o bien el icono de la parte superior derecha de la pantalla %icon.</small>"
            },
            fi_fi: {
                ios: "Liitä tämä sovellus kotivalikkoon: klikkaa %icon ja tämän jälkeen <strong>Lisää kotivalikkoon</strong>.",
                android: "Lisätäksesi tämän sovelluksen aloitusnäytölle, avaa selaimen valikko ja klikkaa tähti -ikonia tai <strong>Lisää aloitusnäytölle tekstiä</strong>. <small>Valikkoon pääsee myös painamalla menuvalikkoa, jos laitteessasi on sellainen tai koskettamalla oikealla yläkulmassa menu ikonia %icon.</small>"
            },
            fr_fr: {
                ios: "Pour ajouter cette application web sur l'écran d'accueil : Appuyez %icon et sélectionnez <strong>Ajouter sur l'écran d'accueil</strong>.",
                android: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez sur le bouton "menu", puis sur <strong>Ajouter sur l\'écran d\'accueil</strong>. <small>Le menu peut-être accessible en appuyant sur le bouton "menu" du téléphone s\'il en possède un <i class="fa fa-bars"></i>. Sinon, il se trouve probablement dans la coin supérieur droit du navigateur %icon.</small>'
            },
            he_il: {
                ios: '<span dir="rtl">להוספת האפליקציה למסך הבית: ללחוץ על %icon ואז <strong>הוסף למסך הבית</strong>.</span>',
                android: "To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>"
            },
            hu_hu: {
                ios: "Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, érintse meg a következő ikont: %icon , majd a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontot.",
                android: "Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, a böngésző menüjében kattintson a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontra. <small>A böngésző menüjét a következő ikon megérintésével tudja megnyitni: %icon.</small>"
            },
            it_it: {
                ios: "Per aggiungere questa web app alla schermata iniziale: premi %icon e poi <strong>Aggiungi a Home</strong>.",
                android: "Per aggiungere questa web app alla schermata iniziale, apri il menu opzioni del browser e premi su <strong>Aggiungi alla homescreen</strong>. <small>Puoi accedere al menu premendo il pulsante hardware delle opzioni se la tua device ne ha uno, oppure premendo l'icona %icon in alto a destra.</small>"
            },
            ja_jp: {
                ios: "このウェプアプリをホーム画面に追加するには、%iconをタップして<strong>ホーム画面に追加</strong>してください。",
                android: "このウェプアプリをホーム画面に追加するには、ブラウザのオプションメニューから<strong>ホーム画面に追加</strong>をタップしてください。<small>オプションメニューは、一部の機種ではデバイスのメニューボタンから、それ以外では画面右上の%iconからアクセスできます。</small>"
            },
            ko_kr: {
                ios: "홈 화면에 바로가기 생성: %icon 을 클릭한 후 <strong>홈 화면에 추가</strong>.",
                android: "브라우저 옵션 메뉴의 <string>홈 화면에 추가</string>를 클릭하여 홈화면에 바로가기를 생성할 수 있습니다. <small>옵션 메뉴는 장치의 메뉴 버튼을 누르거나 오른쪽 상단의 메뉴 아이콘 %icon을 클릭하여 접근할 수 있습니다.</small>"
            },
            nb_no: {
                ios: "For å installere denne appen på hjem-skjermen: trykk på %icon og deretter <strong>Legg til på Hjem-skjerm</strong>.",
                android: "For å legge til denne webappen på startsiden åpner en nettlesermenyen og velger <strong>Legg til på startsiden</strong>. <small>Menyen åpnes ved å trykke på den fysiske menyknappen hvis enheten har det, eller ved å trykke på menyikonet øverst til høyre %icon.</small>"
            },
            pt_br: {
                ios: "Para adicionar este app à tela de início: clique %icon e então <strong>Tela de início</strong>.",
                android: 'Para adicionar este app à tela de início, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
            },
            pt_pt: {
                ios: "Para adicionar esta app ao ecrã principal: clique %icon e depois <strong>Ecrã principal</strong>.",
                android: 'Para adicionar esta app web ecrã principal, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
            },
            nl_nl: {
                ios: "Om deze webapp aan je startscherm toe te voegen, klik op %icon en dan <strong>Zet in startscherm</strong>.",
                android: 'Om deze webapp aan je startscherm toe te voegen, open de browserinstellingen en tik op <strong>Toevoegen aan startscherm</strong>. <small>Gebruik de "menu" knop als je telefoon die heeft, anders het menu-icoon rechtsbovenin %icon.</small>'
            },
            ru_ru: {
                ios: 'Чтобы добавить этот сайт на свой домашний экран, нажмите на иконку %icon и затем <strong>На экран "Домой"</strong>.',
                android: "Чтобы добавить сайт на свой домашний экран, откройте меню браузера и нажмите на <strong>Добавить на главный экран</strong>. <small>Меню можно вызвать, нажав на кнопку меню вашего телефона, если она есть. Или найдите иконку сверху справа %icon[иконка].</small>"
            },
            sk_sk: {
                ios: "Pre pridanie tejto webovej aplikácie na úvodnú obrazovku: stlačte %icon a potom <strong>Pridať na úvodnú obrazovku</strong>.",
                android: 'Pre pridanie tejto webovej aplikácie na úvodnú obrazovku otvorte menu nastavenia prehliadača a stlačte <strong>Pridať na úvodnú obrazovku</strong>. <small>K menu sa dostanete stlačením hardwaroveho tlačidla, ak ho vaše zariadenie má, alebo stlačením pravej hornej menu ikony <span class="ath-action-icon">icon</span>.</small>'
            },
            sv_se: {
                ios: "För att lägga till denna webbapplikation på hemskärmen: tryck på %icon och därefter <strong>Lägg till på hemskärmen</strong>.",
                android: "För att lägga till den här webbappen på hemskärmen öppnar du webbläsarens alternativ-meny och väljer <strong>Lägg till på startskärmen</strong>. <small>Man hittar menyn genom att trycka på hårdvaruknappen om din enhet har en sådan, eller genom att trycka på menyikonen högst upp till höger %icon.</small>"
            },
            tr_tr: {
                ios: "Uygulamayı ana ekrana eklemek için, %icon ve ardından <strong>ana ekrana ekle</strong> butonunu tıklayın.",
                android: "Uygulamayı ana ekrana eklemek için, menüye girin ve <strong>ana ekrana ekle</strong> butonunu tıklayın. <small>Cihazınız menü tuşuna sahip ise menüye girmek için menü tuşunu tıklayın. Aksi takdirde %icon butonunu tıklayın.</small>"
            },
            uk_ua: {
                ios: "Щоб додати цей сайт на початковий екран, натисніть %icon, а потім <strong>На початковий екран</strong>.",
                android: "Щоб додати цей сайт на домашній екран, відкрийте меню браузера та виберіть <strong>Додати на головний екран</strong>. <small>Це можливо зробити, натиснувши кнопку меню на вашому смартфоні, якщо така є. Або ж на іконці зверху справа %icon.</small>"
            },
            zh_cn: {
                ios: "如要把应用程序加至主屏幕,请点击%icon, 然后<strong>添加到主屏幕</strong>",
                android: "To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>"
            },
            zh_tw: {
                ios: "如要把應用程式加至主屏幕, 請點擊%icon, 然後<strong>加至主屏幕</strong>.",
                android: "To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>"
            }
        };
        for (var lang in ath.intl) {
            ath.intl[lang.substr(0, 2)] = ath.intl[lang]
        }
        ath.defaults = {
            appID: "org.cubiq.addtohome",
            fontSize: 15,
            debug: false,
            logging: false,
            modal: false,
            mandatory: false,
            autostart: true,
            skipFirstVisit: false,
            startDelay: 1,
            lifespan: 15,
            displayPace: 1440,
            maxDisplayCount: 0,
            icon: true,
            message: "",
            validLocation: [],
            onInit: null,
            onShow: null,
            onRemove: null,
            onAdd: null,
            onPrivate: null,
            privateModeOverride: false,
            detectHomescreen: false
        };
        var _ua = window.navigator.userAgent;
        var _nav = window.navigator;
        _extend(ath, {
            hasToken: document.location.hash == "#ath" || _reSmartURL.test(document.location.href) || _reQueryString.test(document.location.search),
            isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
            isIDevice: /iphone|ipod|ipad/i.test(_ua),
            isMobileChrome: _ua.indexOf("Android") > -1 && /Chrome\/[.0-9]*/.test(_ua) && _ua.indexOf("Version") == -1,
            isMobileIE: _ua.indexOf("Windows Phone") > -1,
            language: _nav.language && _nav.language.toLowerCase().replace("-", "_") || ""
        });
        ath.language = ath.language && ath.language in ath.intl ? ath.language : "en_us";
        ath.isMobileSafari = ath.isIDevice && _ua.indexOf("Safari") > -1 && _ua.indexOf("CriOS") < 0;
        ath.OS = ath.isIDevice ? "ios" : ath.isMobileChrome ? "android" : ath.isMobileIE ? "windows" : "unsupported";
        ath.OSVersion = _ua.match(/(OS|Android) (\d+[_\.]\d+)/);
        ath.OSVersion = ath.OSVersion && ath.OSVersion[2] ? +ath.OSVersion[2].replace("_", ".") : 0;
        ath.isStandalone = "standalone" in window.navigator && window.navigator.standalone;
        ath.isTablet = ath.isMobileSafari && _ua.indexOf("iPad") > -1 || ath.isMobileChrome && _ua.indexOf("Mobile") < 0;
        ath.isCompatible = ath.isMobileSafari && ath.OSVersion >= 6 || ath.isMobileChrome;
        var _defaultSession = {
            lastDisplayTime: 0,
            returningVisitor: false,
            displayCount: 0,
            optedout: false,
            added: false
        };
        ath.removeSession = function (appID) {
            try {
                if (!localStorage) {
                    throw new Error("localStorage is not defined")
                }
                localStorage.removeItem(appID || ath.defaults.appID)
            } catch (e) {
            }
        };
        ath.doLog = function (logStr) {
            if (this.options.logging) {
                console.log(logStr)
            }
        };
        ath.Class = function (options) {
            this.doLog = ath.doLog;
            this.options = _extend({}, ath.defaults);
            _extend(this.options, options);
            if (this.options && this.options.debug && typeof this.options.logging === "undefined") {
                this.options.logging = true
            }
            if (!_eventListener) {
                return
            }
            this.options.mandatory = this.options.mandatory && ("standalone" in window.navigator || this.options.debug);
            this.options.modal = this.options.modal || this.options.mandatory;
            if (this.options.mandatory) {
                this.options.startDelay = -.5
            }
            this.options.detectHomescreen = this.options.detectHomescreen === true ? "hash" : this.options.detectHomescreen;
            if (this.options.debug) {
                ath.isCompatible = true;
                ath.OS = typeof this.options.debug == "string" ? this.options.debug : ath.OS == "unsupported" ? "android" : ath.OS;
                ath.OSVersion = ath.OS == "ios" ? "8" : "4"
            }
            this.container = document.body;
            this.session = this.getItem(this.options.appID);
            this.session = this.session ? JSON.parse(this.session) : undefined;
            if (ath.hasToken && (!ath.isCompatible || !this.session)) {
                ath.hasToken = false;
                _removeToken()
            }
            if (!ath.isCompatible) {
                this.doLog("Add to homescreen: not displaying callout because device not supported");
                return
            }
            this.session = this.session || _defaultSession;
            try {
                if (!localStorage) {
                    throw new Error("localStorage is not defined")
                }
                localStorage.setItem(this.options.appID, JSON.stringify(this.session));
                ath.hasLocalStorage = true
            } catch (e) {
                ath.hasLocalStorage = false;
                if (this.options.onPrivate) {
                    this.options.onPrivate.call(this)
                }
            }
            var isValidLocation = !this.options.validLocation.length;
            for (var i = this.options.validLocation.length; i--;) {
                if (this.options.validLocation[i].test(document.location.href)) {
                    isValidLocation = true;
                    break
                }
            }
            if (this.getItem("addToHome")) {
                this.optOut()
            }
            if (this.session.optedout) {
                this.doLog("Add to homescreen: not displaying callout because user opted out");
                return
            }
            if (this.session.added) {
                this.doLog("Add to homescreen: not displaying callout because already added to the homescreen");
                return
            }
            if (!isValidLocation) {
                this.doLog("Add to homescreen: not displaying callout because not a valid location");
                return
            }
            if (ath.isStandalone) {
                if (!this.session.added) {
                    this.session.added = true;
                    this.updateSession();
                    if (this.options.onAdd && ath.hasLocalStorage) {
                        this.options.onAdd.call(this)
                    }
                }
                this.doLog("Add to homescreen: not displaying callout because in standalone mode");
                return
            }
            if (this.options.detectHomescreen) {
                if (ath.hasToken) {
                    _removeToken();
                    if (!this.session.added) {
                        this.session.added = true;
                        this.updateSession();
                        if (this.options.onAdd && ath.hasLocalStorage) {
                            this.options.onAdd.call(this)
                        }
                    }
                    this.doLog("Add to homescreen: not displaying callout because URL has token, so we are likely coming from homescreen");
                    return
                }
                if (this.options.detectHomescreen == "hash") {
                    history.replaceState("", window.document.title, document.location.href + "#ath")
                } else if (this.options.detectHomescreen == "smartURL") {
                    history.replaceState("", window.document.title, document.location.href.replace(/(\/)?$/, "/ath$1"))
                } else {
                    history.replaceState("", window.document.title, document.location.href + (document.location.search ? "&" : "?") + "ath=")
                }
            }
            if (!this.session.returningVisitor) {
                this.session.returningVisitor = true;
                this.updateSession();
                if (this.options.skipFirstVisit) {
                    this.doLog("Add to homescreen: not displaying callout because skipping first visit");
                    return
                }
            }
            if (!this.options.privateModeOverride && !ath.hasLocalStorage) {
                this.doLog("Add to homescreen: not displaying callout because browser is in private mode");
                return
            }
            this.ready = true;
            if (this.options.onInit) {
                this.options.onInit.call(this)
            }
            if (this.options.autostart) {
                this.doLog("Add to homescreen: autostart displaying callout");
                this.show()
            }
        };
        ath.Class.prototype = {
            events: {
                load: "_delayedShow",
                error: "_delayedShow",
                orientationchange: "resize",
                resize: "resize",
                scroll: "resize",
                click: "remove",
                touchmove: "_preventDefault",
                transitionend: "_removeElements",
                webkitTransitionEnd: "_removeElements",
                MSTransitionEnd: "_removeElements"
            }, handleEvent: function (e) {
                var type = this.events[e.type];
                if (type) {
                    this[type](e)
                }
            }, show: function (force) {
                if (this.options.autostart && !_DOMReady) {
                    setTimeout(this.show.bind(this), 50);
                    return
                }
                if (this.shown) {
                    this.doLog("Add to homescreen: not displaying callout because already shown on screen");
                    return
                }
                var now = Date.now();
                var lastDisplayTime = this.session.lastDisplayTime;
                if (force !== true) {
                    if (!this.ready) {
                        this.doLog("Add to homescreen: not displaying callout because not ready");
                        return
                    }
                    if (now - lastDisplayTime < this.options.displayPace * 6e4) {
                        this.doLog("Add to homescreen: not displaying callout because displayed recently");
                        return
                    }
                    if (this.options.maxDisplayCount && this.session.displayCount >= this.options.maxDisplayCount) {
                        this.doLog("Add to homescreen: not displaying callout because displayed too many times already");
                        return
                    }
                }
                this.shown = true;
                this.session.lastDisplayTime = now;
                this.session.displayCount++;
                this.updateSession();
                if (!this.applicationIcon) {
                    if (ath.OS == "ios") {
                        this.applicationIcon = document.querySelector('head link[rel^=apple-touch-icon][sizes="152x152"],head link[rel^=apple-touch-icon][sizes="144x144"],head link[rel^=apple-touch-icon][sizes="120x120"],head link[rel^=apple-touch-icon][sizes="114x114"],head link[rel^=apple-touch-icon]')
                    } else {
                        this.applicationIcon = document.querySelector('head link[rel^="shortcut icon"][sizes="196x196"],head link[rel^=apple-touch-icon]')
                    }
                }
                var message = "";
                if (typeof this.options.message == "object" && ath.language in this.options.message) {
                    message = this.options.message[ath.language][ath.OS]
                } else if (typeof this.options.message == "object" && ath.OS in this.options.message) {
                    message = this.options.message[ath.OS]
                } else if (this.options.message in ath.intl) {
                    message = ath.intl[this.options.message][ath.OS]
                } else if (this.options.message !== "") {
                    message = this.options.message
                } else if (ath.OS in ath.intl[ath.language]) {
                    message = ath.intl[ath.language][ath.OS]
                }
                message = "<p>" + message.replace(/%icon(?:\[([^\]]+)\])?/gi, function (matches, group1) {
                    return '<span class="ath-action-icon">' + (!!group1 ? group1 : "icon") + "</span>"
                }) + "</p>";
                this.viewport = document.createElement("div");
                this.viewport.className = "ath-viewport";
                if (this.options.modal) {
                    this.viewport.className += " ath-modal"
                }
                if (this.options.mandatory) {
                    this.viewport.className += " ath-mandatory"
                }
                this.viewport.style.position = "absolute";
                this.element = document.createElement("div");
                this.element.className = "ath-container ath-" + ath.OS + " ath-" + ath.OS + (parseInt(ath.OSVersion) || "") + " ath-" + (ath.isTablet ? "tablet" : "phone");
                this.element.style.cssText = "-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-duration:0s;-webkit-transition-timing-function:ease-out;transition-property:transform,opacity;transition-duration:0s;transition-timing-function:ease-out;";
                this.element.style.webkitTransform = "translate3d(0,-" + window.innerHeight + "px,0)";
                this.element.style.transform = "translate3d(0,-" + window.innerHeight + "px,0)";
                if (this.options.icon && this.applicationIcon) {
                    this.element.className += " ath-icon";
                    this.img = document.createElement("img");
                    this.img.className = "ath-application-icon";
                    this.img.addEventListener("load", this, false);
                    this.img.addEventListener("error", this, false);
                    this.img.src = this.applicationIcon.href;
                    this.element.appendChild(this.img)
                }
                this.element.innerHTML += message;
                this.viewport.style.left = "-99999em";
                this.viewport.appendChild(this.element);
                this.container.appendChild(this.viewport);
                if (this.img) {
                    this.doLog("Add to homescreen: not displaying callout because waiting for img to load")
                } else {
                    this._delayedShow()
                }
            }, _delayedShow: function (e) {
                setTimeout(this._show.bind(this), this.options.startDelay * 1e3 + 500)
            }, _show: function () {
                var that = this;
                this.updateViewport();
                window.addEventListener("resize", this, false);
                window.addEventListener("scroll", this, false);
                window.addEventListener("orientationchange", this, false);
                if (this.options.modal) {
                    document.addEventListener("touchmove", this, true)
                }
                if (!this.options.mandatory) {
                    setTimeout(function () {
                        that.element.addEventListener("click", that, true)
                    }, 1e3)
                }
                setTimeout(function () {
                    that.element.style.webkitTransitionDuration = "1.2s";
                    that.element.style.transitionDuration = "1.2s";
                    that.element.style.webkitTransform = "translate3d(0,0,0)";
                    that.element.style.transform = "translate3d(0,0,0)"
                }, 0);
                if (this.options.lifespan) {
                    this.removeTimer = setTimeout(this.remove.bind(this), this.options.lifespan * 1e3)
                }
                if (this.options.onShow) {
                    this.options.onShow.call(this)
                }
            }, remove: function () {
                clearTimeout(this.removeTimer);
                if (this.img) {
                    this.img.removeEventListener("load", this, false);
                    this.img.removeEventListener("error", this, false)
                }
                window.removeEventListener("resize", this, false);
                window.removeEventListener("scroll", this, false);
                window.removeEventListener("orientationchange", this, false);
                document.removeEventListener("touchmove", this, true);
                this.element.removeEventListener("click", this, true);
                this.element.addEventListener("transitionend", this, false);
                this.element.addEventListener("webkitTransitionEnd", this, false);
                this.element.addEventListener("MSTransitionEnd", this, false);
                this.element.style.webkitTransitionDuration = "0.3s";
                this.element.style.opacity = "0"
            }, _removeElements: function () {
                this.element.removeEventListener("transitionend", this, false);
                this.element.removeEventListener("webkitTransitionEnd", this, false);
                this.element.removeEventListener("MSTransitionEnd", this, false);
                this.container.removeChild(this.viewport);
                this.shown = false;
                if (this.options.onRemove) {
                    this.options.onRemove.call(this)
                }
            }, updateViewport: function () {
                if (!this.shown) {
                    return
                }
                this.viewport.style.width = window.innerWidth + "px";
                this.viewport.style.height = window.innerHeight + "px";
                this.viewport.style.left = window.scrollX + "px";
                this.viewport.style.top = window.scrollY + "px";
                var clientWidth = document.documentElement.clientWidth;
                this.orientation = clientWidth > document.documentElement.clientHeight ? "landscape" : "portrait";
                var screenWidth = ath.OS == "ios" ? this.orientation == "portrait" ? screen.width : screen.height : screen.width;
                this.scale = screen.width > clientWidth ? 1 : screenWidth / window.innerWidth;
                this.element.style.fontSize = this.options.fontSize / this.scale + "px"
            }, resize: function () {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(this.updateViewport.bind(this), 100)
            }, updateSession: function () {
                if (ath.hasLocalStorage === false) {
                    return
                }
                if (localStorage) {
                    localStorage.setItem(this.options.appID, JSON.stringify(this.session))
                }
            }, clearSession: function () {
                this.session = _defaultSession;
                this.updateSession()
            }, getItem: function (item) {
                try {
                    if (!localStorage) {
                        throw new Error("localStorage is not defined")
                    }
                    return localStorage.getItem(item)
                } catch (e) {
                    ath.hasLocalStorage = false
                }
            }, optOut: function () {
                this.session.optedout = true;
                this.updateSession()
            }, optIn: function () {
                this.session.optedout = false;
                this.updateSession()
            }, clearDisplayCount: function () {
                this.session.displayCount = 0;
                this.updateSession()
            }, _preventDefault: function (e) {
                e.preventDefault();
                e.stopPropagation()
            }
        };

        function _extend(target, obj) {
            for (var i in obj) {
                target[i] = obj[i]
            }
            return target
        }

        function _removeToken() {
            if (document.location.hash == "#ath") {
                history.replaceState("", window.document.title, document.location.href.split("#")[0])
            }
            if (_reSmartURL.test(document.location.href)) {
                history.replaceState("", window.document.title, document.location.href.replace(_reSmartURL, "$1"))
            }
            if (_reQueryString.test(document.location.search)) {
                history.replaceState("", window.document.title, document.location.href.replace(_reQueryString, "$2"))
            }
        }

        window.addToHomescreen = ath
    })(window, document);

    /* slick slider */
    !function (i) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
    }(function (i) {
        "use strict";
        var e = window.Slick || {};
        (e = function () {
            var e = 0;
            return function (t, o) {
                var s, n = this;
                n.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: i(t),
                    appendDots: i(t),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (e, t) {
                        return i('<button type="button" />').text(t + 1)
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: .35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3
                }, n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1
                }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
            }
        }()).prototype.activateADA = function () {
            this.$slideTrack.find(".slick-active").attr({"aria-hidden": "false"}).find("a, input, button, select").attr({tabindex: "0"})
        }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
            var s = this;
            if ("boolean" == typeof t) o = t, t = null; else if (t < 0 || t >= s.slideCount) return !1;
            s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
                i(t).attr("data-slick-index", e)
            }), s.$slidesCache = s.$slides, s.reinit()
        }, e.prototype.animateHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({height: e}, i.options.speed)
            }
        }, e.prototype.animateSlide = function (e, t) {
            var o = {}, s = this;
            s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({left: e}, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({top: e}, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({animStart: s.currentLeft}).animate({animStart: e}, {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i) {
                    i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
                },
                complete: function () {
                    t && t.call()
                }
            })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
                s.disableTransition(), t.call()
            }, s.options.speed))
        }, e.prototype.getNavTarget = function () {
            var e = this, t = e.options.asNavFor;
            return t && null !== t && (t = i(t).not(e.$slider)), t
        }, e.prototype.asNavFor = function (e) {
            var t = this.getNavTarget();
            null !== t && "object" == typeof t && t.each(function () {
                var t = i(this).slick("getSlick");
                t.unslicked || t.slideHandler(e, !0)
            })
        }, e.prototype.applyTransition = function (i) {
            var e = this, t = {};
            !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
        }, e.prototype.autoPlay = function () {
            var i = this;
            i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
        }, e.prototype.autoPlayClear = function () {
            var i = this;
            i.autoPlayTimer && clearInterval(i.autoPlayTimer)
        }, e.prototype.autoPlayIterator = function () {
            var i = this, e = i.currentSlide + i.options.slidesToScroll;
            i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e))
        }, e.prototype.buildArrows = function () {
            var e = this;
            !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                tabindex: "-1"
            }))
        }, e.prototype.buildDots = function () {
            var e, t, o = this;
            if (!0 === o.options.dots) {
                for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
                o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
            }
        }, e.prototype.buildOut = function () {
            var e = this;
            e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
                i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
            }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
        }, e.prototype.buildRows = function () {
            var i, e, t, o, s, n, r, l = this;
            if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
                for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                    var d = document.createElement("div");
                    for (e = 0; e < l.options.rows; e++) {
                        var a = document.createElement("div");
                        for (t = 0; t < l.options.slidesPerRow; t++) {
                            var c = i * r + (e * l.options.slidesPerRow + t);
                            n.get(c) && a.appendChild(n.get(c))
                        }
                        d.appendChild(a)
                    }
                    o.appendChild(d)
                }
                l.$slider.empty().append(o), l.$slider.children().children().children().css({
                    width: 100 / l.options.slidesPerRow + "%",
                    display: "inline-block"
                })
            }
        }, e.prototype.checkResponsive = function (e, t) {
            var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width();
            if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
                s = null;
                for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
            }
        }, e.prototype.changeSlide = function (e, t) {
            var o, s, n, r = this, l = i(e.currentTarget);
            switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
                case"previous":
                    s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                    break;
                case"next":
                    s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                    break;
                case"index":
                    var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                    r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                    break;
                default:
                    return
            }
        }, e.prototype.checkNavigable = function (i) {
            var e, t;
            if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1]; else for (var o in e) {
                if (i < e[o]) {
                    i = t;
                    break
                }
                t = e[o]
            }
            return i
        }, e.prototype.cleanUpEvents = function () {
            var e = this;
            e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
        }, e.prototype.cleanUpSlideEvents = function () {
            var e = this;
            e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
        }, e.prototype.cleanUpRows = function () {
            var i, e = this;
            e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i))
        }, e.prototype.clickHandler = function (i) {
            !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
        }, e.prototype.destroy = function (e) {
            var t = this;
            t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
                i(this).attr("style", i(this).data("originalStyling"))
            }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
        }, e.prototype.disableTransition = function (i) {
            var e = this, t = {};
            t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
        }, e.prototype.fadeSlide = function (i, e) {
            var t = this;
            !1 === t.cssTransitions ? (t.$slides.eq(i).css({zIndex: t.options.zIndex}), t.$slides.eq(i).animate({opacity: 1}, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
                opacity: 1,
                zIndex: t.options.zIndex
            }), e && setTimeout(function () {
                t.disableTransition(i), e.call()
            }, t.options.speed))
        }, e.prototype.fadeSlideOut = function (i) {
            var e = this;
            !1 === e.cssTransitions ? e.$slides.eq(i).animate({
                opacity: 0,
                zIndex: e.options.zIndex - 2
            }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
                opacity: 0,
                zIndex: e.options.zIndex - 2
            }))
        }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
            var e = this;
            null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
        }, e.prototype.focusHandler = function () {
            var e = this;
            e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
                t.stopImmediatePropagation();
                var o = i(this);
                setTimeout(function () {
                    e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay())
                }, 0)
            })
        }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
            return this.currentSlide
        }, e.prototype.getDotCount = function () {
            var i = this, e = 0, t = 0, o = 0;
            if (!0 === i.options.infinite) if (i.slideCount <= i.options.slidesToShow) ++o; else for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else if (!0 === i.options.centerMode) o = i.slideCount; else if (i.options.asNavFor) for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
            return o - 1
        }, e.prototype.getLeft = function (i) {
            var e, t, o, s, n = this, r = 0;
            return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
        }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
            return this.options[i]
        }, e.prototype.getNavigableIndexes = function () {
            var i, e = this, t = 0, o = 0, s = [];
            for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            return s
        }, e.prototype.getSlick = function () {
            return this
        }, e.prototype.getSlideCount = function () {
            var e, t, o = this;
            return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
                if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1
            }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
        }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
            this.changeSlide({data: {message: "index", index: parseInt(i)}}, e)
        }, e.prototype.init = function (e) {
            var t = this;
            i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
        }, e.prototype.initADA = function () {
            var e = this, t = Math.ceil(e.slideCount / e.options.slidesToShow),
                o = e.getNavigableIndexes().filter(function (i) {
                    return i >= 0 && i < e.slideCount
                });
            e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
                "aria-hidden": "true",
                tabindex: "-1"
            }).find("a, input, button, select").attr({tabindex: "-1"}), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
                var s = o.indexOf(t);
                i(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + e.instanceUid + t,
                    tabindex: -1
                }), -1 !== s && i(this).attr({"aria-describedby": "slick-slide-control" + e.instanceUid + s})
            }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
                var n = o[s];
                i(this).attr({role: "presentation"}), i(this).find("button").first().attr({
                    role: "tab",
                    id: "slick-slide-control" + e.instanceUid + s,
                    "aria-controls": "slick-slide" + e.instanceUid + n,
                    "aria-label": s + 1 + " of " + t,
                    "aria-selected": null,
                    tabindex: "-1"
                })
            }).eq(e.currentSlide).find("button").attr({"aria-selected": "true", tabindex: "0"}).end());
            for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
            e.activateADA()
        }, e.prototype.initArrowEvents = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {message: "previous"}, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {message: "next"}, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
        }, e.prototype.initDotEvents = function () {
            var e = this;
            !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {message: "index"}, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
        }, e.prototype.initSlideEvents = function () {
            var e = this;
            e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
        }, e.prototype.initializeEvents = function () {
            var e = this;
            e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {action: "start"}, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {action: "move"}, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {action: "end"}, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {action: "end"}, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
        }, e.prototype.initUI = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
        }, e.prototype.keyHandler = function (i) {
            var e = this;
            i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({data: {message: !0 === e.options.rtl ? "next" : "previous"}}) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({data: {message: !0 === e.options.rtl ? "previous" : "next"}}))
        }, e.prototype.lazyLoad = function () {
            function e(e) {
                i("img[data-lazy]", e).each(function () {
                    var e = i(this), t = i(this).attr("data-lazy"), o = i(this).attr("data-srcset"),
                        s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
                        r = document.createElement("img");
                    r.onload = function () {
                        e.animate({opacity: 0}, 100, function () {
                            o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({opacity: 1}, 200, function () {
                                e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                            }), n.$slider.trigger("lazyLoaded", [n, e, t])
                        })
                    }, r.onerror = function () {
                        e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t])
                    }, r.src = t
                })
            }

            var t, o, s, n = this;
            if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
            e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
        }, e.prototype.loadSlider = function () {
            var i = this;
            i.setPosition(), i.$slideTrack.css({opacity: 1}), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
        }, e.prototype.next = e.prototype.slickNext = function () {
            this.changeSlide({data: {message: "next"}})
        }, e.prototype.orientationChange = function () {
            var i = this;
            i.checkResponsive(), i.setPosition()
        }, e.prototype.pause = e.prototype.slickPause = function () {
            var i = this;
            i.autoPlayClear(), i.paused = !0
        }, e.prototype.play = e.prototype.slickPlay = function () {
            var i = this;
            i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
        }, e.prototype.postSlide = function (e) {
            var t = this;
            t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
        }, e.prototype.prev = e.prototype.slickPrev = function () {
            this.changeSlide({data: {message: "previous"}})
        }, e.prototype.preventDefault = function (i) {
            i.preventDefault()
        }, e.prototype.progressiveLazyLoad = function (e) {
            e = e || 1;
            var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider);
            d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
                s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
            }, r.onerror = function () {
                e < 3 ? setTimeout(function () {
                    l.progressiveLazyLoad(e + 1)
                }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
            }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
        }, e.prototype.refresh = function (e) {
            var t, o, s = this;
            o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {currentSlide: t}), s.init(), e || s.changeSlide({
                data: {
                    message: "index",
                    index: t
                }
            }, !1)
        }, e.prototype.registerBreakpoints = function () {
            var e, t, o, s = this, n = s.options.responsive || null;
            if ("array" === i.type(n) && n.length) {
                s.respondTo = s.options.respondTo || "window";
                for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                    s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
                }
                s.breakpoints.sort(function (i, e) {
                    return s.options.mobileFirst ? i - e : e - i
                })
            }
        }, e.prototype.reinit = function () {
            var e = this;
            e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
        }, e.prototype.resize = function () {
            var e = this;
            i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
                e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
            }, 50))
        }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
            var o = this;
            if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
            o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit()
        }, e.prototype.setCSS = function (i) {
            var e, t, o = this, s = {};
            !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
        }, e.prototype.setDimensions = function () {
            var i = this;
            !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({padding: "0px " + i.options.centerPadding}) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({padding: i.options.centerPadding + " 0px"})), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
            var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
            !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
        }, e.prototype.setFade = function () {
            var e, t = this;
            t.$slides.each(function (o, s) {
                e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
                    position: "relative",
                    right: e,
                    top: 0,
                    zIndex: t.options.zIndex - 2,
                    opacity: 0
                }) : i(s).css({position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0})
            }), t.$slides.eq(t.currentSlide).css({zIndex: t.options.zIndex - 1, opacity: 1})
        }, e.prototype.setHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e)
            }
        }, e.prototype.setOption = e.prototype.slickSetOption = function () {
            var e, t, o, s, n, r = this, l = !1;
            if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s; else if ("multiple" === n) i.each(o, function (i, e) {
                r.options[i] = e
            }); else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]]; else {
                for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                r.options.responsive.push(s[t])
            }
            l && (r.unload(), r.reinit())
        }, e.prototype.setPosition = function () {
            var i = this;
            i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
        }, e.prototype.setProps = function () {
            var i = this, e = document.body.style;
            i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
        }, e.prototype.setSlideClasses = function (i) {
            var e, t, o, s, n = this;
            if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
                var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
            } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
            "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
        }, e.prototype.setupInfinite = function () {
            var e, t, o, s = this;
            if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
                for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
                for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
                s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                    i(this).attr("id", "")
                })
            }
        }, e.prototype.interrupt = function (i) {
            var e = this;
            i || e.autoPlay(), e.interrupted = i
        }, e.prototype.selectHandler = function (e) {
            var t = this, o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
            s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
        }, e.prototype.slideHandler = function (i, e, t) {
            var o, s, n, r, l, d = null, a = this;
            if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
                a.postSlide(o)
            }) : a.postSlide(o)); else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
                a.postSlide(o)
            }) : a.postSlide(o)); else {
                if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
                    a.postSlide(s)
                })) : a.postSlide(s), void a.animateHeight();
                !0 !== t ? a.animateSlide(d, function () {
                    a.postSlide(s)
                }) : a.postSlide(s)
            }
        }, e.prototype.startLoad = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
        }, e.prototype.swipeDirection = function () {
            var i, e, t, o, s = this;
            return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
        }, e.prototype.swipeEnd = function (i) {
            var e, t, o = this;
            if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
            if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
            if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
                switch (t = o.swipeDirection()) {
                    case"left":
                    case"down":
                        e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                        break;
                    case"right":
                    case"up":
                        e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
                }
                "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
            } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
        }, e.prototype.swipeHandler = function (i) {
            var e = this;
            if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
                case"start":
                    e.swipeStart(i);
                    break;
                case"move":
                    e.swipeMove(i);
                    break;
                case"end":
                    e.swipeEnd(i)
            }
        }, e.prototype.swipeMove = function (i) {
            var e, t, o, s, n, r, l = this;
            return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
        }, e.prototype.swipeStart = function (i) {
            var e, t = this;
            if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
            void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0
        }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
            var i = this;
            null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
        }, e.prototype.unload = function () {
            var e = this;
            i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
        }, e.prototype.unslick = function (i) {
            var e = this;
            e.$slider.trigger("unslick", [e, i]), e.destroy()
        }, e.prototype.updateArrows = function () {
            var i = this;
            Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
        }, e.prototype.updateDots = function () {
            var i = this;
            null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
        }, e.prototype.visibility = function () {
            var i = this;
            i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
        }, i.fn.slick = function () {
            var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length;
            for (i = 0; i < r; i++) if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
            return o
        }
    });

    /*! Select2 4.0.3 | https://github.com/select2/select2/blob/master/LICENSE.md */
    !function (a) {
        "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : jQuery)
    }(function (a) {
        var b = function () {
            if (a && a.fn && a.fn.select2 && a.fn.select2.amd) var b = a.fn.select2.amd;
            var b;
            return function () {
                if (!b || !b.requirejs) {
                    b ? c = b : b = {};
                    var a, c, d;
                    !function (b) {
                        function e(a, b) {
                            return u.call(a, b)
                        }

                        function f(a, b) {
                            var c, d, e, f, g, h, i, j, k, l, m, n = b && b.split("/"), o = s.map,
                                p = o && o["*"] || {};
                            if (a && "." === a.charAt(0)) if (b) {
                                for (a = a.split("/"), g = a.length - 1, s.nodeIdCompat && w.test(a[g]) && (a[g] = a[g].replace(w, "")), a = n.slice(0, n.length - 1).concat(a), k = 0; k < a.length; k += 1) if (m = a[k], "." === m) a.splice(k, 1), k -= 1; else if (".." === m) {
                                    if (1 === k && (".." === a[2] || ".." === a[0])) break;
                                    k > 0 && (a.splice(k - 1, 2), k -= 2)
                                }
                                a = a.join("/")
                            } else 0 === a.indexOf("./") && (a = a.substring(2));
                            if ((n || p) && o) {
                                for (c = a.split("/"), k = c.length; k > 0; k -= 1) {
                                    if (d = c.slice(0, k).join("/"), n) for (l = n.length; l > 0; l -= 1) if (e = o[n.slice(0, l).join("/")], e && (e = e[d])) {
                                        f = e, h = k;
                                        break
                                    }
                                    if (f) break;
                                    !i && p && p[d] && (i = p[d], j = k)
                                }
                                !f && i && (f = i, h = j), f && (c.splice(0, h, f), a = c.join("/"))
                            }
                            return a
                        }

                        function g(a, c) {
                            return function () {
                                var d = v.call(arguments, 0);
                                return "string" != typeof d[0] && 1 === d.length && d.push(null), n.apply(b, d.concat([a, c]))
                            }
                        }

                        function h(a) {
                            return function (b) {
                                return f(b, a)
                            }
                        }

                        function i(a) {
                            return function (b) {
                                q[a] = b
                            }
                        }

                        function j(a) {
                            if (e(r, a)) {
                                var c = r[a];
                                delete r[a], t[a] = !0, m.apply(b, c)
                            }
                            if (!e(q, a) && !e(t, a)) throw new Error("No " + a);
                            return q[a]
                        }

                        function k(a) {
                            var b, c = a ? a.indexOf("!") : -1;
                            return c > -1 && (b = a.substring(0, c), a = a.substring(c + 1, a.length)), [b, a]
                        }

                        function l(a) {
                            return function () {
                                return s && s.config && s.config[a] || {}
                            }
                        }

                        var m, n, o, p, q = {}, r = {}, s = {}, t = {}, u = Object.prototype.hasOwnProperty,
                            v = [].slice, w = /\.js$/;
                        o = function (a, b) {
                            var c, d = k(a), e = d[0];
                            return a = d[1], e && (e = f(e, b), c = j(e)), e ? a = c && c.normalize ? c.normalize(a, h(b)) : f(a, b) : (a = f(a, b), d = k(a), e = d[0], a = d[1], e && (c = j(e))), {
                                f: e ? e + "!" + a : a,
                                n: a,
                                pr: e,
                                p: c
                            }
                        }, p = {
                            require: function (a) {
                                return g(a)
                            }, exports: function (a) {
                                var b = q[a];
                                return "undefined" != typeof b ? b : q[a] = {}
                            }, module: function (a) {
                                return {id: a, uri: "", exports: q[a], config: l(a)}
                            }
                        }, m = function (a, c, d, f) {
                            var h, k, l, m, n, s, u = [], v = typeof d;
                            if (f = f || a, "undefined" === v || "function" === v) {
                                for (c = !c.length && d.length ? ["require", "exports", "module"] : c, n = 0; n < c.length; n += 1) if (m = o(c[n], f), k = m.f, "require" === k) u[n] = p.require(a); else if ("exports" === k) u[n] = p.exports(a), s = !0; else if ("module" === k) h = u[n] = p.module(a); else if (e(q, k) || e(r, k) || e(t, k)) u[n] = j(k); else {
                                    if (!m.p) throw new Error(a + " missing " + k);
                                    m.p.load(m.n, g(f, !0), i(k), {}), u[n] = q[k]
                                }
                                l = d ? d.apply(q[a], u) : void 0, a && (h && h.exports !== b && h.exports !== q[a] ? q[a] = h.exports : l === b && s || (q[a] = l))
                            } else a && (q[a] = d)
                        }, a = c = n = function (a, c, d, e, f) {
                            if ("string" == typeof a) return p[a] ? p[a](c) : j(o(a, c).f);
                            if (!a.splice) {
                                if (s = a, s.deps && n(s.deps, s.callback), !c) return;
                                c.splice ? (a = c, c = d, d = null) : a = b
                            }
                            return c = c || function () {
                            }, "function" == typeof d && (d = e, e = f), e ? m(b, a, c, d) : setTimeout(function () {
                                m(b, a, c, d)
                            }, 4), n
                        }, n.config = function (a) {
                            return n(a)
                        }, a._defined = q, d = function (a, b, c) {
                            if ("string" != typeof a) throw new Error("See almond README: incorrect module build, no module name");
                            b.splice || (c = b, b = []), e(q, a) || e(r, a) || (r[a] = [a, b, c])
                        }, d.amd = {jQuery: !0}
                    }(), b.requirejs = a, b.require = c, b.define = d
                }
            }(), b.define("almond", function () {
            }), b.define("jquery", [], function () {
                var b = a || $;
                return null == b && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), b
            }), b.define("select2/utils", ["jquery"], function (a) {
                function b(a) {
                    var b = a.prototype, c = [];
                    for (var d in b) {
                        var e = b[d];
                        "function" == typeof e && "constructor" !== d && c.push(d)
                    }
                    return c
                }

                var c = {};
                c.Extend = function (a, b) {
                    function c() {
                        this.constructor = a
                    }

                    var d = {}.hasOwnProperty;
                    for (var e in b) d.call(b, e) && (a[e] = b[e]);
                    return c.prototype = b.prototype, a.prototype = new c, a.__super__ = b.prototype, a
                }, c.Decorate = function (a, c) {
                    function d() {
                        var b = Array.prototype.unshift, d = c.prototype.constructor.length,
                            e = a.prototype.constructor;
                        d > 0 && (b.call(arguments, a.prototype.constructor), e = c.prototype.constructor), e.apply(this, arguments)
                    }

                    function e() {
                        this.constructor = d
                    }

                    var f = b(c), g = b(a);
                    c.displayName = a.displayName, d.prototype = new e;
                    for (var h = 0; h < g.length; h++) {
                        var i = g[h];
                        d.prototype[i] = a.prototype[i]
                    }
                    for (var j = (function (a) {
                        var b = function () {
                        };
                        a in d.prototype && (b = d.prototype[a]);
                        var e = c.prototype[a];
                        return function () {
                            var a = Array.prototype.unshift;
                            return a.call(arguments, b), e.apply(this, arguments)
                        }
                    }), k = 0; k < f.length; k++) {
                        var l = f[k];
                        d.prototype[l] = j(l)
                    }
                    return d
                };
                var d = function () {
                    this.listeners = {}
                };
                return d.prototype.on = function (a, b) {
                    this.listeners = this.listeners || {}, a in this.listeners ? this.listeners[a].push(b) : this.listeners[a] = [b]
                }, d.prototype.trigger = function (a) {
                    var b = Array.prototype.slice, c = b.call(arguments, 1);
                    this.listeners = this.listeners || {}, null == c && (c = []), 0 === c.length && c.push({}), c[0]._type = a, a in this.listeners && this.invoke(this.listeners[a], b.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
                }, d.prototype.invoke = function (a, b) {
                    for (var c = 0, d = a.length; d > c; c++) a[c].apply(this, b)
                }, c.Observable = d, c.generateChars = function (a) {
                    for (var b = "", c = 0; a > c; c++) {
                        var d = Math.floor(36 * Math.random());
                        b += d.toString(36)
                    }
                    return b
                }, c.bind = function (a, b) {
                    return function () {
                        a.apply(b, arguments)
                    }
                }, c._convertData = function (a) {
                    for (var b in a) {
                        var c = b.split("-"), d = a;
                        if (1 !== c.length) {
                            for (var e = 0; e < c.length; e++) {
                                var f = c[e];
                                f = f.substring(0, 1).toLowerCase() + f.substring(1), f in d || (d[f] = {}), e == c.length - 1 && (d[f] = a[b]), d = d[f]
                            }
                            delete a[b]
                        }
                    }
                    return a
                }, c.hasScroll = function (b, c) {
                    var d = a(c), e = c.style.overflowX, f = c.style.overflowY;
                    return e !== f || "hidden" !== f && "visible" !== f ? "scroll" === e || "scroll" === f ? !0 : d.innerHeight() < c.scrollHeight || d.innerWidth() < c.scrollWidth : !1
                }, c.escapeMarkup = function (a) {
                    var b = {
                        "\\": "&#92;",
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#47;"
                    };
                    return "string" != typeof a ? a : String(a).replace(/[&<>"'\/\\]/g, function (a) {
                        return b[a]
                    })
                }, c.appendMany = function (b, c) {
                    if ("1.7" === a.fn.jquery.substr(0, 3)) {
                        var d = a();
                        a.map(c, function (a) {
                            d = d.add(a)
                        }), c = d
                    }
                    b.append(c)
                }, c
            }), b.define("select2/results", ["jquery", "./utils"], function (a, b) {
                function c(a, b, d) {
                    this.$element = a, this.data = d, this.options = b, c.__super__.constructor.call(this)
                }

                return b.Extend(c, b.Observable), c.prototype.render = function () {
                    var b = a('<ul class="select2-results__options" role="tree"></ul>');
                    return this.options.get("multiple") && b.attr("aria-multiselectable", "true"), this.$results = b, b
                }, c.prototype.clear = function () {
                    this.$results.empty()
                }, c.prototype.displayMessage = function (b) {
                    var c = this.options.get("escapeMarkup");
                    this.clear(), this.hideLoading();
                    var d = a('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),
                        e = this.options.get("translations").get(b.message);
                    d.append(c(e(b.args))), d[0].className += " select2-results__message", this.$results.append(d)
                }, c.prototype.hideMessages = function () {
                    this.$results.find(".select2-results__message").remove()
                }, c.prototype.append = function (a) {
                    this.hideLoading();
                    var b = [];
                    if (null == a.results || 0 === a.results.length) return void (0 === this.$results.children().length && this.trigger("results:message", {message: "noResults"}));
                    a.results = this.sort(a.results);
                    for (var c = 0; c < a.results.length; c++) {
                        var d = a.results[c], e = this.option(d);
                        b.push(e)
                    }
                    this.$results.append(b)
                }, c.prototype.position = function (a, b) {
                    var c = b.find(".select2-results");
                    c.append(a)
                }, c.prototype.sort = function (a) {
                    var b = this.options.get("sorter");
                    return b(a)
                }, c.prototype.highlightFirstItem = function () {
                    var a = this.$results.find(".select2-results__option[aria-selected]"),
                        b = a.filter("[aria-selected=true]");
                    b.length > 0 ? b.first().trigger("mouseenter") : a.first().trigger("mouseenter"), this.ensureHighlightVisible()
                }, c.prototype.setClasses = function () {
                    var b = this;
                    this.data.current(function (c) {
                        var d = a.map(c, function (a) {
                            return a.id.toString()
                        }), e = b.$results.find(".select2-results__option[aria-selected]");
                        e.each(function () {
                            var b = a(this), c = a.data(this, "data"), e = "" + c.id;
                            null != c.element && c.element.selected || null == c.element && a.inArray(e, d) > -1 ? b.attr("aria-selected", "true") : b.attr("aria-selected", "false")
                        })
                    })
                }, c.prototype.showLoading = function (a) {
                    this.hideLoading();
                    var b = this.options.get("translations").get("searching"),
                        c = {disabled: !0, loading: !0, text: b(a)}, d = this.option(c);
                    d.className += " loading-results", this.$results.prepend(d)
                }, c.prototype.hideLoading = function () {
                    this.$results.find(".loading-results").remove()
                }, c.prototype.option = function (b) {
                    var c = document.createElement("li");
                    c.className = "select2-results__option";
                    var d = {role: "treeitem", "aria-selected": "false"};
                    b.disabled && (delete d["aria-selected"], d["aria-disabled"] = "true"), null == b.id && delete d["aria-selected"], null != b._resultId && (c.id = b._resultId), b.title && (c.title = b.title), b.children && (d.role = "group", d["aria-label"] = b.text, delete d["aria-selected"]);
                    for (var e in d) {
                        var f = d[e];
                        c.setAttribute(e, f)
                    }
                    if (b.children) {
                        var g = a(c), h = document.createElement("strong");
                        h.className = "select2-results__group";
                        a(h);
                        this.template(b, h);
                        for (var i = [], j = 0; j < b.children.length; j++) {
                            var k = b.children[j], l = this.option(k);
                            i.push(l)
                        }
                        var m = a("<ul></ul>", {"class": "select2-results__options select2-results__options--nested"});
                        m.append(i), g.append(h), g.append(m)
                    } else this.template(b, c);
                    return a.data(c, "data", b), c
                }, c.prototype.bind = function (b, c) {
                    var d = this, e = b.id + "-results";
                    this.$results.attr("id", e), b.on("results:all", function (a) {
                        d.clear(), d.append(a.data), b.isOpen() && (d.setClasses(), d.highlightFirstItem())
                    }), b.on("results:append", function (a) {
                        d.append(a.data), b.isOpen() && d.setClasses()
                    }), b.on("query", function (a) {
                        d.hideMessages(), d.showLoading(a)
                    }), b.on("select", function () {
                        b.isOpen() && (d.setClasses(), d.highlightFirstItem())
                    }), b.on("unselect", function () {
                        b.isOpen() && (d.setClasses(), d.highlightFirstItem())
                    }), b.on("open", function () {
                        d.$results.attr("aria-expanded", "true"), d.$results.attr("aria-hidden", "false"), d.setClasses(), d.ensureHighlightVisible()
                    }), b.on("close", function () {
                        d.$results.attr("aria-expanded", "false"), d.$results.attr("aria-hidden", "true"), d.$results.removeAttr("aria-activedescendant")
                    }), b.on("results:toggle", function () {
                        var a = d.getHighlightedResults();
                        0 !== a.length && a.trigger("mouseup")
                    }), b.on("results:select", function () {
                        var a = d.getHighlightedResults();
                        if (0 !== a.length) {
                            var b = a.data("data");
                            "true" == a.attr("aria-selected") ? d.trigger("close", {}) : d.trigger("select", {data: b})
                        }
                    }), b.on("results:previous", function () {
                        var a = d.getHighlightedResults(), b = d.$results.find("[aria-selected]"), c = b.index(a);
                        if (0 !== c) {
                            var e = c - 1;
                            0 === a.length && (e = 0);
                            var f = b.eq(e);
                            f.trigger("mouseenter");
                            var g = d.$results.offset().top, h = f.offset().top, i = d.$results.scrollTop() + (h - g);
                            0 === e ? d.$results.scrollTop(0) : 0 > h - g && d.$results.scrollTop(i)
                        }
                    }), b.on("results:next", function () {
                        var a = d.getHighlightedResults(), b = d.$results.find("[aria-selected]"), c = b.index(a),
                            e = c + 1;
                        if (!(e >= b.length)) {
                            var f = b.eq(e);
                            f.trigger("mouseenter");
                            var g = d.$results.offset().top + d.$results.outerHeight(!1),
                                h = f.offset().top + f.outerHeight(!1), i = d.$results.scrollTop() + h - g;
                            0 === e ? d.$results.scrollTop(0) : h > g && d.$results.scrollTop(i)
                        }
                    }), b.on("results:focus", function (a) {
                        a.element.addClass("select2-results__option--highlighted")
                    }), b.on("results:message", function (a) {
                        d.displayMessage(a)
                    }), a.fn.mousewheel && this.$results.on("mousewheel", function (a) {
                        var b = d.$results.scrollTop(), c = d.$results.get(0).scrollHeight - b + a.deltaY,
                            e = a.deltaY > 0 && b - a.deltaY <= 0, f = a.deltaY < 0 && c <= d.$results.height();
                        e ? (d.$results.scrollTop(0), a.preventDefault(), a.stopPropagation()) : f && (d.$results.scrollTop(d.$results.get(0).scrollHeight - d.$results.height()), a.preventDefault(), a.stopPropagation())
                    }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (b) {
                        var c = a(this), e = c.data("data");
                        return "true" === c.attr("aria-selected") ? void (d.options.get("multiple") ? d.trigger("unselect", {
                            originalEvent: b,
                            data: e
                        }) : d.trigger("close", {})) : void d.trigger("select", {originalEvent: b, data: e})
                    }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (b) {
                        var c = a(this).data("data");
                        d.getHighlightedResults().removeClass("select2-results__option--highlighted"), d.trigger("results:focus", {
                            data: c,
                            element: a(this)
                        })
                    })
                }, c.prototype.getHighlightedResults = function () {
                    var a = this.$results.find(".select2-results__option--highlighted");
                    return a
                }, c.prototype.destroy = function () {
                    this.$results.remove()
                }, c.prototype.ensureHighlightVisible = function () {
                    var a = this.getHighlightedResults();
                    if (0 !== a.length) {
                        var b = this.$results.find("[aria-selected]"), c = b.index(a), d = this.$results.offset().top,
                            e = a.offset().top, f = this.$results.scrollTop() + (e - d), g = e - d;
                        f -= 2 * a.outerHeight(!1), 2 >= c ? this.$results.scrollTop(0) : (g > this.$results.outerHeight() || 0 > g) && this.$results.scrollTop(f)
                    }
                }, c.prototype.template = function (b, c) {
                    var d = this.options.get("templateResult"), e = this.options.get("escapeMarkup"), f = d(b, c);
                    null == f ? c.style.display = "none" : "string" == typeof f ? c.innerHTML = e(f) : a(c).append(f)
                }, c
            }), b.define("select2/keys", [], function () {
                var a = {
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    SHIFT: 16,
                    CTRL: 17,
                    ALT: 18,
                    ESC: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT: 37,
                    UP: 38,
                    RIGHT: 39,
                    DOWN: 40,
                    DELETE: 46
                };
                return a
            }), b.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (a, b, c) {
                function d(a, b) {
                    this.$element = a, this.options = b, d.__super__.constructor.call(this)
                }

                return b.Extend(d, b.Observable), d.prototype.render = function () {
                    var b = a('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                    return this._tabindex = 0, null != this.$element.data("old-tabindex") ? this._tabindex = this.$element.data("old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), b.attr("title", this.$element.attr("title")), b.attr("tabindex", this._tabindex), this.$selection = b, b
                }, d.prototype.bind = function (a, b) {
                    var d = this, e = (a.id + "-container", a.id + "-results");
                    this.container = a, this.$selection.on("focus", function (a) {
                        d.trigger("focus", a)
                    }), this.$selection.on("blur", function (a) {
                        d._handleBlur(a)
                    }), this.$selection.on("keydown", function (a) {
                        d.trigger("keypress", a), a.which === c.SPACE && a.preventDefault()
                    }), a.on("results:focus", function (a) {
                        d.$selection.attr("aria-activedescendant", a.data._resultId)
                    }), a.on("selection:update", function (a) {
                        d.update(a.data)
                    }), a.on("open", function () {
                        d.$selection.attr("aria-expanded", "true"), d.$selection.attr("aria-owns", e), d._attachCloseHandler(a)
                    }), a.on("close", function () {
                        d.$selection.attr("aria-expanded", "false"), d.$selection.removeAttr("aria-activedescendant"), d.$selection.removeAttr("aria-owns"), d.$selection.focus(), d._detachCloseHandler(a)
                    }), a.on("enable", function () {
                        d.$selection.attr("tabindex", d._tabindex)
                    }), a.on("disable", function () {
                        d.$selection.attr("tabindex", "-1")
                    })
                }, d.prototype._handleBlur = function (b) {
                    var c = this;
                    window.setTimeout(function () {
                        document.activeElement == c.$selection[0] || a.contains(c.$selection[0], document.activeElement) || c.trigger("blur", b)
                    }, 1)
                }, d.prototype._attachCloseHandler = function (b) {
                    a(document.body).on("mousedown.select2." + b.id, function (b) {
                        var c = a(b.target), d = c.closest(".select2"), e = a(".select2.select2-container--open");
                        e.each(function () {
                            var b = a(this);
                            if (this != d[0]) {
                                var c = b.data("element");
                                c.select2("close")
                            }
                        })
                    })
                }, d.prototype._detachCloseHandler = function (b) {
                    a(document.body).off("mousedown.select2." + b.id)
                }, d.prototype.position = function (a, b) {
                    var c = b.find(".selection");
                    c.append(a)
                }, d.prototype.destroy = function () {
                    this._detachCloseHandler(this.container)
                }, d.prototype.update = function (a) {
                    throw new Error("The `update` method must be defined in child classes.")
                }, d
            }), b.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (a, b, c, d) {
                function e() {
                    e.__super__.constructor.apply(this, arguments)
                }

                return c.Extend(e, b), e.prototype.render = function () {
                    var a = e.__super__.render.call(this);
                    return a.addClass("select2-selection--single"), a.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), a
                }, e.prototype.bind = function (a, b) {
                    var c = this;
                    e.__super__.bind.apply(this, arguments);
                    var d = a.id + "-container";
                    this.$selection.find(".select2-selection__rendered").attr("id", d), this.$selection.attr("aria-labelledby", d), this.$selection.on("mousedown", function (a) {
                        1 === a.which && c.trigger("toggle", {originalEvent: a})
                    }), this.$selection.on("focus", function (a) {
                    }), this.$selection.on("blur", function (a) {
                    }), a.on("focus", function (b) {
                        a.isOpen() || c.$selection.focus()
                    }), a.on("selection:update", function (a) {
                        c.update(a.data)
                    })
                }, e.prototype.clear = function () {
                    this.$selection.find(".select2-selection__rendered").empty()
                }, e.prototype.display = function (a, b) {
                    var c = this.options.get("templateSelection"), d = this.options.get("escapeMarkup");
                    return d(c(a, b))
                }, e.prototype.selectionContainer = function () {
                    return a("<span></span>")
                }, e.prototype.update = function (a) {
                    if (0 === a.length) return void this.clear();
                    var b = a[0], c = this.$selection.find(".select2-selection__rendered"), d = this.display(b, c);
                    c.empty().append(d), c.prop("title", b.title || b.text)
                }, e
            }), b.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (a, b, c) {
                function d(a, b) {
                    d.__super__.constructor.apply(this, arguments)
                }

                return c.Extend(d, b), d.prototype.render = function () {
                    var a = d.__super__.render.call(this);
                    return a.addClass("select2-selection--multiple"), a.html('<ul class="select2-selection__rendered"></ul>'), a
                }, d.prototype.bind = function (b, c) {
                    var e = this;
                    d.__super__.bind.apply(this, arguments), this.$selection.on("click", function (a) {
                        e.trigger("toggle", {originalEvent: a})
                    }), this.$selection.on("click", ".select2-selection__choice__remove", function (b) {
                        if (!e.options.get("disabled")) {
                            var c = a(this), d = c.parent(), f = d.data("data");
                            e.trigger("unselect", {originalEvent: b, data: f})
                        }
                    })
                }, d.prototype.clear = function () {
                    this.$selection.find(".select2-selection__rendered").empty()
                }, d.prototype.display = function (a, b) {
                    var c = this.options.get("templateSelection"), d = this.options.get("escapeMarkup");
                    return d(c(a, b))
                }, d.prototype.selectionContainer = function () {
                    var b = a('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
                    return b
                }, d.prototype.update = function (a) {
                    if (this.clear(), 0 !== a.length) {
                        for (var b = [], d = 0; d < a.length; d++) {
                            var e = a[d], f = this.selectionContainer(), g = this.display(e, f);
                            f.append(g), f.prop("title", e.title || e.text), f.data("data", e), b.push(f)
                        }
                        var h = this.$selection.find(".select2-selection__rendered");
                        c.appendMany(h, b)
                    }
                }, d
            }), b.define("select2/selection/placeholder", ["../utils"], function (a) {
                function b(a, b, c) {
                    this.placeholder = this.normalizePlaceholder(c.get("placeholder")), a.call(this, b, c)
                }

                return b.prototype.normalizePlaceholder = function (a, b) {
                    return "string" == typeof b && (b = {id: "", text: b}), b
                }, b.prototype.createPlaceholder = function (a, b) {
                    var c = this.selectionContainer();
                    return c.html(this.display(b)), c.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), c
                }, b.prototype.update = function (a, b) {
                    var c = 1 == b.length && b[0].id != this.placeholder.id, d = b.length > 1;
                    if (d || c) return a.call(this, b);
                    this.clear();
                    var e = this.createPlaceholder(this.placeholder);
                    this.$selection.find(".select2-selection__rendered").append(e)
                }, b
            }), b.define("select2/selection/allowClear", ["jquery", "../keys"], function (a, b) {
                function c() {
                }

                return c.prototype.bind = function (a, b, c) {
                    var d = this;
                    a.call(this, b, c), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function (a) {
                        d._handleClear(a)
                    }), b.on("keypress", function (a) {
                        d._handleKeyboardClear(a, b)
                    })
                }, c.prototype._handleClear = function (a, b) {
                    if (!this.options.get("disabled")) {
                        var c = this.$selection.find(".select2-selection__clear");
                        if (0 !== c.length) {
                            b.stopPropagation();
                            for (var d = c.data("data"), e = 0; e < d.length; e++) {
                                var f = {data: d[e]};
                                if (this.trigger("unselect", f), f.prevented) return
                            }
                            this.$element.val(this.placeholder.id).trigger("change"), this.trigger("toggle", {})
                        }
                    }
                }, c.prototype._handleKeyboardClear = function (a, c, d) {
                    d.isOpen() || (c.which == b.DELETE || c.which == b.BACKSPACE) && this._handleClear(c)
                }, c.prototype.update = function (b, c) {
                    if (b.call(this, c), !(this.$selection.find(".select2-selection__placeholder").length > 0 || 0 === c.length)) {
                        var d = a('<span class="select2-selection__clear">&times;</span>');
                        d.data("data", c), this.$selection.find(".select2-selection__rendered").prepend(d)
                    }
                }, c
            }), b.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (a, b, c) {
                function d(a, b, c) {
                    a.call(this, b, c)
                }

                return d.prototype.render = function (b) {
                    var c = a('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');
                    this.$searchContainer = c, this.$search = c.find("input");
                    var d = b.call(this);
                    return this._transferTabIndex(), d
                }, d.prototype.bind = function (a, b, d) {
                    var e = this;
                    a.call(this, b, d), b.on("open", function () {
                        e.$search.trigger("focus")
                    }), b.on("close", function () {
                        e.$search.val(""), e.$search.removeAttr("aria-activedescendant"), e.$search.trigger("focus")
                    }), b.on("enable", function () {
                        e.$search.prop("disabled", !1), e._transferTabIndex()
                    }), b.on("disable", function () {
                        e.$search.prop("disabled", !0)
                    }), b.on("focus", function (a) {
                        e.$search.trigger("focus")
                    }), b.on("results:focus", function (a) {
                        e.$search.attr("aria-activedescendant", a.id)
                    }), this.$selection.on("focusin", ".select2-search--inline", function (a) {
                        e.trigger("focus", a)
                    }), this.$selection.on("focusout", ".select2-search--inline", function (a) {
                        e._handleBlur(a)
                    }), this.$selection.on("keydown", ".select2-search--inline", function (a) {
                        a.stopPropagation(), e.trigger("keypress", a), e._keyUpPrevented = a.isDefaultPrevented();
                        var b = a.which;
                        if (b === c.BACKSPACE && "" === e.$search.val()) {
                            var d = e.$searchContainer.prev(".select2-selection__choice");
                            if (d.length > 0) {
                                var f = d.data("data");
                                e.searchRemoveChoice(f), a.preventDefault()
                            }
                        }
                    });
                    var f = document.documentMode, g = f && 11 >= f;
                    this.$selection.on("input.searchcheck", ".select2-search--inline", function (a) {
                        return g ? void e.$selection.off("input.search input.searchcheck") : void e.$selection.off("keyup.search")
                    }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function (a) {
                        if (g && "input" === a.type) return void e.$selection.off("input.search input.searchcheck");
                        var b = a.which;
                        b != c.SHIFT && b != c.CTRL && b != c.ALT && b != c.TAB && e.handleSearch(a)
                    })
                }, d.prototype._transferTabIndex = function (a) {
                    this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
                }, d.prototype.createPlaceholder = function (a, b) {
                    this.$search.attr("placeholder", b.text)
                }, d.prototype.update = function (a, b) {
                    var c = this.$search[0] == document.activeElement;
                    this.$search.attr("placeholder", ""), a.call(this, b), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), c && this.$search.focus()
                }, d.prototype.handleSearch = function () {
                    if (this.resizeSearch(), !this._keyUpPrevented) {
                        var a = this.$search.val();
                        this.trigger("query", {term: a})
                    }
                    this._keyUpPrevented = !1
                }, d.prototype.searchRemoveChoice = function (a, b) {
                    this.trigger("unselect", {data: b}), this.$search.val(b.text), this.handleSearch()
                }, d.prototype.resizeSearch = function () {
                    this.$search.css("width", "25px");
                    var a = "";
                    if ("" !== this.$search.attr("placeholder")) a = this.$selection.find(".select2-selection__rendered").innerWidth(); else {
                        var b = this.$search.val().length + 1;
                        a = .75 * b + "em"
                    }
                    this.$search.css("width", a)
                }, d
            }), b.define("select2/selection/eventRelay", ["jquery"], function (a) {
                function b() {
                }

                return b.prototype.bind = function (b, c, d) {
                    var e = this,
                        f = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting"],
                        g = ["opening", "closing", "selecting", "unselecting"];
                    b.call(this, c, d), c.on("*", function (b, c) {
                        if (-1 !== a.inArray(b, f)) {
                            c = c || {};
                            var d = a.Event("select2:" + b, {params: c});
                            e.$element.trigger(d), -1 !== a.inArray(b, g) && (c.prevented = d.isDefaultPrevented())
                        }
                    })
                }, b
            }), b.define("select2/translation", ["jquery", "require"], function (a, b) {
                function c(a) {
                    this.dict = a || {}
                }

                return c.prototype.all = function () {
                    return this.dict
                }, c.prototype.get = function (a) {
                    return this.dict[a]
                }, c.prototype.extend = function (b) {
                    this.dict = a.extend({}, b.all(), this.dict)
                }, c._cache = {}, c.loadPath = function (a) {
                    if (!(a in c._cache)) {
                        var d = b(a);
                        c._cache[a] = d
                    }
                    return new c(c._cache[a])
                }, c
            }), b.define("select2/diacritics", [], function () {
                var a = {
                    "Ⓐ": "A",
                    "Ａ": "A",
                    "À": "A",
                    "Á": "A",
                    "Â": "A",
                    "Ầ": "A",
                    "Ấ": "A",
                    "Ẫ": "A",
                    "Ẩ": "A",
                    "Ã": "A",
                    "Ā": "A",
                    "Ă": "A",
                    "Ằ": "A",
                    "Ắ": "A",
                    "Ẵ": "A",
                    "Ẳ": "A",
                    "Ȧ": "A",
                    "Ǡ": "A",
                    "Ä": "A",
                    "Ǟ": "A",
                    "Ả": "A",
                    "Å": "A",
                    "Ǻ": "A",
                    "Ǎ": "A",
                    "Ȁ": "A",
                    "Ȃ": "A",
                    "Ạ": "A",
                    "Ậ": "A",
                    "Ặ": "A",
                    "Ḁ": "A",
                    "Ą": "A",
                    "Ⱥ": "A",
                    "Ɐ": "A",
                    "Ꜳ": "AA",
                    "Æ": "AE",
                    "Ǽ": "AE",
                    "Ǣ": "AE",
                    "Ꜵ": "AO",
                    "Ꜷ": "AU",
                    "Ꜹ": "AV",
                    "Ꜻ": "AV",
                    "Ꜽ": "AY",
                    "Ⓑ": "B",
                    "Ｂ": "B",
                    "Ḃ": "B",
                    "Ḅ": "B",
                    "Ḇ": "B",
                    "Ƀ": "B",
                    "Ƃ": "B",
                    "Ɓ": "B",
                    "Ⓒ": "C",
                    "Ｃ": "C",
                    "Ć": "C",
                    "Ĉ": "C",
                    "Ċ": "C",
                    "Č": "C",
                    "Ç": "C",
                    "Ḉ": "C",
                    "Ƈ": "C",
                    "Ȼ": "C",
                    "Ꜿ": "C",
                    "Ⓓ": "D",
                    "Ｄ": "D",
                    "Ḋ": "D",
                    "Ď": "D",
                    "Ḍ": "D",
                    "Ḑ": "D",
                    "Ḓ": "D",
                    "Ḏ": "D",
                    "Đ": "D",
                    "Ƌ": "D",
                    "Ɗ": "D",
                    "Ɖ": "D",
                    "Ꝺ": "D",
                    "Ǳ": "DZ",
                    "Ǆ": "DZ",
                    "ǲ": "Dz",
                    "ǅ": "Dz",
                    "Ⓔ": "E",
                    "Ｅ": "E",
                    "È": "E",
                    "É": "E",
                    "Ê": "E",
                    "Ề": "E",
                    "Ế": "E",
                    "Ễ": "E",
                    "Ể": "E",
                    "Ẽ": "E",
                    "Ē": "E",
                    "Ḕ": "E",
                    "Ḗ": "E",
                    "Ĕ": "E",
                    "Ė": "E",
                    "Ë": "E",
                    "Ẻ": "E",
                    "Ě": "E",
                    "Ȅ": "E",
                    "Ȇ": "E",
                    "Ẹ": "E",
                    "Ệ": "E",
                    "Ȩ": "E",
                    "Ḝ": "E",
                    "Ę": "E",
                    "Ḙ": "E",
                    "Ḛ": "E",
                    "Ɛ": "E",
                    "Ǝ": "E",
                    "Ⓕ": "F",
                    "Ｆ": "F",
                    "Ḟ": "F",
                    "Ƒ": "F",
                    "Ꝼ": "F",
                    "Ⓖ": "G",
                    "Ｇ": "G",
                    "Ǵ": "G",
                    "Ĝ": "G",
                    "Ḡ": "G",
                    "Ğ": "G",
                    "Ġ": "G",
                    "Ǧ": "G",
                    "Ģ": "G",
                    "Ǥ": "G",
                    "Ɠ": "G",
                    "Ꞡ": "G",
                    "Ᵹ": "G",
                    "Ꝿ": "G",
                    "Ⓗ": "H",
                    "Ｈ": "H",
                    "Ĥ": "H",
                    "Ḣ": "H",
                    "Ḧ": "H",
                    "Ȟ": "H",
                    "Ḥ": "H",
                    "Ḩ": "H",
                    "Ḫ": "H",
                    "Ħ": "H",
                    "Ⱨ": "H",
                    "Ⱶ": "H",
                    "Ɥ": "H",
                    "Ⓘ": "I",
                    "Ｉ": "I",
                    "Ì": "I",
                    "Í": "I",
                    "Î": "I",
                    "Ĩ": "I",
                    "Ī": "I",
                    "Ĭ": "I",
                    "İ": "I",
                    "Ï": "I",
                    "Ḯ": "I",
                    "Ỉ": "I",
                    "Ǐ": "I",
                    "Ȉ": "I",
                    "Ȋ": "I",
                    "Ị": "I",
                    "Į": "I",
                    "Ḭ": "I",
                    "Ɨ": "I",
                    "Ⓙ": "J",
                    "Ｊ": "J",
                    "Ĵ": "J",
                    "Ɉ": "J",
                    "Ⓚ": "K",
                    "Ｋ": "K",
                    "Ḱ": "K",
                    "Ǩ": "K",
                    "Ḳ": "K",
                    "Ķ": "K",
                    "Ḵ": "K",
                    "Ƙ": "K",
                    "Ⱪ": "K",
                    "Ꝁ": "K",
                    "Ꝃ": "K",
                    "Ꝅ": "K",
                    "Ꞣ": "K",
                    "Ⓛ": "L",
                    "Ｌ": "L",
                    "Ŀ": "L",
                    "Ĺ": "L",
                    "Ľ": "L",
                    "Ḷ": "L",
                    "Ḹ": "L",
                    "Ļ": "L",
                    "Ḽ": "L",
                    "Ḻ": "L",
                    "Ł": "L",
                    "Ƚ": "L",
                    "Ɫ": "L",
                    "Ⱡ": "L",
                    "Ꝉ": "L",
                    "Ꝇ": "L",
                    "Ꞁ": "L",
                    "Ǉ": "LJ",
                    "ǈ": "Lj",
                    "Ⓜ": "M",
                    "Ｍ": "M",
                    "Ḿ": "M",
                    "Ṁ": "M",
                    "Ṃ": "M",
                    "Ɱ": "M",
                    "Ɯ": "M",
                    "Ⓝ": "N",
                    "Ｎ": "N",
                    "Ǹ": "N",
                    "Ń": "N",
                    "Ñ": "N",
                    "Ṅ": "N",
                    "Ň": "N",
                    "Ṇ": "N",
                    "Ņ": "N",
                    "Ṋ": "N",
                    "Ṉ": "N",
                    "Ƞ": "N",
                    "Ɲ": "N",
                    "Ꞑ": "N",
                    "Ꞥ": "N",
                    "Ǌ": "NJ",
                    "ǋ": "Nj",
                    "Ⓞ": "O",
                    "Ｏ": "O",
                    "Ò": "O",
                    "Ó": "O",
                    "Ô": "O",
                    "Ồ": "O",
                    "Ố": "O",
                    "Ỗ": "O",
                    "Ổ": "O",
                    "Õ": "O",
                    "Ṍ": "O",
                    "Ȭ": "O",
                    "Ṏ": "O",
                    "Ō": "O",
                    "Ṑ": "O",
                    "Ṓ": "O",
                    "Ŏ": "O",
                    "Ȯ": "O",
                    "Ȱ": "O",
                    "Ö": "O",
                    "Ȫ": "O",
                    "Ỏ": "O",
                    "Ő": "O",
                    "Ǒ": "O",
                    "Ȍ": "O",
                    "Ȏ": "O",
                    "Ơ": "O",
                    "Ờ": "O",
                    "Ớ": "O",
                    "Ỡ": "O",
                    "Ở": "O",
                    "Ợ": "O",
                    "Ọ": "O",
                    "Ộ": "O",
                    "Ǫ": "O",
                    "Ǭ": "O",
                    "Ø": "O",
                    "Ǿ": "O",
                    "Ɔ": "O",
                    "Ɵ": "O",
                    "Ꝋ": "O",
                    "Ꝍ": "O",
                    "Ƣ": "OI",
                    "Ꝏ": "OO",
                    "Ȣ": "OU",
                    "Ⓟ": "P",
                    "Ｐ": "P",
                    "Ṕ": "P",
                    "Ṗ": "P",
                    "Ƥ": "P",
                    "Ᵽ": "P",
                    "Ꝑ": "P",
                    "Ꝓ": "P",
                    "Ꝕ": "P",
                    "Ⓠ": "Q",
                    "Ｑ": "Q",
                    "Ꝗ": "Q",
                    "Ꝙ": "Q",
                    "Ɋ": "Q",
                    "Ⓡ": "R",
                    "Ｒ": "R",
                    "Ŕ": "R",
                    "Ṙ": "R",
                    "Ř": "R",
                    "Ȑ": "R",
                    "Ȓ": "R",
                    "Ṛ": "R",
                    "Ṝ": "R",
                    "Ŗ": "R",
                    "Ṟ": "R",
                    "Ɍ": "R",
                    "Ɽ": "R",
                    "Ꝛ": "R",
                    "Ꞧ": "R",
                    "Ꞃ": "R",
                    "Ⓢ": "S",
                    "Ｓ": "S",
                    "ẞ": "S",
                    "Ś": "S",
                    "Ṥ": "S",
                    "Ŝ": "S",
                    "Ṡ": "S",
                    "Š": "S",
                    "Ṧ": "S",
                    "Ṣ": "S",
                    "Ṩ": "S",
                    "Ș": "S",
                    "Ş": "S",
                    "Ȿ": "S",
                    "Ꞩ": "S",
                    "Ꞅ": "S",
                    "Ⓣ": "T",
                    "Ｔ": "T",
                    "Ṫ": "T",
                    "Ť": "T",
                    "Ṭ": "T",
                    "Ț": "T",
                    "Ţ": "T",
                    "Ṱ": "T",
                    "Ṯ": "T",
                    "Ŧ": "T",
                    "Ƭ": "T",
                    "Ʈ": "T",
                    "Ⱦ": "T",
                    "Ꞇ": "T",
                    "Ꜩ": "TZ",
                    "Ⓤ": "U",
                    "Ｕ": "U",
                    "Ù": "U",
                    "Ú": "U",
                    "Û": "U",
                    "Ũ": "U",
                    "Ṹ": "U",
                    "Ū": "U",
                    "Ṻ": "U",
                    "Ŭ": "U",
                    "Ü": "U",
                    "Ǜ": "U",
                    "Ǘ": "U",
                    "Ǖ": "U",
                    "Ǚ": "U",
                    "Ủ": "U",
                    "Ů": "U",
                    "Ű": "U",
                    "Ǔ": "U",
                    "Ȕ": "U",
                    "Ȗ": "U",
                    "Ư": "U",
                    "Ừ": "U",
                    "Ứ": "U",
                    "Ữ": "U",
                    "Ử": "U",
                    "Ự": "U",
                    "Ụ": "U",
                    "Ṳ": "U",
                    "Ų": "U",
                    "Ṷ": "U",
                    "Ṵ": "U",
                    "Ʉ": "U",
                    "Ⓥ": "V",
                    "Ｖ": "V",
                    "Ṽ": "V",
                    "Ṿ": "V",
                    "Ʋ": "V",
                    "Ꝟ": "V",
                    "Ʌ": "V",
                    "Ꝡ": "VY",
                    "Ⓦ": "W",
                    "Ｗ": "W",
                    "Ẁ": "W",
                    "Ẃ": "W",
                    "Ŵ": "W",
                    "Ẇ": "W",
                    "Ẅ": "W",
                    "Ẉ": "W",
                    "Ⱳ": "W",
                    "Ⓧ": "X",
                    "Ｘ": "X",
                    "Ẋ": "X",
                    "Ẍ": "X",
                    "Ⓨ": "Y",
                    "Ｙ": "Y",
                    "Ỳ": "Y",
                    "Ý": "Y",
                    "Ŷ": "Y",
                    "Ỹ": "Y",
                    "Ȳ": "Y",
                    "Ẏ": "Y",
                    "Ÿ": "Y",
                    "Ỷ": "Y",
                    "Ỵ": "Y",
                    "Ƴ": "Y",
                    "Ɏ": "Y",
                    "Ỿ": "Y",
                    "Ⓩ": "Z",
                    "Ｚ": "Z",
                    "Ź": "Z",
                    "Ẑ": "Z",
                    "Ż": "Z",
                    "Ž": "Z",
                    "Ẓ": "Z",
                    "Ẕ": "Z",
                    "Ƶ": "Z",
                    "Ȥ": "Z",
                    "Ɀ": "Z",
                    "Ⱬ": "Z",
                    "Ꝣ": "Z",
                    "ⓐ": "a",
                    "ａ": "a",
                    "ẚ": "a",
                    "à": "a",
                    "á": "a",
                    "â": "a",
                    "ầ": "a",
                    "ấ": "a",
                    "ẫ": "a",
                    "ẩ": "a",
                    "ã": "a",
                    "ā": "a",
                    "ă": "a",
                    "ằ": "a",
                    "ắ": "a",
                    "ẵ": "a",
                    "ẳ": "a",
                    "ȧ": "a",
                    "ǡ": "a",
                    "ä": "a",
                    "ǟ": "a",
                    "ả": "a",
                    "å": "a",
                    "ǻ": "a",
                    "ǎ": "a",
                    "ȁ": "a",
                    "ȃ": "a",
                    "ạ": "a",
                    "ậ": "a",
                    "ặ": "a",
                    "ḁ": "a",
                    "ą": "a",
                    "ⱥ": "a",
                    "ɐ": "a",
                    "ꜳ": "aa",
                    "æ": "ae",
                    "ǽ": "ae",
                    "ǣ": "ae",
                    "ꜵ": "ao",
                    "ꜷ": "au",
                    "ꜹ": "av",
                    "ꜻ": "av",
                    "ꜽ": "ay",
                    "ⓑ": "b",
                    "ｂ": "b",
                    "ḃ": "b",
                    "ḅ": "b",
                    "ḇ": "b",
                    "ƀ": "b",
                    "ƃ": "b",
                    "ɓ": "b",
                    "ⓒ": "c",
                    "ｃ": "c",
                    "ć": "c",
                    "ĉ": "c",
                    "ċ": "c",
                    "č": "c",
                    "ç": "c",
                    "ḉ": "c",
                    "ƈ": "c",
                    "ȼ": "c",
                    "ꜿ": "c",
                    "ↄ": "c",
                    "ⓓ": "d",
                    "ｄ": "d",
                    "ḋ": "d",
                    "ď": "d",
                    "ḍ": "d",
                    "ḑ": "d",
                    "ḓ": "d",
                    "ḏ": "d",
                    "đ": "d",
                    "ƌ": "d",
                    "ɖ": "d",
                    "ɗ": "d",
                    "ꝺ": "d",
                    "ǳ": "dz",
                    "ǆ": "dz",
                    "ⓔ": "e",
                    "ｅ": "e",
                    "è": "e",
                    "é": "e",
                    "ê": "e",
                    "ề": "e",
                    "ế": "e",
                    "ễ": "e",
                    "ể": "e",
                    "ẽ": "e",
                    "ē": "e",
                    "ḕ": "e",
                    "ḗ": "e",
                    "ĕ": "e",
                    "ė": "e",
                    "ë": "e",
                    "ẻ": "e",
                    "ě": "e",
                    "ȅ": "e",
                    "ȇ": "e",
                    "ẹ": "e",
                    "ệ": "e",
                    "ȩ": "e",
                    "ḝ": "e",
                    "ę": "e",
                    "ḙ": "e",
                    "ḛ": "e",
                    "ɇ": "e",
                    "ɛ": "e",
                    "ǝ": "e",
                    "ⓕ": "f",
                    "ｆ": "f",
                    "ḟ": "f",
                    "ƒ": "f",
                    "ꝼ": "f",
                    "ⓖ": "g",
                    "ｇ": "g",
                    "ǵ": "g",
                    "ĝ": "g",
                    "ḡ": "g",
                    "ğ": "g",
                    "ġ": "g",
                    "ǧ": "g",
                    "ģ": "g",
                    "ǥ": "g",
                    "ɠ": "g",
                    "ꞡ": "g",
                    "ᵹ": "g",
                    "ꝿ": "g",
                    "ⓗ": "h",
                    "ｈ": "h",
                    "ĥ": "h",
                    "ḣ": "h",
                    "ḧ": "h",
                    "ȟ": "h",
                    "ḥ": "h",
                    "ḩ": "h",
                    "ḫ": "h",
                    "ẖ": "h",
                    "ħ": "h",
                    "ⱨ": "h",
                    "ⱶ": "h",
                    "ɥ": "h",
                    "ƕ": "hv",
                    "ⓘ": "i",
                    "ｉ": "i",
                    "ì": "i",
                    "í": "i",
                    "î": "i",
                    "ĩ": "i",
                    "ī": "i",
                    "ĭ": "i",
                    "ï": "i",
                    "ḯ": "i",
                    "ỉ": "i",
                    "ǐ": "i",
                    "ȉ": "i",
                    "ȋ": "i",
                    "ị": "i",
                    "į": "i",
                    "ḭ": "i",
                    "ɨ": "i",
                    "ı": "i",
                    "ⓙ": "j",
                    "ｊ": "j",
                    "ĵ": "j",
                    "ǰ": "j",
                    "ɉ": "j",
                    "ⓚ": "k",
                    "ｋ": "k",
                    "ḱ": "k",
                    "ǩ": "k",
                    "ḳ": "k",
                    "ķ": "k",
                    "ḵ": "k",
                    "ƙ": "k",
                    "ⱪ": "k",
                    "ꝁ": "k",
                    "ꝃ": "k",
                    "ꝅ": "k",
                    "ꞣ": "k",
                    "ⓛ": "l",
                    "ｌ": "l",
                    "ŀ": "l",
                    "ĺ": "l",
                    "ľ": "l",
                    "ḷ": "l",
                    "ḹ": "l",
                    "ļ": "l",
                    "ḽ": "l",
                    "ḻ": "l",
                    "ſ": "l",
                    "ł": "l",
                    "ƚ": "l",
                    "ɫ": "l",
                    "ⱡ": "l",
                    "ꝉ": "l",
                    "ꞁ": "l",
                    "ꝇ": "l",
                    "ǉ": "lj",
                    "ⓜ": "m",
                    "ｍ": "m",
                    "ḿ": "m",
                    "ṁ": "m",
                    "ṃ": "m",
                    "ɱ": "m",
                    "ɯ": "m",
                    "ⓝ": "n",
                    "ｎ": "n",
                    "ǹ": "n",
                    "ń": "n",
                    "ñ": "n",
                    "ṅ": "n",
                    "ň": "n",
                    "ṇ": "n",
                    "ņ": "n",
                    "ṋ": "n",
                    "ṉ": "n",
                    "ƞ": "n",
                    "ɲ": "n",
                    "ŉ": "n",
                    "ꞑ": "n",
                    "ꞥ": "n",
                    "ǌ": "nj",
                    "ⓞ": "o",
                    "ｏ": "o",
                    "ò": "o",
                    "ó": "o",
                    "ô": "o",
                    "ồ": "o",
                    "ố": "o",
                    "ỗ": "o",
                    "ổ": "o",
                    "õ": "o",
                    "ṍ": "o",
                    "ȭ": "o",
                    "ṏ": "o",
                    "ō": "o",
                    "ṑ": "o",
                    "ṓ": "o",
                    "ŏ": "o",
                    "ȯ": "o",
                    "ȱ": "o",
                    "ö": "o",
                    "ȫ": "o",
                    "ỏ": "o",
                    "ő": "o",
                    "ǒ": "o",
                    "ȍ": "o",
                    "ȏ": "o",
                    "ơ": "o",
                    "ờ": "o",
                    "ớ": "o",
                    "ỡ": "o",
                    "ở": "o",
                    "ợ": "o",
                    "ọ": "o",
                    "ộ": "o",
                    "ǫ": "o",
                    "ǭ": "o",
                    "ø": "o",
                    "ǿ": "o",
                    "ɔ": "o",
                    "ꝋ": "o",
                    "ꝍ": "o",
                    "ɵ": "o",
                    "ƣ": "oi",
                    "ȣ": "ou",
                    "ꝏ": "oo",
                    "ⓟ": "p",
                    "ｐ": "p",
                    "ṕ": "p",
                    "ṗ": "p",
                    "ƥ": "p",
                    "ᵽ": "p",
                    "ꝑ": "p",
                    "ꝓ": "p",
                    "ꝕ": "p",
                    "ⓠ": "q",
                    "ｑ": "q",
                    "ɋ": "q",
                    "ꝗ": "q",
                    "ꝙ": "q",
                    "ⓡ": "r",
                    "ｒ": "r",
                    "ŕ": "r",
                    "ṙ": "r",
                    "ř": "r",
                    "ȑ": "r",
                    "ȓ": "r",
                    "ṛ": "r",
                    "ṝ": "r",
                    "ŗ": "r",
                    "ṟ": "r",
                    "ɍ": "r",
                    "ɽ": "r",
                    "ꝛ": "r",
                    "ꞧ": "r",
                    "ꞃ": "r",
                    "ⓢ": "s",
                    "ｓ": "s",
                    "ß": "s",
                    "ś": "s",
                    "ṥ": "s",
                    "ŝ": "s",
                    "ṡ": "s",
                    "š": "s",
                    "ṧ": "s",
                    "ṣ": "s",
                    "ṩ": "s",
                    "ș": "s",
                    "ş": "s",
                    "ȿ": "s",
                    "ꞩ": "s",
                    "ꞅ": "s",
                    "ẛ": "s",
                    "ⓣ": "t",
                    "ｔ": "t",
                    "ṫ": "t",
                    "ẗ": "t",
                    "ť": "t",
                    "ṭ": "t",
                    "ț": "t",
                    "ţ": "t",
                    "ṱ": "t",
                    "ṯ": "t",
                    "ŧ": "t",
                    "ƭ": "t",
                    "ʈ": "t",
                    "ⱦ": "t",
                    "ꞇ": "t",
                    "ꜩ": "tz",
                    "ⓤ": "u",
                    "ｕ": "u",
                    "ù": "u",
                    "ú": "u",
                    "û": "u",
                    "ũ": "u",
                    "ṹ": "u",
                    "ū": "u",
                    "ṻ": "u",
                    "ŭ": "u",
                    "ü": "u",
                    "ǜ": "u",
                    "ǘ": "u",
                    "ǖ": "u",
                    "ǚ": "u",
                    "ủ": "u",
                    "ů": "u",
                    "ű": "u",
                    "ǔ": "u",
                    "ȕ": "u",
                    "ȗ": "u",
                    "ư": "u",
                    "ừ": "u",
                    "ứ": "u",
                    "ữ": "u",
                    "ử": "u",
                    "ự": "u",
                    "ụ": "u",
                    "ṳ": "u",
                    "ų": "u",
                    "ṷ": "u",
                    "ṵ": "u",
                    "ʉ": "u",
                    "ⓥ": "v",
                    "ｖ": "v",
                    "ṽ": "v",
                    "ṿ": "v",
                    "ʋ": "v",
                    "ꝟ": "v",
                    "ʌ": "v",
                    "ꝡ": "vy",
                    "ⓦ": "w",
                    "ｗ": "w",
                    "ẁ": "w",
                    "ẃ": "w",
                    "ŵ": "w",
                    "ẇ": "w",
                    "ẅ": "w",
                    "ẘ": "w",
                    "ẉ": "w",
                    "ⱳ": "w",
                    "ⓧ": "x",
                    "ｘ": "x",
                    "ẋ": "x",
                    "ẍ": "x",
                    "ⓨ": "y",
                    "ｙ": "y",
                    "ỳ": "y",
                    "ý": "y",
                    "ŷ": "y",
                    "ỹ": "y",
                    "ȳ": "y",
                    "ẏ": "y",
                    "ÿ": "y",
                    "ỷ": "y",
                    "ẙ": "y",
                    "ỵ": "y",
                    "ƴ": "y",
                    "ɏ": "y",
                    "ỿ": "y",
                    "ⓩ": "z",
                    "ｚ": "z",
                    "ź": "z",
                    "ẑ": "z",
                    "ż": "z",
                    "ž": "z",
                    "ẓ": "z",
                    "ẕ": "z",
                    "ƶ": "z",
                    "ȥ": "z",
                    "ɀ": "z",
                    "ⱬ": "z",
                    "ꝣ": "z",
                    "Ά": "Α",
                    "Έ": "Ε",
                    "Ή": "Η",
                    "Ί": "Ι",
                    "Ϊ": "Ι",
                    "Ό": "Ο",
                    "Ύ": "Υ",
                    "Ϋ": "Υ",
                    "Ώ": "Ω",
                    "ά": "α",
                    "έ": "ε",
                    "ή": "η",
                    "ί": "ι",
                    "ϊ": "ι",
                    "ΐ": "ι",
                    "ό": "ο",
                    "ύ": "υ",
                    "ϋ": "υ",
                    "ΰ": "υ",
                    "ω": "ω",
                    "ς": "σ"
                };
                return a
            }), b.define("select2/data/base", ["../utils"], function (a) {
                function b(a, c) {
                    b.__super__.constructor.call(this)
                }

                return a.Extend(b, a.Observable), b.prototype.current = function (a) {
                    throw new Error("The `current` method must be defined in child classes.")
                }, b.prototype.query = function (a, b) {
                    throw new Error("The `query` method must be defined in child classes.")
                }, b.prototype.bind = function (a, b) {
                }, b.prototype.destroy = function () {
                }, b.prototype.generateResultId = function (b, c) {
                    var d = b.id + "-result-";
                    return d += a.generateChars(4), d += null != c.id ? "-" + c.id.toString() : "-" + a.generateChars(4)
                }, b
            }), b.define("select2/data/select", ["./base", "../utils", "jquery"], function (a, b, c) {
                function d(a, b) {
                    this.$element = a, this.options = b, d.__super__.constructor.call(this)
                }

                return b.Extend(d, a), d.prototype.current = function (a) {
                    var b = [], d = this;
                    this.$element.find(":selected").each(function () {
                        var a = c(this), e = d.item(a);
                        b.push(e)
                    }), a(b)
                }, d.prototype.select = function (a) {
                    var b = this;
                    if (a.selected = !0, c(a.element).is("option")) return a.element.selected = !0, void this.$element.trigger("change");
                    if (this.$element.prop("multiple")) this.current(function (d) {
                        var e = [];
                        a = [a], a.push.apply(a, d);
                        for (var f = 0; f < a.length; f++) {
                            var g = a[f].id;
                            -1 === c.inArray(g, e) && e.push(g)
                        }
                        b.$element.val(e), b.$element.trigger("change")
                    }); else {
                        var d = a.id;
                        this.$element.val(d), this.$element.trigger("change")
                    }
                }, d.prototype.unselect = function (a) {
                    var b = this;
                    if (this.$element.prop("multiple")) return a.selected = !1, c(a.element).is("option") ? (a.element.selected = !1, void this.$element.trigger("change")) : void this.current(function (d) {
                        for (var e = [], f = 0; f < d.length; f++) {
                            var g = d[f].id;
                            g !== a.id && -1 === c.inArray(g, e) && e.push(g)
                        }
                        b.$element.val(e), b.$element.trigger("change")
                    })
                }, d.prototype.bind = function (a, b) {
                    var c = this;
                    this.container = a, a.on("select", function (a) {
                        c.select(a.data)
                    }), a.on("unselect", function (a) {
                        c.unselect(a.data)
                    })
                }, d.prototype.destroy = function () {
                    this.$element.find("*").each(function () {
                        c.removeData(this, "data")
                    })
                }, d.prototype.query = function (a, b) {
                    var d = [], e = this, f = this.$element.children();
                    f.each(function () {
                        var b = c(this);
                        if (b.is("option") || b.is("optgroup")) {
                            var f = e.item(b), g = e.matches(a, f);
                            null !== g && d.push(g)
                        }
                    }), b({results: d})
                }, d.prototype.addOptions = function (a) {
                    b.appendMany(this.$element, a)
                }, d.prototype.option = function (a) {
                    var b;
                    a.children ? (b = document.createElement("optgroup"), b.label = a.text) : (b = document.createElement("option"), void 0 !== b.textContent ? b.textContent = a.text : b.innerText = a.text), a.id && (b.value = a.id), a.disabled && (b.disabled = !0), a.selected && (b.selected = !0), a.title && (b.title = a.title);
                    var d = c(b), e = this._normalizeItem(a);
                    return e.element = b, c.data(b, "data", e), d
                }, d.prototype.item = function (a) {
                    var b = {};
                    if (b = c.data(a[0], "data"), null != b) return b;
                    if (a.is("option")) b = {
                        id: a.val(),
                        text: a.text(),
                        disabled: a.prop("disabled"),
                        selected: a.prop("selected"),
                        title: a.prop("title")
                    }; else if (a.is("optgroup")) {
                        b = {text: a.prop("label"), children: [], title: a.prop("title")};
                        for (var d = a.children("option"), e = [], f = 0; f < d.length; f++) {
                            var g = c(d[f]), h = this.item(g);
                            e.push(h)
                        }
                        b.children = e
                    }
                    return b = this._normalizeItem(b), b.element = a[0], c.data(a[0], "data", b), b
                }, d.prototype._normalizeItem = function (a) {
                    c.isPlainObject(a) || (a = {id: a, text: a}), a = c.extend({}, {text: ""}, a);
                    var b = {selected: !1, disabled: !1};
                    return null != a.id && (a.id = a.id.toString()), null != a.text && (a.text = a.text.toString()), null == a._resultId && a.id && null != this.container && (a._resultId = this.generateResultId(this.container, a)), c.extend({}, b, a)
                }, d.prototype.matches = function (a, b) {
                    var c = this.options.get("matcher");
                    return c(a, b)
                }, d
            }), b.define("select2/data/array", ["./select", "../utils", "jquery"], function (a, b, c) {
                function d(a, b) {
                    var c = b.get("data") || [];
                    d.__super__.constructor.call(this, a, b), this.addOptions(this.convertToOptions(c))
                }

                return b.Extend(d, a), d.prototype.select = function (a) {
                    var b = this.$element.find("option").filter(function (b, c) {
                        return c.value == a.id.toString()
                    });
                    0 === b.length && (b = this.option(a), this.addOptions(b)), d.__super__.select.call(this, a)
                }, d.prototype.convertToOptions = function (a) {
                    function d(a) {
                        return function () {
                            return c(this).val() == a.id
                        }
                    }

                    for (var e = this, f = this.$element.find("option"), g = f.map(function () {
                        return e.item(c(this)).id
                    }).get(), h = [], i = 0; i < a.length; i++) {
                        var j = this._normalizeItem(a[i]);
                        if (c.inArray(j.id, g) >= 0) {
                            var k = f.filter(d(j)), l = this.item(k), m = c.extend(!0, {}, j, l), n = this.option(m);
                            k.replaceWith(n)
                        } else {
                            var o = this.option(j);
                            if (j.children) {
                                var p = this.convertToOptions(j.children);
                                b.appendMany(o, p)
                            }
                            h.push(o)
                        }
                    }
                    return h
                }, d
            }), b.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (a, b, c) {
                function d(a, b) {
                    this.ajaxOptions = this._applyDefaults(b.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), d.__super__.constructor.call(this, a, b)
                }

                return b.Extend(d, a), d.prototype._applyDefaults = function (a) {
                    var b = {
                        data: function (a) {
                            return c.extend({}, a, {q: a.term})
                        }, transport: function (a, b, d) {
                            var e = c.ajax(a);
                            return e.then(b), e.fail(d), e
                        }
                    };
                    return c.extend({}, b, a, !0)
                }, d.prototype.processResults = function (a) {
                    return a
                }, d.prototype.query = function (a, b) {
                    function d() {
                        var d = f.transport(f, function (d) {
                            var f = e.processResults(d, a);
                            e.options.get("debug") && window.console && console.error && (f && f.results && c.isArray(f.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), b(f)
                        }, function () {
                            d.status && "0" === d.status || e.trigger("results:message", {message: "errorLoading"})
                        });
                        e._request = d
                    }

                    var e = this;
                    null != this._request && (c.isFunction(this._request.abort) && this._request.abort(), this._request = null);
                    var f = c.extend({type: "GET"}, this.ajaxOptions);
                    "function" == typeof f.url && (f.url = f.url.call(this.$element, a)), "function" == typeof f.data && (f.data = f.data.call(this.$element, a)), this.ajaxOptions.delay && null != a.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(d, this.ajaxOptions.delay)) : d()
                }, d
            }), b.define("select2/data/tags", ["jquery"], function (a) {
                function b(b, c, d) {
                    var e = d.get("tags"), f = d.get("createTag");
                    void 0 !== f && (this.createTag = f);
                    var g = d.get("insertTag");
                    if (void 0 !== g && (this.insertTag = g), b.call(this, c, d), a.isArray(e)) for (var h = 0; h < e.length; h++) {
                        var i = e[h], j = this._normalizeItem(i), k = this.option(j);
                        this.$element.append(k)
                    }
                }

                return b.prototype.query = function (a, b, c) {
                    function d(a, f) {
                        for (var g = a.results, h = 0; h < g.length; h++) {
                            var i = g[h], j = null != i.children && !d({results: i.children}, !0),
                                k = i.text === b.term;
                            if (k || j) return f ? !1 : (a.data = g, void c(a))
                        }
                        if (f) return !0;
                        var l = e.createTag(b);
                        if (null != l) {
                            var m = e.option(l);
                            m.attr("data-select2-tag", !0), e.addOptions([m]), e.insertTag(g, l)
                        }
                        a.results = g, c(a)
                    }

                    var e = this;
                    return this._removeOldTags(), null == b.term || null != b.page ? void a.call(this, b, c) : void a.call(this, b, d)
                }, b.prototype.createTag = function (b, c) {
                    var d = a.trim(c.term);
                    return "" === d ? null : {id: d, text: d}
                }, b.prototype.insertTag = function (a, b, c) {
                    b.unshift(c)
                }, b.prototype._removeOldTags = function (b) {
                    var c = (this._lastTag, this.$element.find("option[data-select2-tag]"));
                    c.each(function () {
                        this.selected || a(this).remove()
                    })
                }, b
            }), b.define("select2/data/tokenizer", ["jquery"], function (a) {
                function b(a, b, c) {
                    var d = c.get("tokenizer");
                    void 0 !== d && (this.tokenizer = d), a.call(this, b, c)
                }

                return b.prototype.bind = function (a, b, c) {
                    a.call(this, b, c), this.$search = b.dropdown.$search || b.selection.$search || c.find(".select2-search__field")
                }, b.prototype.query = function (b, c, d) {
                    function e(b) {
                        var c = g._normalizeItem(b), d = g.$element.find("option").filter(function () {
                            return a(this).val() === c.id
                        });
                        if (!d.length) {
                            var e = g.option(c);
                            e.attr("data-select2-tag", !0), g._removeOldTags(), g.addOptions([e])
                        }
                        f(c)
                    }

                    function f(a) {
                        g.trigger("select", {data: a})
                    }

                    var g = this;
                    c.term = c.term || "";
                    var h = this.tokenizer(c, this.options, e);
                    h.term !== c.term && (this.$search.length && (this.$search.val(h.term), this.$search.focus()), c.term = h.term), b.call(this, c, d)
                }, b.prototype.tokenizer = function (b, c, d, e) {
                    for (var f = d.get("tokenSeparators") || [], g = c.term, h = 0, i = this.createTag || function (a) {
                        return {id: a.term, text: a.term}
                    }; h < g.length;) {
                        var j = g[h];
                        if (-1 !== a.inArray(j, f)) {
                            var k = g.substr(0, h), l = a.extend({}, c, {term: k}), m = i(l);
                            null != m ? (e(m), g = g.substr(h + 1) || "", h = 0) : h++
                        } else h++
                    }
                    return {term: g}
                }, b
            }), b.define("select2/data/minimumInputLength", [], function () {
                function a(a, b, c) {
                    this.minimumInputLength = c.get("minimumInputLength"), a.call(this, b, c)
                }

                return a.prototype.query = function (a, b, c) {
                    return b.term = b.term || "", b.term.length < this.minimumInputLength ? void this.trigger("results:message", {
                        message: "inputTooShort",
                        args: {minimum: this.minimumInputLength, input: b.term, params: b}
                    }) : void a.call(this, b, c)
                }, a
            }), b.define("select2/data/maximumInputLength", [], function () {
                function a(a, b, c) {
                    this.maximumInputLength = c.get("maximumInputLength"), a.call(this, b, c)
                }

                return a.prototype.query = function (a, b, c) {
                    return b.term = b.term || "", this.maximumInputLength > 0 && b.term.length > this.maximumInputLength ? void this.trigger("results:message", {
                        message: "inputTooLong",
                        args: {maximum: this.maximumInputLength, input: b.term, params: b}
                    }) : void a.call(this, b, c)
                }, a
            }), b.define("select2/data/maximumSelectionLength", [], function () {
                function a(a, b, c) {
                    this.maximumSelectionLength = c.get("maximumSelectionLength"), a.call(this, b, c)
                }

                return a.prototype.query = function (a, b, c) {
                    var d = this;
                    this.current(function (e) {
                        var f = null != e ? e.length : 0;
                        return d.maximumSelectionLength > 0 && f >= d.maximumSelectionLength ? void d.trigger("results:message", {
                            message: "maximumSelected",
                            args: {maximum: d.maximumSelectionLength}
                        }) : void a.call(d, b, c)
                    })
                }, a
            }), b.define("select2/dropdown", ["jquery", "./utils"], function (a, b) {
                function c(a, b) {
                    this.$element = a, this.options = b, c.__super__.constructor.call(this)
                }

                return b.Extend(c, b.Observable), c.prototype.render = function () {
                    var b = a('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                    return b.attr("dir", this.options.get("dir")), this.$dropdown = b, b
                }, c.prototype.bind = function () {
                }, c.prototype.position = function (a, b) {
                }, c.prototype.destroy = function () {
                    this.$dropdown.remove()
                }, c
            }), b.define("select2/dropdown/search", ["jquery", "../utils"], function (a, b) {
                function c() {
                }

                return c.prototype.render = function (b) {
                    var c = b.call(this),
                        d = a('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" /></span>');
                    return this.$searchContainer = d, this.$search = d.find("input"), c.prepend(d), c
                }, c.prototype.bind = function (b, c, d) {
                    var e = this;
                    b.call(this, c, d), this.$search.on("keydown", function (a) {
                        e.trigger("keypress", a), e._keyUpPrevented = a.isDefaultPrevented()
                    }), this.$search.on("input", function (b) {
                        a(this).off("keyup")
                    }), this.$search.on("keyup input", function (a) {
                        e.handleSearch(a)
                    }), c.on("open", function () {
                        e.$search.attr("tabindex", 0), e.$search.focus(), window.setTimeout(function () {
                            e.$search.focus()
                        }, 0)
                    }), c.on("close", function () {
                        e.$search.attr("tabindex", -1), e.$search.val("")
                    }), c.on("focus", function () {
                        c.isOpen() && e.$search.focus()
                    }), c.on("results:all", function (a) {
                        if (null == a.query.term || "" === a.query.term) {
                            var b = e.showSearch(a);
                            b ? e.$searchContainer.removeClass("select2-search--hide") : e.$searchContainer.addClass("select2-search--hide")
                        }
                    })
                }, c.prototype.handleSearch = function (a) {
                    if (!this._keyUpPrevented) {
                        var b = this.$search.val();
                        this.trigger("query", {term: b})
                    }
                    this._keyUpPrevented = !1
                }, c.prototype.showSearch = function (a, b) {
                    return !0
                }, c
            }), b.define("select2/dropdown/hidePlaceholder", [], function () {
                function a(a, b, c, d) {
                    this.placeholder = this.normalizePlaceholder(c.get("placeholder")), a.call(this, b, c, d)
                }

                return a.prototype.append = function (a, b) {
                    b.results = this.removePlaceholder(b.results), a.call(this, b)
                }, a.prototype.normalizePlaceholder = function (a, b) {
                    return "string" == typeof b && (b = {id: "", text: b}), b
                }, a.prototype.removePlaceholder = function (a, b) {
                    for (var c = b.slice(0), d = b.length - 1; d >= 0; d--) {
                        var e = b[d];
                        this.placeholder.id === e.id && c.splice(d, 1)
                    }
                    return c
                }, a
            }), b.define("select2/dropdown/infiniteScroll", ["jquery"], function (a) {
                function b(a, b, c, d) {
                    this.lastParams = {}, a.call(this, b, c, d), this.$loadingMore = this.createLoadingMore(), this.loading = !1
                }

                return b.prototype.append = function (a, b) {
                    this.$loadingMore.remove(), this.loading = !1, a.call(this, b), this.showLoadingMore(b) && this.$results.append(this.$loadingMore)
                }, b.prototype.bind = function (b, c, d) {
                    var e = this;
                    b.call(this, c, d), c.on("query", function (a) {
                        e.lastParams = a, e.loading = !0
                    }), c.on("query:append", function (a) {
                        e.lastParams = a, e.loading = !0
                    }), this.$results.on("scroll", function () {
                        var b = a.contains(document.documentElement, e.$loadingMore[0]);
                        if (!e.loading && b) {
                            var c = e.$results.offset().top + e.$results.outerHeight(!1),
                                d = e.$loadingMore.offset().top + e.$loadingMore.outerHeight(!1);
                            c + 50 >= d && e.loadMore()
                        }
                    })
                }, b.prototype.loadMore = function () {
                    this.loading = !0;
                    var b = a.extend({}, {page: 1}, this.lastParams);
                    b.page++, this.trigger("query:append", b)
                }, b.prototype.showLoadingMore = function (a, b) {
                    return b.pagination && b.pagination.more
                }, b.prototype.createLoadingMore = function () {
                    var b = a('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),
                        c = this.options.get("translations").get("loadingMore");
                    return b.html(c(this.lastParams)), b
                }, b
            }), b.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (a, b) {
                function c(b, c, d) {
                    this.$dropdownParent = d.get("dropdownParent") || a(document.body), b.call(this, c, d)
                }

                return c.prototype.bind = function (a, b, c) {
                    var d = this, e = !1;
                    a.call(this, b, c), b.on("open", function () {
                        d._showDropdown(), d._attachPositioningHandler(b), e || (e = !0, b.on("results:all", function () {
                            d._positionDropdown(), d._resizeDropdown()
                        }), b.on("results:append", function () {
                            d._positionDropdown(), d._resizeDropdown()
                        }))
                    }), b.on("close", function () {
                        d._hideDropdown(), d._detachPositioningHandler(b)
                    }), this.$dropdownContainer.on("mousedown", function (a) {
                        a.stopPropagation()
                    })
                }, c.prototype.destroy = function (a) {
                    a.call(this), this.$dropdownContainer.remove()
                }, c.prototype.position = function (a, b, c) {
                    b.attr("class", c.attr("class")), b.removeClass("select2"), b.addClass("select2-container--open"), b.css({
                        position: "absolute",
                        top: -999999
                    }), this.$container = c
                }, c.prototype.render = function (b) {
                    var c = a("<span></span>"), d = b.call(this);
                    return c.append(d), this.$dropdownContainer = c, c
                }, c.prototype._hideDropdown = function (a) {
                    this.$dropdownContainer.detach()
                }, c.prototype._attachPositioningHandler = function (c, d) {
                    var e = this, f = "scroll.select2." + d.id, g = "resize.select2." + d.id,
                        h = "orientationchange.select2." + d.id, i = this.$container.parents().filter(b.hasScroll);
                    i.each(function () {
                        a(this).data("select2-scroll-position", {x: a(this).scrollLeft(), y: a(this).scrollTop()})
                    }), i.on(f, function (b) {
                        var c = a(this).data("select2-scroll-position");
                        a(this).scrollTop(c.y)
                    }), a(window).on(f + " " + g + " " + h, function (a) {
                        e._positionDropdown(), e._resizeDropdown()
                    })
                }, c.prototype._detachPositioningHandler = function (c, d) {
                    var e = "scroll.select2." + d.id, f = "resize.select2." + d.id,
                        g = "orientationchange.select2." + d.id, h = this.$container.parents().filter(b.hasScroll);
                    h.off(e), a(window).off(e + " " + f + " " + g)
                }, c.prototype._positionDropdown = function () {
                    var b = a(window), c = this.$dropdown.hasClass("select2-dropdown--above"),
                        d = this.$dropdown.hasClass("select2-dropdown--below"), e = null, f = this.$container.offset();
                    f.bottom = f.top + this.$container.outerHeight(!1);
                    var g = {height: this.$container.outerHeight(!1)};
                    g.top = f.top, g.bottom = f.top + g.height;
                    var h = {height: this.$dropdown.outerHeight(!1)},
                        i = {top: b.scrollTop(), bottom: b.scrollTop() + b.height()}, j = i.top < f.top - h.height,
                        k = i.bottom > f.bottom + h.height, l = {left: f.left, top: g.bottom}, m = this.$dropdownParent;
                    "static" === m.css("position") && (m = m.offsetParent());
                    var n = m.offset();
                    l.top -= n.top, l.left -= n.left, c || d || (e = "below"), k || !j || c ? !j && k && c && (e = "below") : e = "above", ("above" == e || c && "below" !== e) && (l.top = g.top - n.top - h.height), null != e && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + e), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + e)), this.$dropdownContainer.css(l)
                }, c.prototype._resizeDropdown = function () {
                    var a = {width: this.$container.outerWidth(!1) + "px"};
                    this.options.get("dropdownAutoWidth") && (a.minWidth = a.width, a.position = "relative", a.width = "auto"), this.$dropdown.css(a)
                }, c.prototype._showDropdown = function (a) {
                    this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
                }, c
            }), b.define("select2/dropdown/minimumResultsForSearch", [], function () {
                function a(b) {
                    for (var c = 0, d = 0; d < b.length; d++) {
                        var e = b[d];
                        e.children ? c += a(e.children) : c++
                    }
                    return c
                }

                function b(a, b, c, d) {
                    this.minimumResultsForSearch = c.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), a.call(this, b, c, d)
                }

                return b.prototype.showSearch = function (b, c) {
                    return a(c.data.results) < this.minimumResultsForSearch ? !1 : b.call(this, c)
                }, b
            }), b.define("select2/dropdown/selectOnClose", [], function () {
                function a() {
                }

                return a.prototype.bind = function (a, b, c) {
                    var d = this;
                    a.call(this, b, c), b.on("close", function (a) {
                        d._handleSelectOnClose(a)
                    })
                }, a.prototype._handleSelectOnClose = function (a, b) {
                    if (b && null != b.originalSelect2Event) {
                        var c = b.originalSelect2Event;
                        if ("select" === c._type || "unselect" === c._type) return
                    }
                    var d = this.getHighlightedResults();
                    if (!(d.length < 1)) {
                        var e = d.data("data");
                        null != e.element && e.element.selected || null == e.element && e.selected || this.trigger("select", {data: e})
                    }
                }, a
            }), b.define("select2/dropdown/closeOnSelect", [], function () {
                function a() {
                }

                return a.prototype.bind = function (a, b, c) {
                    var d = this;
                    a.call(this, b, c), b.on("select", function (a) {
                        d._selectTriggered(a)
                    }), b.on("unselect", function (a) {
                        d._selectTriggered(a)
                    })
                }, a.prototype._selectTriggered = function (a, b) {
                    var c = b.originalEvent;
                    c && c.ctrlKey || this.trigger("close", {originalEvent: c, originalSelect2Event: b})
                }, a
            }), b.define("select2/i18n/en", [], function () {
                return {
                    errorLoading: function () {
                        return "The results could not be loaded."
                    }, inputTooLong: function (a) {
                        var b = a.input.length - a.maximum, c = "Please delete " + b + " character";
                        return 1 != b && (c += "s"), c
                    }, inputTooShort: function (a) {
                        var b = a.minimum - a.input.length, c = "Please enter " + b + " or more characters";
                        return c
                    }, loadingMore: function () {
                        return "Loading more results…"
                    }, maximumSelected: function (a) {
                        var b = "You can only select " + a.maximum + " item";
                        return 1 != a.maximum && (b += "s"), b
                    }, noResults: function () {
                        return "No results found"
                    }, searching: function () {
                        return "Searching…"
                    }
                }
            }), b.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C) {
                function D() {
                    this.reset()
                }

                D.prototype.apply = function (l) {
                    if (l = a.extend(!0, {}, this.defaults, l), null == l.dataAdapter) {
                        if (null != l.ajax ? l.dataAdapter = o : null != l.data ? l.dataAdapter = n : l.dataAdapter = m, l.minimumInputLength > 0 && (l.dataAdapter = j.Decorate(l.dataAdapter, r)), l.maximumInputLength > 0 && (l.dataAdapter = j.Decorate(l.dataAdapter, s)), l.maximumSelectionLength > 0 && (l.dataAdapter = j.Decorate(l.dataAdapter, t)), l.tags && (l.dataAdapter = j.Decorate(l.dataAdapter, p)), (null != l.tokenSeparators || null != l.tokenizer) && (l.dataAdapter = j.Decorate(l.dataAdapter, q)), null != l.query) {
                            var C = b(l.amdBase + "compat/query");
                            l.dataAdapter = j.Decorate(l.dataAdapter, C)
                        }
                        if (null != l.initSelection) {
                            var D = b(l.amdBase + "compat/initSelection");
                            l.dataAdapter = j.Decorate(l.dataAdapter, D)
                        }
                    }
                    if (null == l.resultsAdapter && (l.resultsAdapter = c, null != l.ajax && (l.resultsAdapter = j.Decorate(l.resultsAdapter, x)), null != l.placeholder && (l.resultsAdapter = j.Decorate(l.resultsAdapter, w)), l.selectOnClose && (l.resultsAdapter = j.Decorate(l.resultsAdapter, A))), null == l.dropdownAdapter) {
                        if (l.multiple) l.dropdownAdapter = u; else {
                            var E = j.Decorate(u, v);
                            l.dropdownAdapter = E
                        }
                        if (0 !== l.minimumResultsForSearch && (l.dropdownAdapter = j.Decorate(l.dropdownAdapter, z)), l.closeOnSelect && (l.dropdownAdapter = j.Decorate(l.dropdownAdapter, B)), null != l.dropdownCssClass || null != l.dropdownCss || null != l.adaptDropdownCssClass) {
                            var F = b(l.amdBase + "compat/dropdownCss");
                            l.dropdownAdapter = j.Decorate(l.dropdownAdapter, F)
                        }
                        l.dropdownAdapter = j.Decorate(l.dropdownAdapter, y)
                    }
                    if (null == l.selectionAdapter) {
                        if (l.multiple ? l.selectionAdapter = e : l.selectionAdapter = d, null != l.placeholder && (l.selectionAdapter = j.Decorate(l.selectionAdapter, f)), l.allowClear && (l.selectionAdapter = j.Decorate(l.selectionAdapter, g)), l.multiple && (l.selectionAdapter = j.Decorate(l.selectionAdapter, h)), null != l.containerCssClass || null != l.containerCss || null != l.adaptContainerCssClass) {
                            var G = b(l.amdBase + "compat/containerCss");
                            l.selectionAdapter = j.Decorate(l.selectionAdapter, G)
                        }
                        l.selectionAdapter = j.Decorate(l.selectionAdapter, i)
                    }
                    if ("string" == typeof l.language) if (l.language.indexOf("-") > 0) {
                        var H = l.language.split("-"), I = H[0];
                        l.language = [l.language, I]
                    } else l.language = [l.language];
                    if (a.isArray(l.language)) {
                        var J = new k;
                        l.language.push("en");
                        for (var K = l.language, L = 0; L < K.length; L++) {
                            var M = K[L], N = {};
                            try {
                                N = k.loadPath(M)
                            } catch (O) {
                                try {
                                    M = this.defaults.amdLanguageBase + M, N = k.loadPath(M)
                                } catch (P) {
                                    l.debug && window.console && console.warn && console.warn('Select2: The language file for "' + M + '" could not be automatically loaded. A fallback will be used instead.');
                                    continue
                                }
                            }
                            J.extend(N)
                        }
                        l.translations = J
                    } else {
                        var Q = k.loadPath(this.defaults.amdLanguageBase + "en"), R = new k(l.language);
                        R.extend(Q), l.translations = R
                    }
                    return l
                }, D.prototype.reset = function () {
                    function b(a) {
                        function b(a) {
                            return l[a] || a
                        }

                        return a.replace(/[^\u0000-\u007E]/g, b)
                    }

                    function c(d, e) {
                        if ("" === a.trim(d.term)) return e;
                        if (e.children && e.children.length > 0) {
                            for (var f = a.extend(!0, {}, e), g = e.children.length - 1; g >= 0; g--) {
                                var h = e.children[g], i = c(d, h);
                                null == i && f.children.splice(g, 1)
                            }
                            return f.children.length > 0 ? f : c(d, f)
                        }
                        var j = b(e.text).toUpperCase(), k = b(d.term).toUpperCase();
                        return j.indexOf(k) > -1 ? e : null
                    }

                    this.defaults = {
                        amdBase: "./",
                        amdLanguageBase: "./i18n/",
                        closeOnSelect: !0,
                        debug: !1,
                        dropdownAutoWidth: !1,
                        escapeMarkup: j.escapeMarkup,
                        language: C,
                        matcher: c,
                        minimumInputLength: 0,
                        maximumInputLength: 0,
                        maximumSelectionLength: 0,
                        minimumResultsForSearch: 0,
                        selectOnClose: !1,
                        sorter: function (a) {
                            return a
                        },
                        templateResult: function (a) {
                            return a.text
                        },
                        templateSelection: function (a) {
                            return a.text
                        },
                        theme: "default",
                        width: "resolve"
                    }
                }, D.prototype.set = function (b, c) {
                    var d = a.camelCase(b), e = {};
                    e[d] = c;
                    var f = j._convertData(e);
                    a.extend(this.defaults, f)
                };
                var E = new D;
                return E
            }), b.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (a, b, c, d) {
                function e(b, e) {
                    if (this.options = b, null != e && this.fromElement(e), this.options = c.apply(this.options), e && e.is("input")) {
                        var f = a(this.get("amdBase") + "compat/inputData");
                        this.options.dataAdapter = d.Decorate(this.options.dataAdapter, f)
                    }
                }

                return e.prototype.fromElement = function (a) {
                    var c = ["select2"];
                    null == this.options.multiple && (this.options.multiple = a.prop("multiple")), null == this.options.disabled && (this.options.disabled = a.prop("disabled")), null == this.options.language && (a.prop("lang") ? this.options.language = a.prop("lang").toLowerCase() : a.closest("[lang]").prop("lang") && (this.options.language = a.closest("[lang]").prop("lang"))), null == this.options.dir && (a.prop("dir") ? this.options.dir = a.prop("dir") : a.closest("[dir]").prop("dir") ? this.options.dir = a.closest("[dir]").prop("dir") : this.options.dir = "ltr"), a.prop("disabled", this.options.disabled), a.prop("multiple", this.options.multiple), a.data("select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), a.data("data", a.data("select2Tags")), a.data("tags", !0)), a.data("ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), a.attr("ajax--url", a.data("ajaxUrl")), a.data("ajax--url", a.data("ajaxUrl")));
                    var e = {};
                    e = b.fn.jquery && "1." == b.fn.jquery.substr(0, 2) && a[0].dataset ? b.extend(!0, {}, a[0].dataset, a.data()) : a.data();
                    var f = b.extend(!0, {}, e);
                    f = d._convertData(f);
                    for (var g in f) b.inArray(g, c) > -1 || (b.isPlainObject(this.options[g]) ? b.extend(this.options[g], f[g]) : this.options[g] = f[g]);
                    return this
                }, e.prototype.get = function (a) {
                    return this.options[a]
                }, e.prototype.set = function (a, b) {
                    this.options[a] = b
                }, e
            }), b.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (a, b, c, d) {
                var e = function (a, c) {
                    null != a.data("select2") && a.data("select2").destroy(), this.$element = a, this.id = this._generateId(a), c = c || {}, this.options = new b(c, a), e.__super__.constructor.call(this);
                    var d = a.attr("tabindex") || 0;
                    a.data("old-tabindex", d), a.attr("tabindex", "-1");
                    var f = this.options.get("dataAdapter");
                    this.dataAdapter = new f(a, this.options);
                    var g = this.render();
                    this._placeContainer(g);
                    var h = this.options.get("selectionAdapter");
                    this.selection = new h(a, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, g);
                    var i = this.options.get("dropdownAdapter");
                    this.dropdown = new i(a, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, g);
                    var j = this.options.get("resultsAdapter");
                    this.results = new j(a, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
                    var k = this;
                    this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function (a) {
                        k.trigger("selection:update", {data: a})
                    }), a.addClass("select2-hidden-accessible"), a.attr("aria-hidden", "true"), this._syncAttributes(), a.data("select2", this)
                };
                return c.Extend(e, c.Observable), e.prototype._generateId = function (a) {
                    var b = "";
                    return b = null != a.attr("id") ? a.attr("id") : null != a.attr("name") ? a.attr("name") + "-" + c.generateChars(2) : c.generateChars(4), b = b.replace(/(:|\.|\[|\]|,)/g, ""), b = "select2-" + b
                }, e.prototype._placeContainer = function (a) {
                    a.insertAfter(this.$element);
                    var b = this._resolveWidth(this.$element, this.options.get("width"));
                    null != b && a.css("width", b)
                }, e.prototype._resolveWidth = function (a, b) {
                    var c = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                    if ("resolve" == b) {
                        var d = this._resolveWidth(a, "style");
                        return null != d ? d : this._resolveWidth(a, "element")
                    }
                    if ("element" == b) {
                        var e = a.outerWidth(!1);
                        return 0 >= e ? "auto" : e + "px"
                    }
                    if ("style" == b) {
                        var f = a.attr("style");
                        if ("string" != typeof f) return null;
                        for (var g = f.split(";"), h = 0, i = g.length; i > h; h += 1) {
                            var j = g[h].replace(/\s/g, ""), k = j.match(c);
                            if (null !== k && k.length >= 1) return k[1]
                        }
                        return null
                    }
                    return b
                }, e.prototype._bindAdapters = function () {
                    this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
                }, e.prototype._registerDomEvents = function () {
                    var b = this;
                    this.$element.on("change.select2", function () {
                        b.dataAdapter.current(function (a) {
                            b.trigger("selection:update", {data: a})
                        })
                    }), this.$element.on("focus.select2", function (a) {
                        b.trigger("focus", a)
                    }), this._syncA = c.bind(this._syncAttributes, this), this._syncS = c.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                    var d = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                    null != d ? (this._observer = new d(function (c) {
                        a.each(c, b._syncA), a.each(c, b._syncS)
                    }), this._observer.observe(this.$element[0], {
                        attributes: !0,
                        childList: !0,
                        subtree: !1
                    })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", b._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", b._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", b._syncS, !1))
                }, e.prototype._registerDataEvents = function () {
                    var a = this;
                    this.dataAdapter.on("*", function (b, c) {
                        a.trigger(b, c)
                    })
                }, e.prototype._registerSelectionEvents = function () {
                    var b = this, c = ["toggle", "focus"];
                    this.selection.on("toggle", function () {
                        b.toggleDropdown()
                    }), this.selection.on("focus", function (a) {
                        b.focus(a)
                    }), this.selection.on("*", function (d, e) {
                        -1 === a.inArray(d, c) && b.trigger(d, e)
                    })
                }, e.prototype._registerDropdownEvents = function () {
                    var a = this;
                    this.dropdown.on("*", function (b, c) {
                        a.trigger(b, c)
                    })
                }, e.prototype._registerResultsEvents = function () {
                    var a = this;
                    this.results.on("*", function (b, c) {
                        a.trigger(b, c)
                    })
                }, e.prototype._registerEvents = function () {
                    var a = this;
                    this.on("open", function () {
                        a.$container.addClass("select2-container--open")
                    }), this.on("close", function () {
                        a.$container.removeClass("select2-container--open")
                    }), this.on("enable", function () {
                        a.$container.removeClass("select2-container--disabled")
                    }), this.on("disable", function () {
                        a.$container.addClass("select2-container--disabled")
                    }), this.on("blur", function () {
                        a.$container.removeClass("select2-container--focus")
                    }), this.on("query", function (b) {
                        a.isOpen() || a.trigger("open", {}), this.dataAdapter.query(b, function (c) {
                            a.trigger("results:all", {data: c, query: b})
                        })
                    }), this.on("query:append", function (b) {
                        this.dataAdapter.query(b, function (c) {
                            a.trigger("results:append", {data: c, query: b})
                        })
                    }), this.on("keypress", function (b) {
                        var c = b.which;
                        a.isOpen() ? c === d.ESC || c === d.TAB || c === d.UP && b.altKey ? (a.close(), b.preventDefault()) : c === d.ENTER ? (a.trigger("results:select", {}), b.preventDefault()) : c === d.SPACE && b.ctrlKey ? (a.trigger("results:toggle", {}), b.preventDefault()) : c === d.UP ? (a.trigger("results:previous", {}), b.preventDefault()) : c === d.DOWN && (a.trigger("results:next", {}), b.preventDefault()) : (c === d.ENTER || c === d.SPACE || c === d.DOWN && b.altKey) && (a.open(), b.preventDefault())
                    })
                }, e.prototype._syncAttributes = function () {
                    this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
                }, e.prototype._syncSubtree = function (a, b) {
                    var c = !1, d = this;
                    if (!a || !a.target || "OPTION" === a.target.nodeName || "OPTGROUP" === a.target.nodeName) {
                        if (b) if (b.addedNodes && b.addedNodes.length > 0) for (var e = 0; e < b.addedNodes.length; e++) {
                            var f = b.addedNodes[e];
                            f.selected && (c = !0)
                        } else b.removedNodes && b.removedNodes.length > 0 && (c = !0); else c = !0;
                        c && this.dataAdapter.current(function (a) {
                            d.trigger("selection:update", {data: a})
                        })
                    }
                }, e.prototype.trigger = function (a, b) {
                    var c = e.__super__.trigger,
                        d = {open: "opening", close: "closing", select: "selecting", unselect: "unselecting"};
                    if (void 0 === b && (b = {}), a in d) {
                        var f = d[a], g = {prevented: !1, name: a, args: b};
                        if (c.call(this, f, g), g.prevented) return void (b.prevented = !0)
                    }
                    c.call(this, a, b)
                }, e.prototype.toggleDropdown = function () {
                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
                }, e.prototype.open = function () {
                    this.isOpen() || this.trigger("query", {})
                }, e.prototype.close = function () {
                    this.isOpen() && this.trigger("close", {})
                }, e.prototype.isOpen = function () {
                    return this.$container.hasClass("select2-container--open")
                }, e.prototype.hasFocus = function () {
                    return this.$container.hasClass("select2-container--focus")
                }, e.prototype.focus = function (a) {
                    this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
                }, e.prototype.enable = function (a) {
                    this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), (null == a || 0 === a.length) && (a = [!0]);
                    var b = !a[0];
                    this.$element.prop("disabled", b)
                }, e.prototype.data = function () {
                    this.options.get("debug") && arguments.length > 0 && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                    var a = [];
                    return this.dataAdapter.current(function (b) {
                        a = b
                    }), a
                }, e.prototype.val = function (b) {
                    if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == b || 0 === b.length) return this.$element.val();
                    var c = b[0];
                    a.isArray(c) && (c = a.map(c, function (a) {
                        return a.toString()
                    })), this.$element.val(c).trigger("change")
                }, e.prototype.destroy = function () {
                    this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", this.$element.data("old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null;
                }, e.prototype.render = function () {
                    var b = a('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                    return b.attr("dir", this.options.get("dir")), this.$container = b, this.$container.addClass("select2-container--" + this.options.get("theme")), b.data("element", this.$element), b
                }, e
            }), b.define("jquery-mousewheel", ["jquery"], function (a) {
                return a
            }), b.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults"], function (a, b, c, d) {
                if (null == a.fn.select2) {
                    var e = ["open", "close", "destroy"];
                    a.fn.select2 = function (b) {
                        if (b = b || {}, "object" == typeof b) return this.each(function () {
                            var d = a.extend(!0, {}, b);
                            new c(a(this), d)
                        }), this;
                        if ("string" == typeof b) {
                            var d, f = Array.prototype.slice.call(arguments, 1);
                            return this.each(function () {
                                var c = a(this).data("select2");
                                null == c && window.console && console.error && console.error("The select2('" + b + "') method was called on an element that is not using Select2."), d = c[b].apply(c, f)
                            }), a.inArray(b, e) > -1 ? this : d
                        }
                        throw new Error("Invalid arguments for Select2: " + b)
                    }
                }
                return null == a.fn.select2.defaults && (a.fn.select2.defaults = d), c
            }), {define: b.define, require: b.require}
        }(), c = b.require("jquery.select2");
        return a.fn.select2.amd = b, c
    });

    /* js cookie */
    !function (e) {
        var o;
        if ("function" == typeof define && define.amd) define(["jquery"], e); else if ("object" == typeof exports) {
            try {
                o = require("jquery")
            } catch (e) {
            }
            module.exports = e(o)
        } else {
            var n = window.Cookies, r = window.Cookies = e(window.jQuery);
            r.noConflict = function () {
                return window.Cookies = n, r
            }
        }
    }(function (e) {
        var o = /\+/g;

        function n(e) {
            return c.raw ? e : encodeURIComponent(e)
        }

        function r(e, n) {
            var r = c.raw ? e : function (e) {
                0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
                try {
                    return e = decodeURIComponent(e.replace(o, " ")), c.json ? JSON.parse(e) : e
                } catch (e) {
                }
            }(e);
            return i(n) ? n(r) : r
        }

        function t() {
            for (var e, o, n = 0, r = {}; n < arguments.length; n++) for (e in o = arguments[n]) r[e] = o[e];
            return r
        }

        function i(e) {
            return "[object Function]" === Object.prototype.toString.call(e)
        }

        var c = function (e, o, u) {
            if (arguments.length > 1 && !i(o)) {
                if ("number" == typeof (u = t(c.defaults, u)).expires) {
                    var s = u.expires, f = u.expires = new Date;
                    f.setMilliseconds(f.getMilliseconds() + 864e5 * s)
                }
                return document.cookie = [n(e), "=", (a = o, n(c.json ? JSON.stringify(a) : String(a))), u.expires ? "; expires=" + u.expires.toUTCString() : "", u.path ? "; path=" + u.path : "", u.domain ? "; domain=" + u.domain : "", u.secure ? "; secure" : ""].join("")
            }
            for (var a, d, p = e ? void 0 : {}, l = document.cookie ? document.cookie.split("; ") : [], m = 0, v = l.length; m < v; m++) {
                var g = l[m].split("="), w = (d = g.shift(), c.raw ? d : decodeURIComponent(d)), j = g.join("=");
                if (e === w) {
                    p = r(j, o);
                    break
                }
                e || void 0 === (j = r(j)) || (p[w] = j)
            }
            return p
        };
        return c.get = c.set = c, c.defaults = {}, c.remove = function (e, o) {
            return c(e, "", t(o, {expires: -1})), !c(e)
        }, e && (e.cookie = c, e.removeCookie = c.remove), c
    });

    /**
     * BxSlider v4.1.2 - Fully loaded, responsive content slider
     * http://bxslider.com
     *
     * Copyright 2014, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
     * Written while drinking Belgian ales and listening to jazz
     *
     * Released under the MIT license - http://opensource.org/licenses/MIT
     */
    !function (t) {
        var e = {}, s = {
            mode: "horizontal",
            slideSelector: "",
            infiniteLoop: !0,
            hideControlOnEnd: !1,
            speed: 500,
            easing: null,
            slideMargin: 0,
            startSlide: 0,
            randomStart: !1,
            captions: !1,
            ticker: !1,
            tickerHover: !1,
            adaptiveHeight: !1,
            adaptiveHeightSpeed: 500,
            video: !1,
            useCSS: !0,
            preloadImages: "visible",
            responsive: !0,
            slideZIndex: 50,
            touchEnabled: !0,
            swipeThreshold: 50,
            oneToOneTouch: !0,
            preventDefaultSwipeX: !0,
            preventDefaultSwipeY: !1,
            pager: !0,
            pagerType: "full",
            pagerShortSeparator: " / ",
            pagerSelector: null,
            buildPager: null,
            pagerCustom: null,
            controls: !0,
            nextText: "Next",
            prevText: "Prev",
            nextSelector: null,
            prevSelector: null,
            autoControls: !1,
            startText: "Start",
            stopText: "Stop",
            autoControlsCombine: !1,
            autoControlsSelector: null,
            auto: !1,
            pause: 4e3,
            autoStart: !0,
            autoDirection: "next",
            autoHover: !1,
            autoDelay: 0,
            minSlides: 1,
            maxSlides: 1,
            moveSlides: 0,
            slideWidth: 0,
            onSliderLoad: function () {
            },
            onSlideBefore: function () {
            },
            onSlideAfter: function () {
            },
            onSlideNext: function () {
            },
            onSlidePrev: function () {
            },
            onSliderResize: function () {
            }
        };
        t.fn.bxSlider = function (n) {
            if (0 == this.length) return this;
            if (this.length > 1) return this.each(function () {
                t(this).bxSlider(n)
            }), this;
            var o = {}, r = this;
            e.el = this;
            var a = t(window).width(), l = t(window).height(), d = function () {
                o.settings = t.extend({}, s, n), o.settings.slideWidth = parseInt(o.settings.slideWidth), o.children = r.children(o.settings.slideSelector), o.children.length < o.settings.minSlides && (o.settings.minSlides = o.children.length), o.children.length < o.settings.maxSlides && (o.settings.maxSlides = o.children.length), o.settings.randomStart && (o.settings.startSlide = Math.floor(Math.random() * o.children.length)), o.active = {index: o.settings.startSlide}, o.carousel = o.settings.minSlides > 1 || o.settings.maxSlides > 1, o.carousel && (o.settings.preloadImages = "all"), o.minThreshold = o.settings.minSlides * o.settings.slideWidth + (o.settings.minSlides - 1) * o.settings.slideMargin, o.maxThreshold = o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin, o.working = !1, o.controls = {}, o.interval = null, o.animProp = "vertical" == o.settings.mode ? "top" : "left", o.usingCSS = o.settings.useCSS && "fade" != o.settings.mode && function () {
                    var t = document.createElement("div"),
                        e = ["WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                    for (var i in e) if (void 0 !== t.style[e[i]]) return o.cssPrefix = e[i].replace("Perspective", "").toLowerCase(), o.animProp = "-" + o.cssPrefix + "-transform", !0;
                    return !1
                }(), "vertical" == o.settings.mode && (o.settings.maxSlides = o.settings.minSlides), r.data("origStyle", r.attr("style")), r.children(o.settings.slideSelector).each(function () {
                    t(this).data("origStyle", t(this).attr("style"))
                }), c()
            }, c = function () {
                r.wrap('<div class="bx-wrapper"><div class="bx-viewport"></div></div>'), o.viewport = r.parent(), o.loader = t('<div class="bx-loading" />'), o.viewport.prepend(o.loader), r.css({
                    width: "horizontal" == o.settings.mode ? 100 * o.children.length + 215 + "%" : "auto",
                    position: "relative"
                }), o.usingCSS && o.settings.easing ? r.css("-" + o.cssPrefix + "-transition-timing-function", o.settings.easing) : o.settings.easing || (o.settings.easing = "swing"), f(), o.viewport.css({
                    width: "100%",
                    overflow: "hidden",
                    position: "relative"
                }), o.viewport.parent().css({maxWidth: p()}), o.settings.pager || o.viewport.parent().css({margin: "0 auto 0px"}), o.children.css({
                    "float": "horizontal" == o.settings.mode ? "left" : "none",
                    listStyle: "none",
                    position: "relative"
                }), o.children.css("width", u()), "horizontal" == o.settings.mode && o.settings.slideMargin > 0 && o.children.css("marginRight", o.settings.slideMargin), "vertical" == o.settings.mode && o.settings.slideMargin > 0 && o.children.css("marginBottom", o.settings.slideMargin), "fade" == o.settings.mode && (o.children.css({
                    position: "absolute",
                    zIndex: 0,
                    display: "none"
                }), o.children.eq(o.settings.startSlide).css({
                    zIndex: o.settings.slideZIndex,
                    display: "block"
                })), o.controls.el = t('<div class="bx-controls" />'), o.settings.captions && P(), o.active.last = o.settings.startSlide == x() - 1, o.settings.video && r.fitVids();
                var e = o.children.eq(o.settings.startSlide);
                "all" == o.settings.preloadImages && (e = o.children), o.settings.ticker ? o.settings.pager = !1 : (o.settings.pager && T(), o.settings.controls && C(), o.settings.auto && o.settings.autoControls && E(), (o.settings.controls || o.settings.autoControls || o.settings.pager) && o.viewport.after(o.controls.el)), g(e, h)
            }, g = function (e, i) {
                var s = e.find("img, iframe").length;
                if (0 == s) return i(), void 0;
                var n = 0;
                e.find("img, iframe").each(function () {
                    t(this).one("load", function () {
                        ++n == s && i()
                    }).each(function () {
                        this.complete && t(this).load()
                    })
                })
            }, h = function () {
                if (o.settings.infiniteLoop && "fade" != o.settings.mode && !o.settings.ticker) {
                    var e = "vertical" == o.settings.mode ? o.settings.minSlides : o.settings.maxSlides,
                        i = o.children.slice(0, e).clone().addClass("bx-clone"),
                        s = o.children.slice(-e).clone().addClass("bx-clone");
                    r.append(i).prepend(s)
                }
                o.loader.remove(), S(), "vertical" == o.settings.mode && (o.settings.adaptiveHeight = !0), o.viewport.height(v()), r.redrawSlider(), o.settings.onSliderLoad(o.active.index), o.initialized = !0, o.settings.responsive && t(window).bind("resize", Z), o.settings.auto && o.settings.autoStart && H(), o.settings.ticker && L(), o.settings.pager && q(o.settings.startSlide), o.settings.controls && W(), o.settings.touchEnabled && !o.settings.ticker && O()
            }, v = function () {
                var e = 0, s = t();
                if ("vertical" == o.settings.mode || o.settings.adaptiveHeight) if (o.carousel) {
                    var n = 1 == o.settings.moveSlides ? o.active.index : o.active.index * m();
                    for (s = o.children.eq(n), i = 1; i <= o.settings.maxSlides - 1; i++) s = n + i >= o.children.length ? s.add(o.children.eq(i - 1)) : s.add(o.children.eq(n + i))
                } else s = o.children.eq(o.active.index); else s = o.children;
                return "vertical" == o.settings.mode ? (s.each(function () {
                    e += t(this).outerHeight()
                }), o.settings.slideMargin > 0 && (e += o.settings.slideMargin * (o.settings.minSlides - 1))) : e = Math.max.apply(Math, s.map(function () {
                    return t(this).outerHeight(!1)
                }).get()), e
            }, p = function () {
                var t = "100%";
                return o.settings.slideWidth > 0 && (t = "horizontal" == o.settings.mode ? o.settings.maxSlides * o.settings.slideWidth + (o.settings.maxSlides - 1) * o.settings.slideMargin : o.settings.slideWidth), t
            }, u = function () {
                var t = o.settings.slideWidth, e = o.viewport.width();
                return 0 == o.settings.slideWidth || o.settings.slideWidth > e && !o.carousel || "vertical" == o.settings.mode ? t = e : o.settings.maxSlides > 1 && "horizontal" == o.settings.mode && (e > o.maxThreshold || e < o.minThreshold && (t = (e - o.settings.slideMargin * (o.settings.minSlides - 1)) / o.settings.minSlides)), t
            }, f = function () {
                var t = 1;
                if ("horizontal" == o.settings.mode && o.settings.slideWidth > 0) if (o.viewport.width() < o.minThreshold) t = o.settings.minSlides; else if (o.viewport.width() > o.maxThreshold) t = o.settings.maxSlides; else {
                    var e = o.children.first().width();
                    t = Math.floor(o.viewport.width() / e)
                } else "vertical" == o.settings.mode && (t = o.settings.minSlides);
                return t
            }, x = function () {
                var t = 0;
                if (o.settings.moveSlides > 0) if (o.settings.infiniteLoop) t = o.children.length / m(); else for (var e = 0, i = 0; e < o.children.length;) ++t, e = i + f(), i += o.settings.moveSlides <= f() ? o.settings.moveSlides : f(); else t = Math.ceil(o.children.length / f());
                return t
            }, m = function () {
                return o.settings.moveSlides > 0 && o.settings.moveSlides <= f() ? o.settings.moveSlides : f()
            }, S = function () {
                if (o.children.length > o.settings.maxSlides && o.active.last && !o.settings.infiniteLoop) {
                    if ("horizontal" == o.settings.mode) {
                        var t = o.children.last(), e = t.position();
                        b(-(e.left - (o.viewport.width() - t.width())), "reset", 0)
                    } else if ("vertical" == o.settings.mode) {
                        var i = o.children.length - o.settings.minSlides, e = o.children.eq(i).position();
                        b(-e.top, "reset", 0)
                    }
                } else {
                    var e = o.children.eq(o.active.index * m()).position();
                    o.active.index == x() - 1 && (o.active.last = !0), void 0 != e && ("horizontal" == o.settings.mode ? b(-e.left, "reset", 0) : "vertical" == o.settings.mode && b(-e.top, "reset", 0))
                }
            }, b = function (t, e, i, s) {
                if (o.usingCSS) {
                    var n = "vertical" == o.settings.mode ? "translate3d(0, " + t + "px, 0)" : "translate3d(" + t + "px, 0, 0)";
                    r.css("-" + o.cssPrefix + "-transition-duration", i / 1e3 + "s"), "slide" == e ? (r.css(o.animProp, n), r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
                        r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), D()
                    })) : "reset" == e ? r.css(o.animProp, n) : "ticker" == e && (r.css("-" + o.cssPrefix + "-transition-timing-function", "linear"), r.css(o.animProp, n), r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
                        r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"), b(s.resetValue, "reset", 0), N()
                    }))
                } else {
                    var a = {};
                    a[o.animProp] = t, "slide" == e ? r.animate(a, i, o.settings.easing, function () {
                        D()
                    }) : "reset" == e ? r.css(o.animProp, t) : "ticker" == e && r.animate(a, speed, "linear", function () {
                        b(s.resetValue, "reset", 0), N()
                    })
                }
            }, w = function () {
                for (var e = "", i = x(), s = 0; i > s; s++) {
                    var n = "";
                    o.settings.buildPager && t.isFunction(o.settings.buildPager) ? (n = o.settings.buildPager(s), o.pagerEl.addClass("bx-custom-pager")) : (n = s + 1, o.pagerEl.addClass("bx-default-pager")), e += '<div class="bx-pager-item"><a href="" data-slide-index="' + s + '" class="bx-pager-link">' + n + "</a></div>"
                }
                o.pagerEl.html(e)
            }, T = function () {
                o.settings.pagerCustom ? o.pagerEl = t(o.settings.pagerCustom) : (o.pagerEl = t('<div class="bx-pager" />'), o.settings.pagerSelector ? t(o.settings.pagerSelector).html(o.pagerEl) : o.controls.el.addClass("bx-has-pager").append(o.pagerEl), w()), o.pagerEl.on("click", "a", I)
            }, C = function () {
                o.controls.next = t('<a class="bx-next" href="">' + o.settings.nextText + "</a>"), o.controls.prev = t('<a class="bx-prev" href="">' + o.settings.prevText + "</a>"), o.controls.next.bind("click", y), o.controls.prev.bind("click", z), o.settings.nextSelector && t(o.settings.nextSelector).append(o.controls.next), o.settings.prevSelector && t(o.settings.prevSelector).append(o.controls.prev), o.settings.nextSelector || o.settings.prevSelector || (o.controls.directionEl = t('<div class="bx-controls-direction" />'), o.controls.directionEl.append(o.controls.prev).append(o.controls.next), o.controls.el.addClass("bx-has-controls-direction").append(o.controls.directionEl))
            }, E = function () {
                o.controls.start = t('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + o.settings.startText + "</a></div>"), o.controls.stop = t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + o.settings.stopText + "</a></div>"), o.controls.autoEl = t('<div class="bx-controls-auto" />'), o.controls.autoEl.on("click", ".bx-start", k), o.controls.autoEl.on("click", ".bx-stop", M), o.settings.autoControlsCombine ? o.controls.autoEl.append(o.controls.start) : o.controls.autoEl.append(o.controls.start).append(o.controls.stop), o.settings.autoControlsSelector ? t(o.settings.autoControlsSelector).html(o.controls.autoEl) : o.controls.el.addClass("bx-has-controls-auto").append(o.controls.autoEl), A(o.settings.autoStart ? "stop" : "start")
            }, P = function () {
                o.children.each(function () {
                    var e = t(this).find("img:first").attr("title");
                    void 0 != e && ("" + e).length && t(this).append('<div class="bx-caption"><span>' + e + "</span></div>")
                })
            }, y = function (t) {
                o.settings.auto && r.stopAuto(), r.goToNextSlide(), t.preventDefault()
            }, z = function (t) {
                o.settings.auto && r.stopAuto(), r.goToPrevSlide(), t.preventDefault()
            }, k = function (t) {
                r.startAuto(), t.preventDefault()
            }, M = function (t) {
                r.stopAuto(), t.preventDefault()
            }, I = function (e) {
                o.settings.auto && r.stopAuto();
                var i = t(e.currentTarget), s = parseInt(i.attr("data-slide-index"));
                s != o.active.index && r.goToSlide(s), e.preventDefault()
            }, q = function (e) {
                var i = o.children.length;
                return "short" == o.settings.pagerType ? (o.settings.maxSlides > 1 && (i = Math.ceil(o.children.length / o.settings.maxSlides)), o.pagerEl.html(e + 1 + o.settings.pagerShortSeparator + i), void 0) : (o.pagerEl.find("a").removeClass("active"), o.pagerEl.each(function (i, s) {
                    t(s).find("a").eq(e).addClass("active")
                }), void 0)
            }, D = function () {
                if (o.settings.infiniteLoop) {
                    var t = "";
                    0 == o.active.index ? t = o.children.eq(0).position() : o.active.index == x() - 1 && o.carousel ? t = o.children.eq((x() - 1) * m()).position() : o.active.index == o.children.length - 1 && (t = o.children.eq(o.children.length - 1).position()), t && ("horizontal" == o.settings.mode ? b(-t.left, "reset", 0) : "vertical" == o.settings.mode && b(-t.top, "reset", 0))
                }
                o.working = !1, o.settings.onSlideAfter(o.children.eq(o.active.index), o.oldIndex, o.active.index)
            }, A = function (t) {
                o.settings.autoControlsCombine ? o.controls.autoEl.html(o.controls[t]) : (o.controls.autoEl.find("a").removeClass("active"), o.controls.autoEl.find("a:not(.bx-" + t + ")").addClass("active"))
            }, W = function () {
                1 == x() ? (o.controls.prev.addClass("disabled"), o.controls.next.addClass("disabled")) : !o.settings.infiniteLoop && o.settings.hideControlOnEnd && (0 == o.active.index ? (o.controls.prev.addClass("disabled"), o.controls.next.removeClass("disabled")) : o.active.index == x() - 1 ? (o.controls.next.addClass("disabled"), o.controls.prev.removeClass("disabled")) : (o.controls.prev.removeClass("disabled"), o.controls.next.removeClass("disabled")))
            }, H = function () {
                o.settings.autoDelay > 0 ? setTimeout(r.startAuto, o.settings.autoDelay) : r.startAuto(), o.settings.autoHover && r.hover(function () {
                    o.interval && (r.stopAuto(!0), o.autoPaused = !0)
                }, function () {
                    o.autoPaused && (r.startAuto(!0), o.autoPaused = null)
                })
            }, L = function () {
                var e = 0;
                if ("next" == o.settings.autoDirection) r.append(o.children.clone().addClass("bx-clone")); else {
                    r.prepend(o.children.clone().addClass("bx-clone"));
                    var i = o.children.first().position();
                    e = "horizontal" == o.settings.mode ? -i.left : -i.top
                }
                b(e, "reset", 0), o.settings.pager = !1, o.settings.controls = !1, o.settings.autoControls = !1, o.settings.tickerHover && !o.usingCSS && o.viewport.hover(function () {
                    r.stop()
                }, function () {
                    var e = 0;
                    o.children.each(function () {
                        e += "horizontal" == o.settings.mode ? t(this).outerWidth(!0) : t(this).outerHeight(!0)
                    });
                    var i = o.settings.speed / e, s = "horizontal" == o.settings.mode ? "left" : "top",
                        n = i * (e - Math.abs(parseInt(r.css(s))));
                    N(n)
                }), N()
            }, N = function (t) {
                speed = t ? t : o.settings.speed;
                var e = {left: 0, top: 0}, i = {left: 0, top: 0};
                "next" == o.settings.autoDirection ? e = r.find(".bx-clone").first().position() : i = o.children.first().position();
                var s = "horizontal" == o.settings.mode ? -e.left : -e.top,
                    n = "horizontal" == o.settings.mode ? -i.left : -i.top, a = {resetValue: n};
                b(s, "ticker", speed, a)
            }, O = function () {
                o.touch = {start: {x: 0, y: 0}, end: {x: 0, y: 0}}, o.viewport.bind("touchstart", X)
            }, X = function (t) {
                if (o.working) t.preventDefault(); else {
                    o.touch.originalPos = r.position();
                    var e = t.originalEvent;
                    o.touch.start.x = e.changedTouches[0].pageX, o.touch.start.y = e.changedTouches[0].pageY, o.viewport.bind("touchmove", Y), o.viewport.bind("touchend", V)
                }
            }, Y = function (t) {
                var e = t.originalEvent, i = Math.abs(e.changedTouches[0].pageX - o.touch.start.x),
                    s = Math.abs(e.changedTouches[0].pageY - o.touch.start.y);
                if (3 * i > s && o.settings.preventDefaultSwipeX ? t.preventDefault() : 3 * s > i && o.settings.preventDefaultSwipeY && t.preventDefault(), "fade" != o.settings.mode && o.settings.oneToOneTouch) {
                    var n = 0;
                    if ("horizontal" == o.settings.mode) {
                        var r = e.changedTouches[0].pageX - o.touch.start.x;
                        n = o.touch.originalPos.left + r
                    } else {
                        var r = e.changedTouches[0].pageY - o.touch.start.y;
                        n = o.touch.originalPos.top + r
                    }
                    b(n, "reset", 0)
                }
            }, V = function (t) {
                o.viewport.unbind("touchmove", Y);
                var e = t.originalEvent, i = 0;
                if (o.touch.end.x = e.changedTouches[0].pageX, o.touch.end.y = e.changedTouches[0].pageY, "fade" == o.settings.mode) {
                    var s = Math.abs(o.touch.start.x - o.touch.end.x);
                    s >= o.settings.swipeThreshold && (o.touch.start.x > o.touch.end.x ? r.goToNextSlide() : r.goToPrevSlide(), r.stopAuto())
                } else {
                    var s = 0;
                    "horizontal" == o.settings.mode ? (s = o.touch.end.x - o.touch.start.x, i = o.touch.originalPos.left) : (s = o.touch.end.y - o.touch.start.y, i = o.touch.originalPos.top), !o.settings.infiniteLoop && (0 == o.active.index && s > 0 || o.active.last && 0 > s) ? b(i, "reset", 200) : Math.abs(s) >= o.settings.swipeThreshold ? (0 > s ? r.goToNextSlide() : r.goToPrevSlide(), r.stopAuto()) : b(i, "reset", 200)
                }
                o.viewport.unbind("touchend", V)
            }, Z = function () {
                var e = t(window).width(), i = t(window).height();
                (a != e || l != i) && (a = e, l = i, r.redrawSlider(), o.settings.onSliderResize.call(r, o.active.index))
            };
            return r.goToSlide = function (e, i) {
                if (!o.working && o.active.index != e) if (o.working = !0, o.oldIndex = o.active.index, o.active.index = 0 > e ? x() - 1 : e >= x() ? 0 : e, o.settings.onSlideBefore(o.children.eq(o.active.index), o.oldIndex, o.active.index), "next" == i ? o.settings.onSlideNext(o.children.eq(o.active.index), o.oldIndex, o.active.index) : "prev" == i && o.settings.onSlidePrev(o.children.eq(o.active.index), o.oldIndex, o.active.index), o.active.last = o.active.index >= x() - 1, o.settings.pager && q(o.active.index), o.settings.controls && W(), "fade" == o.settings.mode) o.settings.adaptiveHeight && o.viewport.height() != v() && o.viewport.animate({height: v()}, o.settings.adaptiveHeightSpeed), o.children.filter(":visible").fadeOut(o.settings.speed).css({zIndex: 0}), o.children.eq(o.active.index).css("zIndex", o.settings.slideZIndex + 1).fadeIn(o.settings.speed, function () {
                    t(this).css("zIndex", o.settings.slideZIndex), D()
                }); else {
                    o.settings.adaptiveHeight && o.viewport.height() != v() && o.viewport.animate({height: v()}, o.settings.adaptiveHeightSpeed);
                    var s = 0, n = {left: 0, top: 0};
                    if (!o.settings.infiniteLoop && o.carousel && o.active.last) if ("horizontal" == o.settings.mode) {
                        var a = o.children.eq(o.children.length - 1);
                        n = a.position(), s = o.viewport.width() - a.outerWidth()
                    } else {
                        var l = o.children.length - o.settings.minSlides;
                        n = o.children.eq(l).position()
                    } else if (o.carousel && o.active.last && "prev" == i) {
                        var d = 1 == o.settings.moveSlides ? o.settings.maxSlides - m() : (x() - 1) * m() - (o.children.length - o.settings.maxSlides),
                            a = r.children(".bx-clone").eq(d);
                        n = a.position()
                    } else if ("next" == i && 0 == o.active.index) n = r.find("> .bx-clone").eq(o.settings.maxSlides).position(), o.active.last = !1; else if (e >= 0) {
                        var c = e * m();
                        n = o.children.eq(c).position()
                    }
                    if ("undefined" != typeof n) {
                        var g = "horizontal" == o.settings.mode ? -(n.left - s) : -n.top;
                        b(g, "slide", o.settings.speed)
                    }
                }
            }, r.goToNextSlide = function () {
                if (o.settings.infiniteLoop || !o.active.last) {
                    var t = parseInt(o.active.index) + 1;
                    r.goToSlide(t, "next")
                }
            }, r.goToPrevSlide = function () {
                if (o.settings.infiniteLoop || 0 != o.active.index) {
                    var t = parseInt(o.active.index) - 1;
                    r.goToSlide(t, "prev")
                }
            }, r.startAuto = function (t) {
                o.interval || (o.interval = setInterval(function () {
                    "next" == o.settings.autoDirection ? r.goToNextSlide() : r.goToPrevSlide()
                }, o.settings.pause), o.settings.autoControls && 1 != t && A("stop"))
            }, r.stopAuto = function (t) {
                o.interval && (clearInterval(o.interval), o.interval = null, o.settings.autoControls && 1 != t && A("start"))
            }, r.getCurrentSlide = function () {
                return o.active.index
            }, r.getCurrentSlideElement = function () {
                return o.children.eq(o.active.index)
            }, r.getSlideCount = function () {
                return o.children.length
            }, r.redrawSlider = function () {
                o.children.add(r.find(".bx-clone")).outerWidth(u()), o.viewport.css("height", v()), o.settings.ticker || S(), o.active.last && (o.active.index = x() - 1), o.active.index >= x() && (o.active.last = !0), o.settings.pager && !o.settings.pagerCustom && (w(), q(o.active.index))
            }, r.destroySlider = function () {
                o.initialized && (o.initialized = !1, t(".bx-clone", this).remove(), o.children.each(function () {
                    void 0 != t(this).data("origStyle") ? t(this).attr("style", t(this).data("origStyle")) : t(this).removeAttr("style")
                }), void 0 != t(this).data("origStyle") ? this.attr("style", t(this).data("origStyle")) : t(this).removeAttr("style"), t(this).unwrap().unwrap(), o.controls.el && o.controls.el.remove(), o.controls.next && o.controls.next.remove(), o.controls.prev && o.controls.prev.remove(), o.pagerEl && o.settings.controls && o.pagerEl.remove(), t(".bx-caption", this).remove(), o.controls.autoEl && o.controls.autoEl.remove(), clearInterval(o.interval), o.settings.responsive && t(window).unbind("resize", Z))
            }, r.reloadSlider = function (t) {
                void 0 != t && (n = t), r.destroySlider(), d()
            }, d(), this
        }
    }(jQuery);

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

                if ($('#video-wrapper').length > 0) {
                    var currentStudio = $('#video-wrapper').attr('data-studio');

                    var jsVideo = document.getElementById('video');
                    var jsVideoHQ = document.getElementById('video-hq');
                    $('#headervideo').addClass('show-thumbnail');
                    if (!$('#headervideo').hasClass('mobile-video')) {
                        videojs("video").ready(function () {
                            var myPlayer = this;

                            var firstInit = true;
                            jsVideo.addEventListener("playing", function () {
                                if (firstInit == true) {
                                    myPlayer.pause();
                                    firstInit = false;
                                }
                            });
                            myPlayer.play();

                            $('#headervideo').removeClass('not-ready');
                            //$('#info-button').stop().fadeIn(1000);

                            var headerVideo = $('#headervideo');
                            var infoButton = $('#info-button');
                            var scrollWrapper = $('#scroll-wrapper');
                            var scroll = $('#scroll');
                            var introbox = $('#introbox');
                            var closeButton = $('.close-fullscreen');

                            var isFullscreen = false;

                            var videoDuration = jsVideo.duration;
                            var playbackConst = 250;

                            function initVideo() {
                                scroll.css('height', (Math.floor(videoDuration) * playbackConst + $(window).height()) + 'px');
                            }

                            initVideo();

                            function setSections() {
                                var countSections = $('.video-navigation-wrapper .sections li').length;
                                var count = 0;
                                $('.video-navigation-wrapper .sections li').each(function () {
                                    $(this).css('left', count * 100 / countSections + '%');
                                    count++;
                                });
                            }

                            setSections();

                            function jumpToSection(second) {
                                myPlayer.currentTime(second);
                            }

                            $('.video-navigation-wrapper .sections li').click(function () {
                                jumpToSection($(this).attr('data-time'));
                            });

                            function Timer(callback, delay) {
                                var timerId, start, remaining = delay;

                                this.pause = function () {
                                    window.clearTimeout(timerId);
                                    remaining -= new Date() - start;
                                };

                                this.resume = function () {
                                    start = new Date();
                                    window.clearTimeout(timerId);
                                    timerId = window.setTimeout(callback, remaining);
                                };

                                this.resume();
                            }

                            var timer0;
                            var gatimer0 = false;
                            var timer10;
                            var gatimer10 = false;
                            var timer20;
                            var gatimer20 = false;
                            var timer30;
                            var gatimer30 = false;
                            var timer40;
                            var gatimer40 = false;
                            var timer50;
                            var gatimer50 = false;
                            var timer60;
                            var gatimer60 = false;
                            var timer70;
                            var gatimer70 = false;
                            var timer80;
                            var gatimer80 = false;
                            var timer90;
                            var gatimer90 = false;
                            var timer100;
                            var gatimer100 = false;
                            var timer110;
                            var gatimer110 = false;
                            var timer120;
                            var gatimer120 = false;
                            var timer130;
                            var gatimer130 = false;
                            var timer140;
                            var gatimer140 = false;
                            var timer150;
                            var gatimer150 = false;
                            var timer160;
                            var gatimer160 = false;
                            var timer170;
                            var gatimer170 = false;
                            var timer180;
                            var gatimer180 = false;

                            var gaStart = false;
                            var gaClose = false;
                            var gaEnd = false;

                            function openFullscreen() {
                                $('#headervideo').removeClass('show-thumbnail');
                                if (gaStart == false) {
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', 'start');
                                    }

                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '0-10 Sekunden');
                                    }

                                    timer10 = new Timer(function () {
                                        gatimer10 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '10-20 Sekunden');
                                        }
                                    }, 10000);
                                    timer20 = new Timer(function () {
                                        gatimer20 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '20-30 Sekunden');
                                        }
                                    }, 20000);
                                    timer30 = new Timer(function () {
                                        gatimer30 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '30-40 Sekunden');
                                        }
                                    }, 30000);
                                    timer40 = new Timer(function () {
                                        gatimer40 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '40-50 Sekunden');
                                        }
                                    }, 40000);
                                    timer50 = new Timer(function () {
                                        gatimer50 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '50-60 Sekunden');
                                        }
                                    }, 50000);
                                    timer60 = new Timer(function () {
                                        gatimer60 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '60-70 Sekunden');
                                        }
                                    }, 60000);
                                    timer70 = new Timer(function () {
                                        gatimer70 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '70-80 Sekunden');
                                        }
                                    }, 70000);
                                    timer80 = new Timer(function () {
                                        gatimer80 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '80-90 Sekunden');
                                        }
                                    }, 80000);
                                    timer90 = new Timer(function () {
                                        gatimer90 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '90-100 Sekunden');
                                        }
                                    }, 90000);
                                    timer100 = new Timer(function () {
                                        gatimer100 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '100-110 Sekunden');
                                        }
                                    }, 100000);
                                    timer110 = new Timer(function () {
                                        gatimer110 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '110-120 Sekunden');
                                        }
                                    }, 110000);
                                    timer120 = new Timer(function () {
                                        gatimer120 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '120-130 Sekunden');
                                        }
                                    }, 120000);
                                    timer130 = new Timer(function () {
                                        gatimer130 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '130-140 Sekunden');
                                        }
                                    }, 130000);
                                    timer140 = new Timer(function () {
                                        gatimer140 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '140-150 Sekunden');
                                        }
                                    }, 140000);
                                    timer150 = new Timer(function () {
                                        gatimer150 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '150-160 Sekunden');
                                        }
                                    }, 150000);
                                    timer160 = new Timer(function () {
                                        gatimer160 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '160-170 Sekunden');
                                        }
                                    }, 160000);
                                    timer170 = new Timer(function () {
                                        gatimer170 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '170-180 Sekunden');
                                        }
                                    }, 170000);
                                    timer180 = new Timer(function () {
                                        gatimer180 = true;
                                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                            ga('send', 'event', 'video-' + currentStudio, 'video', '180+ Sekunden');
                                        }
                                    }, 180000);

                                    gaStart = true;
                                } else {
                                    if (typeof timer0 !== 'undefined' && gatimer0 == false) {
                                        timer0.resume();
                                    }
                                    if (typeof timer10 !== 'undefined' && gatimer10 == false) {
                                        timer10.resume();
                                    }
                                    if (typeof timer20 !== 'undefined' && gatimer20 == false) {
                                        timer20.resume();
                                    }
                                    if (typeof timer30 !== 'undefined' && gatimer30 == false) {
                                        timer30.resume();
                                    }
                                    if (typeof timer40 !== 'undefined' && gatimer40 == false) {
                                        timer40.resume();
                                    }
                                    if (typeof timer50 !== 'undefined' && gatimer50 == false) {
                                        timer50.resume();
                                    }
                                    if (typeof timer60 !== 'undefined' && gatimer60 == false) {
                                        timer60.resume();
                                    }
                                    if (typeof timer70 !== 'undefined' && gatimer70 == false) {
                                        timer70.resume();
                                    }
                                    if (typeof timer80 !== 'undefined' && gatimer80 == false) {
                                        timer80.resume();
                                    }
                                    if (typeof timer90 !== 'undefined' && gatimer90 == false) {
                                        timer90.resume();
                                    }
                                    if (typeof timer100 !== 'undefined' && gatimer100 == false) {
                                        timer100.resume();
                                    }
                                    if (typeof timer110 !== 'undefined' && gatimer110 == false) {
                                        timer110.resume();
                                    }
                                    if (typeof timer120 !== 'undefined' && gatimer120 == false) {
                                        timer120.resume();
                                    }
                                    if (typeof timer130 !== 'undefined' && gatimer130 == false) {
                                        timer130.resume();
                                    }
                                    if (typeof timer140 !== 'undefined' && gatimer140 == false) {
                                        timer140.resume();
                                    }
                                    if (typeof timer150 !== 'undefined' && gatimer150 == false) {
                                        timer150.resume();
                                    }
                                    if (typeof timer160 !== 'undefined' && gatimer160 == false) {
                                        timer160.resume();
                                    }
                                    if (typeof timer170 !== 'undefined' && gatimer170 == false) {
                                        timer170.resume();
                                    }
                                    if (typeof timer180 !== 'undefined' && gatimer180 == false) {
                                        timer180.resume();
                                    }
                                }
                                myPlayer.play();

                                disableScrolling();
                                headerVideo.addClass('active');
                                infoButton.stop().fadeOut(1000);
                                introbox.addClass('active-scroll');
                                isFullscreen = true;
                            }

                            function closeFullscreen() {
                                if (typeof timer0 !== 'undefined') {
                                    timer0.pause();
                                }
                                if (typeof timer10 !== 'undefined') {
                                    timer10.pause();
                                }
                                if (typeof timer20 !== 'undefined') {
                                    timer20.pause();
                                }
                                if (typeof timer30 !== 'undefined') {
                                    timer30.pause();
                                }
                                if (typeof timer40 !== 'undefined') {
                                    timer40.pause();
                                }
                                if (typeof timer50 !== 'undefined') {
                                    timer50.pause();
                                }
                                if (typeof timer60 !== 'undefined') {
                                    timer60.pause();
                                }
                                if (typeof timer70 !== 'undefined') {
                                    timer70.pause();
                                }
                                if (typeof timer80 !== 'undefined') {
                                    timer80.pause();
                                }
                                if (typeof timer90 !== 'undefined') {
                                    timer90.pause();
                                }
                                if (typeof timer100 !== 'undefined') {
                                    timer100.pause();
                                }
                                if (typeof timer110 !== 'undefined') {
                                    timer110.pause();
                                }
                                if (typeof timer120 !== 'undefined') {
                                    timer120.pause();
                                }
                                if (typeof timer130 !== 'undefined') {
                                    timer130.pause();
                                }
                                if (typeof timer140 !== 'undefined') {
                                    timer140.pause();
                                }
                                if (typeof timer150 !== 'undefined') {
                                    timer150.pause();
                                }
                                if (typeof timer160 !== 'undefined') {
                                    timer160.pause();
                                }
                                if (typeof timer170 !== 'undefined') {
                                    timer170.pause();
                                }
                                if (typeof timer180 !== 'undefined') {
                                    timer180.pause();
                                }

                                if (gaClose == false) {
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', 'schliessen');
                                    }
                                    gaClose = true;
                                }

                                myPlayer.pause();

                                enableScrolling();
                                headerVideo.removeClass('active');
                                infoButton.stop().fadeIn(1000);
                                introbox.removeClass('active-scroll');
                                isFullscreen = false;
                            }

                            scrollWrapper.click(function () {
                                if (!$('#headervideo').hasClass('mobile-video')) {
                                    if (isFullscreen == false) {
                                        openFullscreen();
                                    }
                                } else {
                                    if (typeof (jsVideo.webkitEnterFullscreen) != "undefined") {
                                        // This is for Android Stock.
                                        jsVideo.play();
                                        jsVideo.webkitEnterFullscreen();
                                    } else if (typeof (jsVideo.webkitRequestFullscreen) != "undefined") {
                                        // This is for Chrome.
                                        jsVideo.play();
                                        jsVideo.webkitRequestFullscreen();
                                    } else if (typeof (jsVideo.mozRequestFullScreen) != "undefined") {
                                        jsVideo.play();
                                        jsVideo.mozRequestFullScreen();
                                    } else {
                                        if (isFullscreen == false) {
                                            infoButton.stop().fadeOut(1000);
                                            myPlayer.play();
                                        }
                                    }
                                }
                            });

                            closeButton.click(function () {
                                if (isFullscreen == true) {
                                    closeFullscreen();
                                }
                            });

                            jsVideo.onended = function (e) {
                                if (gaEnd == false) {
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', 'ende');
                                    }
                                    gaEnd = true;
                                }
                            };
                        });
                    } else {
                        function Timer(callback, delay) {
                            var timerId, start, remaining = delay;

                            this.pause = function () {
                                window.clearTimeout(timerId);
                                remaining -= new Date() - start;
                            };

                            this.resume = function () {
                                start = new Date();
                                window.clearTimeout(timerId);
                                timerId = window.setTimeout(callback, remaining);
                            };

                            this.resume();
                        }

                        var timer0;
                        var gatimer0 = false;
                        var timer10;
                        var gatimer10 = false;
                        var timer20;
                        var gatimer20 = false;
                        var timer30;
                        var gatimer30 = false;
                        var timer40;
                        var gatimer40 = false;
                        var timer50;
                        var gatimer50 = false;
                        var timer60;
                        var gatimer60 = false;
                        var timer70;
                        var gatimer70 = false;
                        var timer80;
                        var gatimer80 = false;
                        var timer90;
                        var gatimer90 = false;
                        var timer100;
                        var gatimer100 = false;
                        var timer110;
                        var gatimer110 = false;
                        var timer120;
                        var gatimer120 = false;
                        var timer130;
                        var gatimer130 = false;
                        var timer140;
                        var gatimer140 = false;
                        var timer150;
                        var gatimer150 = false;
                        var timer160;
                        var gatimer160 = false;
                        var timer170;
                        var gatimer170 = false;
                        var timer180;
                        var gatimer180 = false;

                        var gaStart = false;
                        var gaEnd = false;

                        jsVideo.addEventListener("playing", function () {
                            if (gaStart == false) {
                                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                    ga('send', 'event', 'video-' + currentStudio, 'video', 'start');
                                }

                                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                    ga('send', 'event', 'video-' + currentStudio, 'video', '0-10 Sekunden');
                                }

                                timer10 = new Timer(function () {
                                    gatimer10 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '10-20 Sekunden');
                                    }
                                }, 10000);
                                timer20 = new Timer(function () {
                                    gatimer20 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '20-30 Sekunden');
                                    }
                                }, 20000);
                                timer30 = new Timer(function () {
                                    gatimer30 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '30-40 Sekunden');
                                    }
                                }, 30000);
                                timer40 = new Timer(function () {
                                    gatimer40 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '40-50 Sekunden');
                                    }
                                }, 40000);
                                timer50 = new Timer(function () {
                                    gatimer50 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '50-60 Sekunden');
                                    }
                                }, 50000);
                                timer60 = new Timer(function () {
                                    gatimer60 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '60-70 Sekunden');
                                    }
                                }, 60000);
                                timer70 = new Timer(function () {
                                    gatimer70 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '70-80 Sekunden');
                                    }
                                }, 70000);
                                timer80 = new Timer(function () {
                                    gatimer80 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '80-90 Sekunden');
                                    }
                                }, 80000);
                                timer90 = new Timer(function () {
                                    gatimer90 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '90-100 Sekunden');
                                    }
                                }, 90000);
                                timer100 = new Timer(function () {
                                    gatimer100 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '100-110 Sekunden');
                                    }
                                }, 100000);
                                timer110 = new Timer(function () {
                                    gatimer110 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '110-120 Sekunden');
                                    }
                                }, 110000);
                                timer120 = new Timer(function () {
                                    gatimer120 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '120-130 Sekunden');
                                    }
                                }, 120000);
                                timer130 = new Timer(function () {
                                    gatimer130 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '130-140 Sekunden');
                                    }
                                }, 130000);
                                timer140 = new Timer(function () {
                                    gatimer140 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '140-150 Sekunden');
                                    }
                                }, 140000);
                                timer150 = new Timer(function () {
                                    gatimer150 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '150-160 Sekunden');
                                    }
                                }, 150000);
                                timer160 = new Timer(function () {
                                    gatimer160 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '160-170 Sekunden');
                                    }
                                }, 160000);
                                timer170 = new Timer(function () {
                                    gatimer170 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '170-180 Sekunden');
                                    }
                                }, 170000);
                                timer180 = new Timer(function () {
                                    gatimer180 = true;
                                    if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                        ga('send', 'event', 'video-' + currentStudio, 'video', '180+ Sekunden');
                                    }
                                }, 180000);

                                gaStart = true;
                            } else {
                                if (typeof timer0 !== 'undefined' && gatimer0 == false) {
                                    timer0.resume();
                                }
                                if (typeof timer10 !== 'undefined' && gatimer10 == false) {
                                    timer10.resume();
                                }
                                if (typeof timer20 !== 'undefined' && gatimer20 == false) {
                                    timer20.resume();
                                }
                                if (typeof timer30 !== 'undefined' && gatimer30 == false) {
                                    timer30.resume();
                                }
                                if (typeof timer40 !== 'undefined' && gatimer40 == false) {
                                    timer40.resume();
                                }
                                if (typeof timer50 !== 'undefined' && gatimer50 == false) {
                                    timer50.resume();
                                }
                                if (typeof timer60 !== 'undefined' && gatimer60 == false) {
                                    timer60.resume();
                                }
                                if (typeof timer70 !== 'undefined' && gatimer70 == false) {
                                    timer70.resume();
                                }
                                if (typeof timer80 !== 'undefined' && gatimer80 == false) {
                                    timer80.resume();
                                }
                                if (typeof timer90 !== 'undefined' && gatimer90 == false) {
                                    timer90.resume();
                                }
                                if (typeof timer100 !== 'undefined' && gatimer100 == false) {
                                    timer100.resume();
                                }
                                if (typeof timer110 !== 'undefined' && gatimer110 == false) {
                                    timer110.resume();
                                }
                                if (typeof timer120 !== 'undefined' && gatimer120 == false) {
                                    timer120.resume();
                                }
                                if (typeof timer130 !== 'undefined' && gatimer130 == false) {
                                    timer130.resume();
                                }
                                if (typeof timer140 !== 'undefined' && gatimer140 == false) {
                                    timer140.resume();
                                }
                                if (typeof timer150 !== 'undefined' && gatimer150 == false) {
                                    timer150.resume();
                                }
                                if (typeof timer160 !== 'undefined' && gatimer160 == false) {
                                    timer160.resume();
                                }
                                if (typeof timer170 !== 'undefined' && gatimer170 == false) {
                                    timer170.resume();
                                }
                                if (typeof timer180 !== 'undefined' && gatimer180 == false) {
                                    timer180.resume();
                                }
                            }
                        }, true);
                        jsVideo.addEventListener("pause", function () {
                            if (typeof timer0 !== 'undefined') {
                                timer0.pause();
                            }
                            if (typeof timer10 !== 'undefined') {
                                timer10.pause();
                            }
                            if (typeof timer20 !== 'undefined') {
                                timer20.pause();
                            }
                            if (typeof timer30 !== 'undefined') {
                                timer30.pause();
                            }
                            if (typeof timer40 !== 'undefined') {
                                timer40.pause();
                            }
                            if (typeof timer50 !== 'undefined') {
                                timer50.pause();
                            }
                            if (typeof timer60 !== 'undefined') {
                                timer60.pause();
                            }
                            if (typeof timer70 !== 'undefined') {
                                timer70.pause();
                            }
                            if (typeof timer80 !== 'undefined') {
                                timer80.pause();
                            }
                            if (typeof timer90 !== 'undefined') {
                                timer90.pause();
                            }
                            if (typeof timer100 !== 'undefined') {
                                timer100.pause();
                            }
                            if (typeof timer110 !== 'undefined') {
                                timer110.pause();
                            }
                            if (typeof timer120 !== 'undefined') {
                                timer120.pause();
                            }
                            if (typeof timer130 !== 'undefined') {
                                timer130.pause();
                            }
                            if (typeof timer140 !== 'undefined') {
                                timer140.pause();
                            }
                            if (typeof timer150 !== 'undefined') {
                                timer150.pause();
                            }
                            if (typeof timer160 !== 'undefined') {
                                timer160.pause();
                            }
                            if (typeof timer170 !== 'undefined') {
                                timer170.pause();
                            }
                            if (typeof timer180 !== 'undefined') {
                                timer180.pause();
                            }
                        }, true);

                        jsVideo.onended = function (e) {
                            if (gaEnd == false) {
                                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                                    ga('send', 'event', 'video-' + currentStudio, 'video', 'ende');
                                }
                                gaEnd = true;
                            }
                        };
                    }
                }
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    /* Sticky Hover */
    var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
    if (!touchsupport) { // browser doesn't support touch
        document.documentElement.className += " non-touch"
    }

    /* Scroll */
    var keys = {32: 1, 37: 1, 38: 1, 39: 1, 40: 1};

    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    function disableScrollingFunction() {
        if (window.addEventListener)
            window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.onwheel = preventDefault;
        window.onmousewheel = document.onmousewheel = preventDefault;
        window.ontouchmove = preventDefault;
        document.onkeydown = preventDefaultForScrollKeys;
    }

    function enableScrollingFunction() {
        if (window.removeEventListener)
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.onmousewheel = document.onmousewheel = null;
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    }

    function disableScrolling() {
        if ($('body').css('position') != 'fixed') {
            $('body').css('top', '-' + $(window).scrollTop() + 'px').css('position', 'fixed').css('width', '100%');
        }
    }

    function enableScrolling() {
        if ($('body').css('position') == 'fixed') {
            var scrollTop = parseInt($('body').css('top').replace('-', '').replace('px', ''));
            $('body').css('top', '0').css('position', 'static').css('width', 'auto');
            $(window).scrollTop(scrollTop);
        }
    }

    /* Navigation */
    function r() {
        $(".nav-primary .parentmenu").removeClass("inactive"), $(".nav-primary .submenu").removeClass("active"), $(".nav-primary .submenu").removeClass("inactive"), $(".nav-primary .subsubmenu").removeClass("active")
    }

    $('.menupoints .open-submenu').click(function () {
        $(this).parent().find('ul').stop().slideToggle(250);
        if ($(window).width() <= 767) {
            if ($(".menu-toggle").hasClass("active")) {
                $(".nav-primary").stop().slideUp(250, function () {
                    $(".nav-primary").removeAttr("style"), $(".nav-primary ul ul").removeAttr("style"), r()
                });
                $(".menu-toggle").removeClass('active');
            }
        }
    });
    $(".menu-toggle").click(function () {
        $('.menupoints ul ul').stop().slideUp(250);
        if ($(window).width() <= 767)
            if ($(this).toggleClass("active"), $(this).hasClass("active")) {
                if (disableScrolling(), $(".nav-primary").hasClass("submenu-open")) {
                    var e = !1;
                    $(".nav-primary .submenu").each(function () {
                        "studio" != $(this).data("submenu") && 0 == e && ($(".nav-primary .parentmenu").toggleClass("inactive"), $(this).toggleClass("active"), e = !0)
                    })
                }
                $(".nav-primary").stop().slideDown(250), $(".nav-primary").scrollTop(0)
            } else enableScrolling(), $(".nav-primary").stop().slideUp(250, function () {
                $(".nav-primary").removeAttr("style"), $(".nav-primary ul ul").removeAttr("style"), r()
            })
    }), $(".nav-primary ul li a").click(function (e) {
        $(window).width() <= 767 && $(this).parent().find("span").hasClass("arrow") && (e.preventDefault(), "studio" == $(this).data("submenu") ? ($(".nav-primary .parentmenu").toggleClass("inactive"), $('.nav-primary .submenu[data-submenu="studio"]').toggleClass("active")) : $(this).parent().parent().hasClass("submenu") ? ($('.nav-primary .submenu[data-submenu="studio"]').addClass("inactive"), $(this).parent().find(".subsubmenu").addClass("active")) : ($(".nav-primary .parentmenu").toggleClass("inactive"), $('.nav-primary .submenu[data-submenu="' + $(this).data("submenu") + '"]').toggleClass("active")))
    }), $(".nav-primary .submenu .back a").click(function (e) {
        if (e.preventDefault(), $(this).parent().parent().hasClass("submenu")) $(".nav-primary .parentmenu").toggleClass("inactive"), "studio" == $(this).parent().parent().data("submenu") ? $('.nav-primary .submenu[data-submenu="studio"]').toggleClass("active") : $('.nav-primary .submenu[data-submenu="' + $(this).parent().parent().data("submenu") + '"]').toggleClass("active");
        else if ($(this).parent().parent().hasClass("subsubmenu")) {
            $(this).parent().parent().parent().parent().removeClass("inactive");
            var i = $(this);
            setTimeout(function () {
                i.parent().parent().removeClass("active")
            }, 500)
        }
    })

    /* scroll-to */
    var scrollTo = $('.scroll-to');
    if (scrollTo.length > 0) {
        $(window).scrollTop(scrollTo.offset().top - 120);
    }

    /* Courseplan */
    function courseplan() {
        function loadCourseplan() {
            if ($('.courseplan-wrapper.v2.load-courseplan').length > 0) {
                var currentStudio = $('.widget.courseplan .change-studio option:checked').val();
                $.ajax({
                    url: '/wp/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: 'action=get_courseplan&studio=',
                    success: function (response) {
                        console.log('response', response);
                        $('.courseplan-wrapper.v2').append(response);
                        $('.courseplan-wrapper.v2').removeClass('load-courseplan');

                        $('.courseplan button.inactive').click(function (e) {
                            e.preventDefault();
                        });
                        $('.courseplan button.inactive').hover(function () {
                            $('.info-tooltip.global-i').remove();
                            var positionLeft = $(this).offset().left + $(this).outerWidth() / 2 - $(this).find('.info-tooltip').outerWidth() / 2;
                            $(this).find('.info-tooltip').clone().appendTo('body').addClass('global-i').css('margin', '0').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top - $('.info-tooltip.global-i').outerHeight() - 10) + 'px');
                        }, function () {
                            $('.info-tooltip.global-i').fadeOut(250);
                        });
                        $('.info-tooltip.global-i').on('hover', function () {
                            $('.info-tooltip.global-i').fadeOut(250);
                        });

                        $('form.queue .info-tip span, form.unqueue .info-tip span').hover(function () {
                            $('.info-tooltip.global').remove();
                            var positionLeft = $(this).offset().left + $(this).outerWidth() / 2;
                            $(this).find('.info-tooltip').clone().appendTo('body').addClass('global').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top - $('.info-tooltip.global').outerHeight() - 15) + 'px');
                        }, function () {
                            $('.info-tooltip.global').fadeOut(250);
                        });

                        if ($('#body').hasClass('myelements-logged-in')) {
                            var overlay = $('#overlay');

                            function overlayLoading() {
                                overlay.addClass('load-module').fadeIn(500);
                            }

                            function openOverlay(module) {
                                overlay.removeClass('load-module').find('.module[data-overlay=' + module + ']').fadeIn(500);
                            }

                            function closeOverlay() {
                                overlay.fadeOut(500);
                                setTimeout(function () {
                                    overlay.find('.module').hide();
                                });
                            }

                            overlay.find('.close-overlay, [data-close-overlay]').click(function () {
                                closeOverlay();
                            });
                            $('.courseplan-wrapper.v2').unbind('submit');
                            $('.courseplan-wrapper.v2').on('submit', '.courseplan form', function (e) {
                                var values = $(this).serializeArray();
                                var valuesObj = {};
                                $(values).each(function (i, field) {
                                    valuesObj[field.name] = field.value;
                                });

                                var action = $(this).find('button[type=submit]').attr('name');
                                if (action == 'subscribe') {
                                    e.preventDefault();
                                    var studioName = valuesObj['studio_name'].replace("TIMESLOTS ", "");
                                    var module = overlay.find('.module[data-overlay="subscribe"], .module[data-overlay="subscribe-slots"]');
                                    module.find('[data-fill="time"]').html(valuesObj['time']);
                                    module.find('[data-fill="date"]').html(valuesObj['date']);
                                    module.find('[data-fill="course-name"]').html(valuesObj['course_name']);
                                    module.find('[data-fill="studio-name"]').html(studioName);
                                    module.find('[data-fill="studio-address"]').html(valuesObj['studio_address']);
                                    overlayLoading();
                                    $.ajax({
                                        url: '/wp-admin/admin-ajax.php',
                                        type: 'POST',
                                        data: 'action=courseplan_subscribe&course_id=' + valuesObj['course_id'] + '&r=' + valuesObj['r'],
                                        success: function (results) {
                                            var obj = jQuery.parseJSON(results);
                                            if (obj.success == true) {
                                                if ($('.courseplan').attr('data-studio').startsWith('timeslots-')) {
                                                    openOverlay('subscribe-slots');
                                                } else {
                                                    openOverlay('subscribe');
                                                }
                                            } else {
                                                if (obj.error == 'restricted') {
                                                    openOverlay('restricted');
                                                } else {
                                                    openOverlay('subscribe-error');
                                                }
                                            }
                                            reloadCourseplan();
                                        }
                                    });
                                }
                                if (action == 'unsubscribe') {
                                    e.preventDefault();
                                    overlayLoading();
                                    $.ajax({
                                        url: '/wp-admin/admin-ajax.php',
                                        type: 'POST',
                                        data: 'action=courseplan_unsubscribe&course_id=' + valuesObj['course_id'],
                                        success: function (results) {
                                            if ($('.courseplan').attr('data-studio').startsWith('timeslots-')) {
                                                openOverlay('unsubscribe-slots');
                                            } else {
                                                openOverlay('unsubscribe');
                                            }
                                            reloadCourseplan();
                                        }
                                    });
                                }
                                if (action == 'queue') {
                                    e.preventDefault();
                                    var studioName = valuesObj['studio_name'].replace("TIMESLOTS ", "");
                                    var module = overlay.find('.module[data-overlay="queue"], .module[data-overlay="queue-slots"]');
                                    module.find('[data-fill="time"]').html(valuesObj['time']);
                                    module.find('[data-fill="date"]').html(valuesObj['date']);
                                    module.find('[data-fill="course-name"]').html(valuesObj['course_name']);
                                    module.find('[data-fill="studio-name"]').html(studioName);
                                    module.find('[data-fill="studio-address"]').html(valuesObj['studio_address']);
                                    overlayLoading();
                                    $.ajax({
                                        url: '/wp-admin/admin-ajax.php',
                                        type: 'POST',
                                        data: 'action=courseplan_queue&course_id=' + valuesObj['course_id'] + '&r=' + valuesObj['r'],
                                        success: function (results) {
                                            if ($('.courseplan').attr('data-studio').startsWith('timeslots-')) {
                                                openOverlay('queue-slots');
                                            } else {
                                                var obj = jQuery.parseJSON(results);
                                                if (obj.success == true) {
                                                    openOverlay('queue');
                                                } else {
                                                    if (obj.error == 'restricted') {
                                                        openOverlay('restricted');
                                                    }
                                                }
                                            }
                                            reloadCourseplan();
                                        }
                                    });
                                }
                                if (action == 'unqueue') {
                                    e.preventDefault();
                                    overlayLoading();
                                    $.ajax({
                                        url: '/wp-admin/admin-ajax.php',
                                        type: 'POST',
                                        data: 'action=courseplan_unqueue&course_id=' + valuesObj['course_id'],
                                        success: function (results) {
                                            openOverlay('unqueue');
                                            reloadCourseplan();
                                        }
                                    });
                                }
                            });
                        }

                        courseplanDatepicker();

                        $(window).resize();
                    }
                });
            }
        }

        loadCourseplan();

        function reloadCourseplan() {
            $('.courseplan-wrapper.v2').addClass('load-courseplan');
            $('.courseplan-wrapper.v2 .courseplan').remove();
            $('.courseplan-wrapper.v2 .courseplan-datepicker-wrapper').remove();
            loadCourseplan();
        }

        $('.page-template-template-courseplan #introbox select, .page-template-template-courseplan-slots #introbox select').on('change', function () {
            if ($(this).val() != 'Studio auswählen') {
                $('.courseplan-wrapper.v2').addClass('load-courseplan');
            }
            $('.courseplan-wrapper.v2 .courseplan').remove();
            $('.courseplan-wrapper.v2 .courseplan-datepicker-wrapper').remove();
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=set_studio_session&studio=' + this.value,
                success: function (results) {
                    reloadCourseplan();
                }
            });
        });
        $(document).on('change', '.ft-toggle-checkbox', function () {
            $('.ft-toggle-checkbox').prop('checked', this.checked);
            $(this).closest('.courseplan').toggleClass('ft-courses');
        });
    }

    courseplan();

    function courseplanDatepicker() {
        $('.courseplan-datepicker ul li').click(function () {
            var dataAccordion = $(this).data('accordion');
            $('.courseplan-datepicker ul li').removeClass('active');
            $(this).addClass('active');
            $('.courseplan .accordion').removeClass('open');
            $.when($('.courseplan .accordion .body').fadeOut(250)).done(function () {
                $('.courseplan .accordion[data-accordion="' + dataAccordion + '"]').addClass('open');
                $('.courseplan .accordion[data-accordion="' + dataAccordion + '"] .body').stop().fadeIn(250);
            });
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=set_day_session&day=' + $('.courseplan .accordion[data-accordion="' + dataAccordion + '"] .head span').data('day'),
                success: function (results) {
                }
            });
        });
        if ((($('body').hasClass('page-template-template-courseplan') || $('body').hasClass('page-template-template-courseplan-slots')) && $('.courseplan-datepicker').is(':visible')) || $('.courseplan-online').length > 0) {
            if ($('.courseplan-datepicker ul li.active').length > 0) {
                $('.courseplan-datepicker').scrollLeft($('.courseplan-datepicker ul li.active').offset().left);
            }

            function datepickerShadow() {
                if ($('.courseplan-datepicker').scrollLeft() == 0) {
                    $('.courseplan-datepicker-wrapper').find('.shadow.left').addClass('hide');
                } else {
                    $('.courseplan-datepicker-wrapper').find('.shadow.left').removeClass('hide');
                }
                var ulWidth = 0;
                $('.courseplan-datepicker ul li').each(function () {
                    ulWidth = ulWidth + $(this).outerWidth();
                });
                if ($('.courseplan-datepicker').scrollLeft() + $('.courseplan-datepicker').outerWidth() >= ulWidth) {
                    $('.courseplan-datepicker-wrapper').find('.shadow.right').addClass('hide');
                } else {
                    $('.courseplan-datepicker-wrapper').find('.shadow.right').removeClass('hide');
                }
            }

            datepickerShadow();
            $('.courseplan-datepicker').scroll(function () {
                datepickerShadow();
            });
            $(document).scroll(function () {
                if ($(window).width() <= 767 && $(window).scrollTop() >= $('.courseplan').offset().top - 100) {
                    $('.courseplan-datepicker-wrapper').addClass('hold');
                } else {
                    $('.courseplan-datepicker-wrapper').removeClass('hold');
                }
            });
        }
        if ($('body').hasClass('page-template-template-courseplan') || $('body').hasClass('page-template-template-courseplan-slots') || $('body').hasClass('page-id-19550') || $('body').hasClass('page-template-template-myelements') || $('.courseplan-online').length > 0) {
            $('.courseplan .accordion .body').each(function () {
                if ($(this).scrollLeft() == 0) {
                    $(this).parent().find('.shadow.left').addClass('hide');
                } else {
                    $(this).parent().find('.shadow.left').removeClass('hide');
                }
                if ($(this).scrollLeft() + $(this).outerWidth() >= $(this).parent().find('table').outerWidth()) {
                    $(this).parent().find('.shadow.right').addClass('hide');
                } else {
                    $(this).parent().find('.shadow.right').removeClass('hide');
                }
            });
            $(window).resize(function () {
                $('.courseplan .accordion .body').each(function () {
                    if ($(this).scrollLeft() == 0) {
                        $(this).parent().find('.shadow.left').addClass('hide');
                    } else {
                        $(this).parent().find('.shadow.left').removeClass('hide');
                    }
                    if ($(this).scrollLeft() + $(this).outerWidth() >= $(this).parent().find('table').outerWidth()) {
                        $(this).parent().find('.shadow.right').addClass('hide');
                    } else {
                        $(this).parent().find('.shadow.right').removeClass('hide');
                    }
                });
            });
            $('.courseplan .accordion .body').scroll(function () {
                if ($(this).scrollLeft() == 0) {
                    $(this).parent().find('.shadow.left').addClass('hide');
                } else {
                    $(this).parent().find('.shadow.left').removeClass('hide');
                }
                if ($(this).scrollLeft() + $(this).outerWidth() >= $(this).parent().find('table').outerWidth()) {
                    $(this).parent().find('.shadow.right').addClass('hide');
                } else {
                    $(this).parent().find('.shadow.right').removeClass('hide');
                }
            });
        }
    }

    courseplanDatepicker();

    /* Sidepanel */
    $(document).scroll(function () {
        $('#sidepanel').removeClass('active');
    });

    /* Slider */
    if ($('#slider .slide').length > 0) {
        if ($(window).width() <= 767) {
            $('#slider').bxSlider({
                mode: 'fade',
                speed: 500,
                controls: true,
                auto: true,
                pause: 11000
            });
        } else {
            var slider = $('#slider').bxSlider({
                mode: 'fade',
                speed: 500,
                controls: true,
                auto: true,
                pause: 11000,
                onSliderLoad: function (currentIndex) {
                    if ($('#slider-wrapper #slider .slide:eq(' + currentIndex + ')').find('.video').length > 0) {
                        var videoCurrent = videojs('video_' + currentIndex);
                        videoCurrent.ready(function () {
                            var myPlayer = this;
                            var myInterval = setInterval(function () {
                                myPlayer.play();
                                if (myPlayer.paused() === false) {
                                    clearInterval(myInterval);
                                }
                            }, 100);
                        });
                    }
                },
                onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                    if ($('#slider-wrapper #slider .slide:eq(' + newIndex + ')').find('.video').length > 0) {
                        var videoNext = videojs('video_' + newIndex);
                        videoNext.ready(function () {
                            var myPlayer = this;
                            var myInterval = setInterval(function () {
                                myPlayer.play();
                                if (myPlayer.paused() === false) {
                                    clearInterval(myInterval);
                                }
                            }, 100);
                        });
                    }
                },
                onSlideAfter: function ($slideElement, oldIndex, newIndex) {
                    if ($('#slider-wrapper #slider .slide:eq(' + oldIndex + ')').find('.video').length > 0) {
                        var videoOld = videojs('video_' + oldIndex);
                        videoOld.pause();
                    }
                }
            });

            // Play videos
            /*var firstSlideElement = $('#slider-wrapper #slider .slide:nth-child(1)');
      var video = firstSlideElement.find('video');
      if(video.length > 0) {
        video[0].play();
        //video.on('ended', function () {
        //  if(firstSlideElement.is(':visible')) {
        //    slider.goToNextSlide();
        //  }
        //});
      }*/
        }
    }
    if ($('.content-bx-slider').length > 0) {
        $('.content-bx-slider').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 5,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        infinite: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        });
    }
    if ($('.content-slider .content-slide').length > 1) {
        var numberOfSlides = $('.content-slider .content-slide').length;
        $('.content-slider').bxSlider({
            mode: 'horizontal',
            speed: 1000,
            onSliderLoad: function (currentIndex) {
                var slideElement = $('.content-slider .content-slide:nth-child(' + (currentIndex + 2) + ')');

                slideElement.addClass('active');
                if (currentIndex + 1 == 1) {
                    slideElement.parent().find('.content-slide:last-child').addClass('active');
                }
                if (currentIndex + 1 == numberOfSlides) {
                    slideElement.parent().find('.content-slide:first-child').addClass('active');
                }

                if (currentIndex >= 1) {
                    slideElement.parent().find('.content-slide:nth-child(' + (currentIndex + 1) + ')').addClass('left');
                    if (currentIndex == 1) {
                        slideElement.parent().find('.content-slide:last-child').addClass('left sliding');
                    }
                } else {
                    slideElement.parent().find('.content-slide:first-child').addClass('left');
                    slideElement.parent().find('.content-slide:nth-child(' + (numberOfSlides + 1) + ')').addClass('left');
                }

                if (currentIndex + 2 <= numberOfSlides) {
                    slideElement.parent().find('.content-slide:nth-child(' + (currentIndex + 3) + ')').addClass('right');
                    if (currentIndex + 2 == numberOfSlides) {
                        slideElement.parent().find('.content-slide:first-child').addClass('right');
                    }
                } else {
                    slideElement.parent().find('.content-slide:nth-child(2)').addClass('right');
                    slideElement.parent().find('.content-slide:last-child').addClass('right');
                }
            },
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                $slideElement.parent().find('.content-slide').removeClass('active').removeClass('left').removeClass('right');

                $slideElement.addClass('active');
                if (newIndex + 1 == 1) {
                    $slideElement.parent().find('.content-slide:last-child').addClass('active');
                }
                if (newIndex + 1 == numberOfSlides) {
                    $slideElement.parent().find('.content-slide:first-child').addClass('active');
                }

                if (newIndex >= 1) {
                    $slideElement.parent().find('.content-slide:nth-child(' + (newIndex + 1) + ')').addClass('left');
                    if (oldIndex == 0 && newIndex + 1 == numberOfSlides) {
                        $slideElement.parent().find('.content-slide:nth-child(' + (newIndex + 1) + ')').addClass('sliding');
                    }
                    if (newIndex == 1) {
                        $slideElement.parent().find('.content-slide:last-child').addClass('left sliding');
                    }
                } else {
                    $slideElement.parent().find('.content-slide:first-child').addClass('left');
                    $slideElement.parent().find('.content-slide:nth-child(' + (numberOfSlides + 1) + ')').addClass('left');
                }

                if (newIndex + 2 <= numberOfSlides) {
                    $slideElement.parent().find('.content-slide:nth-child(' + (newIndex + 3) + ')').addClass('right');
                    if (oldIndex + 1 == numberOfSlides && newIndex == 0) {
                        $slideElement.parent().find('.content-slide:nth-child(' + (newIndex + 3) + ')').addClass('sliding');
                    }
                    if (newIndex + 2 == numberOfSlides) {
                        $slideElement.parent().find('.content-slide:first-child').addClass('right');
                    }
                } else {
                    $slideElement.parent().find('.content-slide:nth-child(2)').addClass('right');
                    $slideElement.parent().find('.content-slide:last-child').addClass('right');
                }
            },
            onSlideAfter: function ($slideElement, oldIndex, newIndex) {
                $slideElement.parent().find('.content-slide').removeClass('sliding');
            }
        });
        if ($(window).width() <= 767) {
            $('.content-slider').each(function () {
                var thisSlider = $(this);
                var maxHeightSlideText = 0;
                thisSlider.find('.content-slide').each(function () {
                    if ($(this).find('.contentbox').height() > maxHeightSlideText) {
                        maxHeightSlideText = $(this).find('.contentbox').height() + parseInt($(this).find('.contentbox').css('padding-top')) + parseInt($(this).find('.contentbox').css('padding-bottom'));
                    }
                });
                thisSlider.find('.content-slide .contentbox').css('height', maxHeightSlideText + 'px');
            });
        }
    }
    var currentServiceSlide = 1;
    var countServiceSlides = Math.ceil($('.services-slider-wrapper ul li').length / 4);
    $('.services-slider-wrapper .next').click(function () {
        currentServiceSlide++;
        $('.services-slider-wrapper .prev').css('pointer-events', 'auto').fadeIn(500);
        if (currentServiceSlide == 1) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(0))');
        }
        if (currentServiceSlide == 2) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-25%)');
        }
        if (currentServiceSlide == 3) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-50%)');
        }
        if (currentServiceSlide == 4) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-75%)');
        }
        if (currentServiceSlide == countServiceSlides) {
            $('.services-slider-wrapper .next').css('pointer-events', 'none').fadeOut(500);
        }
    });
    $('.services-slider-wrapper .prev').click(function () {
        currentServiceSlide--;
        $('.services-slider-wrapper .next').css('pointer-events', 'auto').fadeIn(500);
        if (currentServiceSlide == 1) {
            $('.services-slider-wrapper .prev').css('pointer-events', 'none').fadeOut(500);
            $('.services-slider-wrapper ul').css('transform', 'translateX(0)');
        }
        if (currentServiceSlide == 2) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-25%)');
        }
        if (currentServiceSlide == 3) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-50%)');
        }
        if (currentServiceSlide == 4) {
            $('.services-slider-wrapper ul').css('transform', 'translateX(-75%)');
        }
    });

    function serviceSliderHeight() {
        if ($(window).width() <= 767) {
            var servideSliderItemsHeight = 0;
            var servideSliderFullHeight = $('.services-slider ul').outerHeight();
            $('.services-slider ul li:first-child, .services-slider ul li:nth-child(2)').each(function () {
                if ($(this).outerHeight() > servideSliderItemsHeight) {
                    servideSliderItemsHeight = $(this).outerHeight();
                }
            });
            $('.services-slider ul').height((servideSliderItemsHeight - 50) + 'px');
            $('.services-slider-wrapper').addClass('mobile');
            $('.show-more-services').css('display', 'block');
            $('.show-more-services').click(function () {
                $('.services-slider-wrapper').addClass('open');
                $('.services-slider ul').animate({
                    height: servideSliderFullHeight
                }, 500);
                $(this).slideUp(500);
            });
        } else {
            $('.services-slider ul').css('height', 'auto');
        }
    }

    serviceSliderHeight();
    $(window).resize(function () {
        if (!($(window).width() <= 767)) {
            $('.services-slider ul').css('height', 'auto');
        }
    });

    // Event Calender
    var tableWrapper = $('.table-wrapper');
    var table = $('.table-wrapper table');
    var allVisible = false;

    function setEventCalernderHeight() {
        if (tableWrapper.find('tbody tr').length > 12) {
            tableWrapper.css('height', 'auto');

            tableWrapper.addClass('animate');

            tableWrapper.attr('data-height', tableWrapper.outerHeight() + 'px');

            var offsetTableTop = table.offset().top;
            var offsetTableBottom = table.find('tbody tr:nth-child(11)').offset().top + table.find('tbody tr:nth-child(11)').outerHeight();

            tableWrapper.css('height', (offsetTableBottom - offsetTableTop + 1) + 'px');
        }
    }

    setEventCalernderHeight();
    $(window).resize(function () {
        if (allVisible == false) {
            setEventCalernderHeight();
        }
    });

    var showMoreButton = $('.show-more');

    function showMore() {
        allVisible = true;
        showMoreButton.addClass('hide');
        tableWrapper.css('height', tableWrapper.attr('data-height'));
        setTimeout(function () {
            tableWrapper.css('height', 'auto');
        }, 500);
    }

    showMoreButton.click(function () {
        showMore();
    });

    if (tableWrapper.find('tbody tr').length <= 12) {
        showMoreButton.addClass('hide');
    }

    /* Event Calendar */
    $('.open-event-overlay').click(function () {
        disableScrolling();
        $('.prev-event, .next-event').removeClass('inactive');
        $('.event-overlay .overlay-wrapper').removeClass('active').hide();
        $('.event-overlay .overlay-wrapper[data-id="' + $(this).attr('data-id') + '"]').addClass('active').show();
        var index = $('.event-overlay .overlay-wrapper[data-id="' + $(this).attr('data-id') + '"]').index();
        if (index == 0) {
            $('.prev-event').addClass('inactive');
        }
        if (index + 1 == $('.event-overlay .overlay-wrapper').length) {
            $('.next-event').addClass('inactive');
        }
        $('.event-overlay').fadeIn(250);
    });
    $('.event-overlay .close-overlay').click(function () {
        enableScrolling();
        $('.event-overlay').fadeOut(250);
    });
    $('.next-event').click(function () {
        var oldIndex = $('.event-overlay .overlay-wrapper.active').index();

        $('.event-overlay .overlay-wrapper').removeClass('active').fadeOut(250);
        $('.event-overlay .overlay-wrapper:nth-child(' + (oldIndex + 2) + ')').addClass('active');
        setTimeout(function () {
            $('.event-overlay .overlay-wrapper:nth-child(' + (oldIndex + 2) + ')').fadeIn(250);
        }, 250);

        var index = $('.event-overlay .overlay-wrapper.active').index();
        if (index == 0) {
            $('.prev-event').addClass('inactive');
        } else {
            $('.prev-event').removeClass('inactive');
        }
        if (index + 1 == $('.event-overlay .overlay-wrapper').length) {
            $('.next-event').addClass('inactive');
        } else {
            $('.next-event').removeClass('inactive');
        }
    });
    $('.prev-event').click(function () {
        var oldIndex = $('.event-overlay .overlay-wrapper.active').index();

        $('.event-overlay .overlay-wrapper').removeClass('active').fadeOut(250);
        $('.event-overlay .overlay-wrapper:nth-child(' + (oldIndex) + ')').addClass('active');
        setTimeout(function () {
            $('.event-overlay .overlay-wrapper:nth-child(' + (oldIndex) + ')').fadeIn(250);
        }, 250);

        var index = $('.event-overlay .overlay-wrapper.active').index();
        if (index == 0) {
            $('.prev-event').addClass('inactive');
        } else {
            $('.prev-event').removeClass('inactive');
        }
        if (index + 1 == $('.event-overlay .overlay-wrapper').length) {
            $('.next-event').addClass('inactive');
        } else {
            $('.next-event').removeClass('inactive');
        }
    });
    $('.show-more-mobile').click(function () {
        if ($(this).parent().parent().next().is(':visible')) {
            $(this).parent().parent().find('td:nth-child(6) a').text('Mehr');
            $(this).parent().parent().next().slideUp(0);
        } else {
            $(this).parent().parent().find('td:nth-child(6) a').text('X');
            $(this).parent().parent().next().slideDown(0);
        }
    });

    /* Scroll Down */
    $('.scroll-down').click(function () {
        disableScrollingFunction();
        $('html, body').animate({
            scrollTop: $('#slider-wrapper').outerHeight()
        }, 500, 'swing', function () {
            enableScrollingFunction();
        });
    });

    /* Scroll to top */
    $('.scroll-to-top').click(function () {
        disableScrollingFunction();
        $('html, body').animate({
            scrollTop: 0
        }, 500, 'swing', function () {
            enableScrollingFunction();
        });
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() >= $(window).height() || $(window).scrollTop() >= 980) {
            $('.scroll-to-top').addClass('active');
        } else {
            $('.scroll-to-top').removeClass('active');
        }
    });
    if ($(window).scrollTop() >= $(window).height() || $(window).scrollTop() >= 980) {
        $('.scroll-to-top').addClass('active');
    } else {
        $('.scroll-to-top').removeClass('active');
    }

    /* Overlays */
    var currentOverlayPage = 1;
    if ($('.overlay').hasClass('login')) {
        disableScrolling();
        $('.overlay-wrapper.login-information').show();
    } else if ($('.overlay').hasClass('subscribe')) {
        disableScrolling();
        $('.overlay-wrapper.subscribe').show();
    } else if ($('.overlay').hasClass('unsubscribe')) {
        disableScrolling();
        $('.overlay-wrapper.unsubscribe').show();
    } else if ($('.overlay').hasClass('queue')) {
        disableScrolling();
        $('.overlay-wrapper.queue').show();
    } else if ($('.overlay').hasClass('unqueue')) {
        disableScrolling();
        $('.overlay-wrapper.unqueue').show();
    } else if ($('.overlay').hasClass('confirm')) {
        $('.overlay').show().removeClass('confirm');
        disableScrolling();
        $('.overlay-wrapper.confirm').show();
    } else if ($('.overlay').hasClass('myelements-studio-select')) {
        disableScrolling();
    }
    $('.open-contact-overlay').click(function () {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.contact').show();
        $('.overlay').fadeIn(250);
    });
    $('.open-appointment-overlay, a[href*="#mitglied-werden"], a[href*="#24monate"], a[href*="#12monate"], a[href*="#6monate"], a[href*="#1monat"], a[href*="#youabo"]').click(function () {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.appointment').show();
        $('.overlay').fadeIn(250);
    });

    // Home page offer overlay
    var currentDate = '2022-12-01';
    var endDate = "2022-12-25";
    // endDate = new Date(endDate);

    if (currentDate < endDate) {
        if( $('body.home').length ){
            disableScrolling();
            $('.overlay-wrapper').hide();
            $('.overlay-wrapper.autumnHome').show();
            $('.overlay').fadeIn(250);
        }
    }

    $(document).ready(function () {

        $("#selectedStudio").on('change', function () {
            var studioCode = $('#selectedStudio').find(":selected").val();

            if (studioCode === "") {
                $("#selectedStudioButton").css("display", "none");
            } else {
                $("#selectedStudioButton").attr("href", "https://mitgliedschaft.e-app.eu/sale/ELEMENTS-" + studioCode).css("display", "inline-block");
            }
        })

    });

    var overlayAppointementSent = false;
    $('a[href*="#beratungstermin"]').click(function (e) {
        e.preventDefault();
        if (overlayAppointementSent) {
            window.location.replace(window.location.href + '#beratungstermin');
            window.location.reload(true);
        } else {
            setTimeout(function () {
                disableScrolling();
                $('.overlay-wrapper').hide();
                $('.overlay-wrapper.appointment').show();
                $('.overlay').fadeIn(250);
            }, 250);
        }
    });
    $('.overlay-wrapper.appointment select[name="select-studio"]').on('change', function () {
        scrollToOverlaySelect($(this));
        $('.appointment-picker').addClass('inactive');
        if (this.value != 'none') {
            $('.appointment-picker[data-studio="' + this.value + '"]').removeClass('inactive');
        }
    });
    $('.open-trial-overlay, a[href*="#probetraining"]').click(function () {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.trial').show();
        $('.overlay').fadeIn(250);
    });
    $('.open-trainer-overlay').click(function () {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.trainer[data-id="' + $(this).data('id') + '"]').show();
        $('.overlay').fadeIn(250);
    });
    $('.courseplan-wrapper').on('click', '.open-course-overlay', function () {
        if ($(window).width() >= 768) {
            disableScrolling();
            $('.overlay-wrapper').hide();
            $('.overlay-wrapper.course img').hide();
            if ($(this).parent().parent().data('course-image') != '') {
                $('.overlay-wrapper.course img').attr('src', $(this).parent().parent().data('course-image')).show();
            }
            $('.overlay-wrapper.course .name').text($(this).parent().parent().data('course-name'));
            $('.overlay-wrapper.course .description').hide();
            if ($(this).parent().parent().data('course-description') != '') {
                $('.overlay-wrapper.course .description').text($(this).parent().parent().data('course-description')).show();
            }
            $('.overlay-wrapper.course').show();
            $('.overlay').fadeIn(250);
        } else if (!$(this).parent().is('td')) {
            disableScrolling();
            $('.overlay-wrapper').hide();
            $('.overlay-wrapper.course img').hide();
            if ($(this).parent().parent().parent().prev().data('course-image') != '') {
                $('.overlay-wrapper.course img').attr('src', $(this).parent().parent().parent().prev().data('course-image')).show();
            }
            $('.overlay-wrapper.course .name').text($(this).parent().parent().parent().prev().data('course-name'));
            $('.overlay-wrapper.course .description').hide();
            if ($(this).parent().parent().data('course-description') != '') {
                $('.overlay-wrapper.course .description').text($(this).parent().parent().parent().prev().data('course-description')).show();
            }
            $('.overlay-wrapper.course').show();
            $('.overlay').fadeIn(250);
        } else {
            if ($(this).parent().parent().next().is(':visible')) {
                $(this).parent().parent().find('td:nth-child(6) a').text('Mehr');
                $(this).parent().parent().next().slideUp(0);
            } else {
                $(this).parent().parent().find('td:nth-child(6) a').text('X');
                $(this).parent().parent().next().slideDown(0);
            }
        }
    });
    $('.more-info-link').on('click', function () {
        if ($(window).width() >= 768) {
            if (!$('.info-tooltip.global-i').is(':visible')) {
                $('.info-tooltip.global-i').remove();
                var positionLeft = $(this).offset().left + $(this).outerWidth() / 2 - $(this).find('.info-tooltip').outerWidth() / 2;
                $(this).find('.info-tooltip').clone().appendTo('body').addClass('global-i').css('margin', '0').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top + 28) + 'px');
                setTimeout(function () {
                    $('#body').one('click', function () {
                        $('.info-tooltip.global-i').fadeOut(250);
                    });
                }, 1);
            } else {
                $('.info-tooltip.global-i').fadeOut(250);
            }
        } else if (!$(this).parent().is('td')) {
            if (!$('.info-tooltip.global-i').is(':visible')) {
                $('.info-tooltip.global-i').remove();
                var positionLeft = $(this).offset().left + $(this).outerWidth() / 2 - $(this).find('.info-tooltip').outerWidth() / 2;
                $(this).find('.info-tooltip').clone().appendTo('body').addClass('global-i').css('margin', '0').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top + 38) + 'px');
                setTimeout(function () {
                    $('#body').one('click', function () {
                        $('.info-tooltip.global-i').fadeOut(250);
                    });
                }, 1);
            } else {
                $('.info-tooltip.global-i').fadeOut(250);
            }
        } else {
            if ($(this).parent().parent().next().is(':visible')) {
                $(this).parent().parent().find('td:nth-child(6) a').text('Mehr');
                $(this).parent().parent().next().slideUp(0);
            } else {
                $(this).parent().parent().find('td:nth-child(6) a').text('X');
                $(this).parent().parent().next().slideDown(0);
            }
        }
    });

    function loadAppointmentPickerSlots() {
        if ($('.appointment-picker.loading').length > 0) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=load_appointment_picker_slots',
                success: function (response) {
                    var slots = JSON.parse(response);
                    $('.appointment-picker').removeClass('loading');
                    $('.appointment-picker').each(function () {
                        var thisAppointmentPicker = $(this);
                        var studioId = $(this).attr('data-studio-id');
                        var studioSlots = slots[studioId];
                        $(studioSlots).each(function () {
                            var datetime = $(this)[0].datetime;
                            var datetimeSplit = datetime.split(' ');
                            var date = datetimeSplit[0];
                            var dateSplit = date.split('-');
                            var convertedDate = dateSplit[0] + dateSplit[1] + dateSplit[2]
                            var time = datetimeSplit[1];
                            var timepSlit = time.split(':');
                            var convertedTime = timepSlit[0] + ':' + timepSlit[1];
                            var employeeId = $(this)[0].employee_id;
                            thisAppointmentPicker.find('.calendar li[data-date="' + convertedDate + '"] .time[data-time="' + convertedTime + '"]').attr('data-employee', employeeId).removeClass('inactive');
                        });
                    });
                }
            });
        }
    }

    $('.appointment-picker .time').click(function () {
        if (!$(this).hasClass('inactive')) {
            $('.appointment-picker .time').removeClass('active');
            $(this).addClass('active');
            $('.overlay-wrapper.appointment .page-navigation .button.next').click();
        }
    });
    var weeks = 4;
    var currentWeek = 1;
    var visibleWeeks = 2;

    function switchToNextWeek() {
        currentWeek += visibleWeeks;
        $('.appointment-picker:not(.inactive) .week-switcher.prev').removeClass('inactive');
        $('.appointment-picker:not(.inactive) .calendar').animate({
            scrollLeft: '+=' + $('.appointment-picker:not(.inactive) .calendar').outerWidth()
        }, 500);
        if (currentWeek + visibleWeeks - 1 >= weeks) {
            $('.appointment-picker:not(.inactive) .week-switcher.next').addClass('inactive');
        }
    }

    function switchToPrevWeek() {
        currentWeek -= visibleWeeks;
        $('.appointment-picker:not(.inactive) .week-switcher.next').removeClass('inactive');
        $('.appointment-picker:not(.inactive) .calendar').animate({
            scrollLeft: '-=' + $('.appointment-picker:not(.inactive) .calendar').outerWidth()
        }, 500);
        if (currentWeek == 1) {
            $('.appointment-picker:not(.inactive) .week-switcher.prev').addClass('inactive');
        }
    }

    $('.week-switcher.next').click(function () {
        if (!$(this).hasClass('inactive')) {
            switchToNextWeek();
        }
    });
    $('.week-switcher.prev').click(function () {
        if (!$(this).hasClass('inactive')) {
            switchToPrevWeek();
        }
    });
    var calendarInnerHeight = 0;
    $(".calendar:nth-child(2) li:first-child").children().each(function () {
        calendarInnerHeight += $(this).outerHeight() + parseInt($(this).css('margin-bottom'));
    });
    $('.calendar:nth-child(2)').scroll(function () {
        $(this).find('.calendar-shadow.top').css('top', $(this).scrollTop() + 'px');
        $(this).find('.calendar-shadow.bottom').css('bottom', '-' + $(this).scrollTop() + 'px');
        $(this).find('.calendar-shadow').css('left', $(this).scrollLeft() + 'px');
        if ($(this).scrollTop() == 0) {
            $(this).find('.calendar-shadow.top').addClass('hide');
        } else {
            $(this).find('.calendar-shadow.top').removeClass('hide');
        }
        if ($(this).scrollTop() + $(this).outerHeight() >= calendarInnerHeight) {
            $(this).find('.calendar-shadow.bottom').addClass('hide');
        } else {
            $(this).find('.calendar-shadow.bottom').removeClass('hide');
        }
    });
    var calendarTime = '00:00';
    var calendarTimeEnd = '00:00';
    var bookingStart = 0;
    var bookingEnd = 0;
    var overlayAppointementSent = false;
    $('.overlay .overlay-wrapper.appointment .page-navigation .next, .overlay .infobox .button, a[href*="#beratungstermin"]').click(function (e) {
        if (!$(this).hasClass('inactive')) {
            //loadAppointmentPickerSlots();
            if (currentOverlayPage == 1) {
                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                    ga('send', 'event', 'mitglied-werden', 'click', 'beratungstermin-vereinbaren');
                }
                if ($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
                    $('.overlay .page-navigation .next').fadeOut(250);
                    $('.overlay .page-navigation .overview').fadeOut(250);
                }
                $('.page-head').fadeOut(250);
                currentOverlayPage++;
                $('.page-main-' + (currentOverlayPage - 1)).fadeOut(250, function () {
                    $('.page-head').removeClass('left').fadeIn(250);
                    $('.page-main-' + currentOverlayPage).fadeIn(250);
                    $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                    $('.overlay .page-navigation .next').fadeIn(250).css('display', 'inline-block');
                    $('.overlay .page-navigation .overview').fadeIn(250);
                });
            } else if (currentOverlayPage == 2 && $('.appointment-picker:not(.inactive) .time.active').length > 0) {
                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                    ga('send', 'event', 'beratungstermine', 'click', 'beratungstermine-kalender');
                }
                calendarTime = $('.appointment-picker:not(.inactive) .time.active').data('time').toString();
                if ($('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(3, 2) == '30') {
                    var hour = parseInt($('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(0, 2)) + 1;
                    if (hour.toString().length == 1) {
                        hour = '0' + hour
                    }
                    calendarTimeEnd = hour + '00';
                } else {
                    calendarTimeEnd = ($('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(0, 2)) + '' + (parseInt($('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(3, 2)) + 30);
                }
                calendarDate = $('.appointment-picker:not(.inactive) .time.active').parent().data('date').toString();
                calendarWeekday = $('.appointment-picker:not(.inactive) .time.active').parent().data('weekday').toString();
                bookingStart = parseInt(calendarDate + $('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(0, 2) + $('.appointment-picker:not(.inactive) .time.active').data('time').toString().substr(3, 2) + '00');
                bookingEnd = parseInt(calendarDate + calendarTimeEnd + '00');

                if ($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
                    $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
                    $('.overlay .page-navigation .overview').fadeOut(250);
                }
                currentOverlayPage++;
                $('.page-main-' + (currentOverlayPage - 1)).fadeOut(250, function () {
                    $('.page-main .text .time').html(calendarTime);
                    $('.page-main .text .date').html(calendarWeekday + ', ' + calendarDate.substr(6, 2) + '.' + calendarDate.substr(4, 2) + '.');
                    $('.page-main .text .address').html($('.overlay-wrapper.appointment .appointment-picker:not(.inactive)').data('studio-name') + '<br />' + $('.overlay-wrapper.appointment .appointment-picker:not(.inactive)').data('studio-address'));
                    $('.overlay input[name="studio_id"]').val($('.overlay-wrapper.appointment .appointment-picker:not(.inactive)').data('studio-id'));
                    $('.page-main-' + currentOverlayPage).fadeIn(250);
                    $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                    $('.overlay-wrapper.appointment input[name="employee_id"]').val($('.appointment-picker:not(.inactive) .time.active').data('employee'));
                    if (currentOverlayPage == 3) {
                        $('.overlay .page-navigation .prev').hide();
                    }
                    $('.overlay .page-navigation .overview').fadeIn(250);
                });
            }
        }
    });
    $('.overlay .overlay-wrapper.trial .page-navigation .next').click(function () {
        if (!$(this).hasClass('inactive')) {
            if ($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
                $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
                $('.overlay .page-navigation .overview').fadeOut(250);
            }
            currentOverlayPage++;
            $('.page-main-' + (currentOverlayPage - 1)).fadeOut(250, function () {
                $('.page-main-' + currentOverlayPage).fadeIn(250);
                $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                $('.overlay .page-navigation .overview').fadeIn(250);
            });
        }
    });
    $('.overlay .page-navigation .prev, .overlay .appointment-form .prev').click(function () {
        if (!$(this).hasClass('inactive')) {
            if (currentOverlayPage - 1 <= 1) {
                $('.overlay .page-navigation .prev').addClass('inactive').fadeOut(250);
                $('.overlay .page-navigation .overview').fadeOut(250);
            }
            currentOverlayPage--;
            if (currentOverlayPage == 1) {
                $('.page-head').fadeOut(250, function () {
                    $('.page-head').addClass('left').fadeIn(250);
                });
            }
            $('.overlay .page-navigation .overview').fadeOut(250);
            $('.page-main-' + (currentOverlayPage + 1)).fadeOut(250, function () {
                if (currentOverlayPage > 1) {
                    $('.overlay .page-navigation .prev').fadeIn(250);
                }
                $('.page-main-' + currentOverlayPage).fadeIn(250);
                $('.overlay .page-navigation .next').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                $('.overlay .page-navigation .overview').fadeIn(250);
            });
        }
    });
    $('.open-request-password-by-email').click(function () {
        if (!$(this).hasClass('inactive')) {
            if ($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
                $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
                $('.overlay .page-navigation .overview').fadeOut(250);
            }
            currentOverlayPage++;
            $('.page-main-' + (currentOverlayPage - 1)).fadeOut(250, function () {
                $('.page-main-' + currentOverlayPage).fadeIn(250);
                $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                $('.overlay .page-navigation .overview').fadeIn(250);
            });
        }
    });
    /*$('.open-request-password-by-member-id').click(function() {
    if($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
      $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
      $('.overlay .page-navigation .overview').fadeOut(250);
    }
    currentOverlayPage++;
    currentOverlayPage++;
    $('.overlay-wrapper.login .page-main-3 .text.primary').hide();
    $('.overlay-wrapper.login .page-main-3 .text.secondary').show();
    $('.page-main-' + (currentOverlayPage - 2)).fadeOut(250, function() {
      $('.page-main-' + currentOverlayPage).fadeIn(250);
      $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
      $('.overlay .page-navigation .overview').fadeIn(250);
    });
  });*/
    $('.overlay-wrapper.login .prev').click(function () {
        if ($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
            $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
            $('.overlay .page-navigation .overview').fadeOut(250);
        }
        currentOverlayPage = 1;
        $('.overlay-wrapper.login .page-main-2, .overlay-wrapper.login .page-main-3').fadeOut(250);
        setTimeout(function () {
            $('.overlay-wrapper.login .page-main-3 .text.primary').show();
            $('.overlay-wrapper.login .page-main-3 .text.secondary').hide();
            $('.page-main-' + currentOverlayPage).fadeIn(250);
            $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
            $('.overlay .page-navigation .overview').fadeIn(250);
        }, 250);
    });

    /*if($('.open-request-password-by-email').hasClass('clicknow')) {
    if($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
      $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
      $('.overlay .page-navigation .overview').fadeOut(250);
    }
    currentOverlayPage++;
    currentOverlayPage++;
    $('.page-main-' + (currentOverlayPage - 2)).fadeOut(250, function() {
      $('.page-main-' + currentOverlayPage).fadeIn(250);
      $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
      $('.overlay .page-navigation .overview').fadeIn(250);
    });
  }*/
    function validateAppointmentForm() {
        $('.appointment-form input.required').removeClass('error');
        $('.appointment-form select.required').next().removeClass('error');
        $('.appointment-form span.error').removeClass('visible');
        $('.appointment-form checkboxes.error').removeClass('visible');
        /*var formQ1 = $('.appointment-form select[name="q1"]').val();
    if(formQ1 == 'none') {
      $('.appointment-form select[name="q1"]').next().addClass('error').next().addClass('visible');
    }
    var formQ2 = $('.appointment-form select[name="q2"]').val();
    if(formQ2 == 'none') {
      $('.appointment-form select[name="q2"]').next().addClass('error').next().addClass('visible');
    }
    var formQ3 = $('.appointment-form input[name="q3"]').val();
    if(formQ3 == '') {
      $('.appointment-form input[name="q3"]').addClass('error').next().addClass('visible');
    }*/
        var formFirstname = $('.appointment-form input[name="firstname"]').val();
        if (formFirstname == '') {
            $('.appointment-form input[name="firstname"]').addClass('error').next().addClass('visible');
        }
        var formLastname = $('.appointment-form input[name="lastname"]').val();
        if (formLastname == '') {
            $('.appointment-form input[name="lastname"]').addClass('error').next().addClass('visible');
        }
        var formEmail = $('.appointment-form input[name="email"]').val();
        var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
        if (!filter.test(formEmail)) {
            $('.appointment-form input[name="email"]').addClass('error').next().addClass('visible');
        }
        var formPhone = $('.appointment-form input[name="phone"]').val();
        if (formPhone == '') {
            $('.appointment-form input[name="phone"]').addClass('error').next().addClass('visible');
        }
        var trialPrivacy = $('.appointment-form input[name="privacy"]');
        if (!trialPrivacy.is(':checked')) {
            trialPrivacy.addClass('error').parent().addClass('visible');
        }
        var trialType = $('.appointment-form input[name="type"]:checked').val();
        if (trialType == undefined) {
            $('.appointment-form .checkboxes').addClass('visible');
        }
        /*var formDob = $('.appointment-form input[name="dob"]').val();
    if(formDob == '') {
      $('.appointment-form input[name="dob"]').addClass('error').next().addClass('visible');
    }*/
    }

    var appointmentFormInactive = false;
    $('.appointment-form input[type="submit"]').click(function (e) {
        e.preventDefault();
        validateAppointmentForm();
        if ($('.appointment-form span.error.visible').length == 0) {
            if (appointmentFormInactive == false) {
                appointmentFormInactive = true;
                var studioName = $('.overlay-wrapper.appointment select[name="select-studio"]').val();
                if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                    ga('send', 'event', 'beratungstermine', 'click', 'beratungstermin-verschickt');
                    ga('send', 'event', 'beratungstermin', 'click', 'beratungstermin-angefordert-' + studioName);
                    goog_report_conversion('https://www.elements.com/beratungstermin');
                    fbq('track', 'Termin vereinbaren');
                    gtag('event', 'conversion', {'send_to': 'AW-1007250080/jLOtCOfKoJgBEKDVpeAD'});
                }
                var bookingQ1 = $('.appointment-form select[name="q1"]').val();
                var bookingQ2 = $('.appointment-form select[name="q2"]').val();
                var bookingQ3 = $('.appointment-form input[name="q3"]').val();
                var bookingQ4 = $('.appointment-form input[name="q4"]').val();
                var bookingFirstname = $('.appointment-form input[name="firstname"]').val();
                var bookingLastname = $('.appointment-form input[name="lastname"]').val();
                var bookingPhone = $('.appointment-form input[name="phone"]').val();
                var bookingEmail = $('.appointment-form input[name="email"]').val();
                var bookingType = $('.appointment-form input[name="type"]:checked').val();
                var bookingDob = $('.appointment-form input[name="dob"]').val();
                var bookingMessage = $('.appointment-form textarea[name="message"]').val();
                var newsletter = $('.appointment-form input[name="newsletter"]').is(':checked') ? 1 : 0;
                var studioId = $('.overlay input[name="studio_id"]').val();
                var employeeId = $('.overlay input[name="employee_id"]').val();
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: 'action=save_appointment&employee_id=' + employeeId + '&studio_id=' + studioId + '&booking_start=' + bookingStart + '&booking_end=' + bookingEnd + '&booking_firstname=' + bookingFirstname + '&booking_lastname=' + bookingLastname + '&booking_phone=' + bookingPhone + '&booking_email=' + bookingEmail + '&booking_type=' + bookingType + '&booking_dob=' + bookingDob + '&booking_message=' + bookingMessage + '&booking_q1=' + bookingQ1 + '&booking_q2=' + bookingQ2 + '&booking_q3=' + bookingQ3 + '&booking_q4=' + bookingQ4 + '&newsletter=' + newsletter,
                    success: function (results) {
                        $('.appointment-form').find('input[type="text"], input[type="email"], textarea').val('');
                        $('.appointment-form').fadeOut(250).prev().find('hr').fadeOut(250);
                        $('.overlay .page-navigation').fadeOut(250);
                        var successMessageHeight = $('.overlay .appointment .success-message').show().css('height', 'auto').height();
                        $('.overlay .appointment .success-message').css('height', '0');
                        $('.overlay .appointment .success-message').animate({
                            opacity: 1,
                            height: successMessageHeight + 'px'
                        }, 500);
                        overlayAppointementSent = true;
                    }
                });
            }
        }
    });
    $('.overlay-wrapper.trial select[name="select-studio"]').on('change', function () {
        scrollToOverlaySelect($(this));

        if (this.value != 'none') {
            $('.overlay-wrapper.trial .trial-form').fadeIn(250);
            $('.overlay-wrapper.trial input[name="studio_id"]').val(this.value);

            if (this.value == 9) {
                $('.overlay-wrapper.trial .trial-form .trial-info .info-henninger-turm').fadeIn(250);
            } else {
                $('.overlay-wrapper.trial .trial-form .trial-info .info-henninger-turm').fadeOut(250);
            }
        } else {
            $('.overlay-wrapper.trial .trial-form').fadeOut(250);
            $('.overlay-wrapper.trial .trial-form .trial-info .info-henninger-turm').fadeOut(250);
        }
    });
    $('.trial-form input[type="submit"]').click(function (e) {
        e.preventDefault();
        $('.trial-form input').removeClass('error');
        $('span.error').removeClass('visible');
        var trialTitle = $('.trial-form select[name="select-title"]').val();
        var trialFirstname = $('.trial-form input[name="firstname"]').val();
        if (trialFirstname == '') {
            $('.trial-form input[name="firstname"]').addClass('error').next().addClass('visible');
        }
        var trialLastname = $('.trial-form input[name="lastname"]').val();
        if (trialLastname == '') {
            $('.trial-form input[name="lastname"]').addClass('error').next().addClass('visible');
        }
        var trialEmail = $('.trial-form input[name="email"]').val();
        var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
        if (!filter.test(trialEmail)) {
            $('.trial-form input[name="email"]').addClass('error').next().addClass('visible');
        }
        var trialPhone = $('.trial-form input[name="phone"]').val();
        if (trialPhone == '') {
            //$('.trial-form input[name="phone"]').addClass('error').next().addClass('visible');
        }
        var trialPrivacy = $('.trial-form input[name="privacy"]');
        if (!trialPrivacy.is(':checked')) {
            trialPrivacy.addClass('error').parent().addClass('visible');
        }
        var trialStudioId = $('.trial-form input[name="studio_id"]').val();
        var trialStudioName = $('.overlay-wrapper.trial select[name="select-studio"] option[value="' + trialStudioId + '"]').data('slug');
        if ($('.trial-form span.error.visible').length == 0) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=save_trial&trial_title=' + trialTitle + '&trial_firstname=' + trialFirstname + '&trial_lastname=' + trialLastname + '&trial_email=' + trialEmail + '&trial_phone=' + trialPhone + '&trial_studio=' + trialStudioId,
                success: function (results) {
                    var obj = jQuery.parseJSON(results);
                    if (obj.success == true) {
                        $('.overlay .trial .text, .overlay .trial .trial-form').fadeOut(250);
                        var successMessageHeight = $('.overlay .trial .success-message').show().css('height', 'auto').height();
                        $('.overlay .trial .success-message').css('height', '0');
                        $('.overlay .trial .success-message').animate({
                            opacity: 1,
                            height: successMessageHeight + 'px'
                        }, 500);
                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                            fbq('track', 'CompleteRegistration');
                            ga('send', 'event', 'probetraining', 'click', 'probetraining-angefordert-' + trialStudioName);
                            goog_report_conversion('https://www.elements.com/probetraining');
                        }
                    } else {
                        $('.trial-form input[type="submit"]').next().addClass('visible');
                    }
                }
            });
        }
    });
    var requestByEmailInactive = false;
    $('.request-password-by-email-form input[type="submit"]').click(function (e) {
        e.preventDefault();
        $('.request-password-by-email-form input').removeClass('error');
        $('span.error').removeClass('visible');
        $('span.error-2').removeClass('visible');
        var user = $('.request-password-by-email-form input[name="user"]').val();
        if (user == '') {
            $('.request-password-by-email-form input[name="user"]').addClass('error').next().addClass('visible');
        }
        var trialPrivacy = $('.request-password-by-email-form input[name="privacy"]');
        if (!trialPrivacy.is(':checked')) {
            trialPrivacy.addClass('error').parent().addClass('visible');
        }
        if ($('.request-password-by-email-form span.error.visible').length == 0) {
            if (requestByEmailInactive == false) {
                requestByEmailInactive = true;
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: 'action=request_password_by_email&user=' + user,
                    success: function (results) {
                        requestByEmailInactive = false;
                        if (results.success == false) {
                            /*if($('.overlay .page-navigation .overview').data('pages') >= currentOverlayPage + 1) {
                $('.overlay .page-navigation .next').addClass('inactive').fadeOut(250);
                $('.overlay .page-navigation .overview').fadeOut(250);
              }
              currentOverlayPage++;
              $('.page-main-' + (currentOverlayPage - 1)).fadeOut(250, function() {
                $('.page-main-' + currentOverlayPage).fadeIn(250);
                $('.overlay .page-navigation .prev').fadeIn(250).removeClass('inactive').css('display', 'inline-block');
                $('.overlay .page-navigation .overview').fadeIn(250);
              });*/
                            $('.request-password-by-email-form input[name="user"]').addClass('error').next().next().addClass('visible');
                        } else {
                            $('.request-password-by-email-form').fadeOut(250).prev().fadeOut(250);
                            var successMessageHeight = $('.overlay .login .page-main-2 .success-message').show().css('height', 'auto').height();
                            $('.overlay .login .page-main-2 .success-message').css('height', '0');
                            $('.overlay .login .page-main-2 .success-message').animate({
                                opacity: 1,
                                height: successMessageHeight + 'px'
                            }, 500);
                        }
                    }
                });
            }
        }
    });

    function validateRequestByDataForm() {
        $('.request-password-by-data-form input').removeClass('error');
        $('.request-password-by-data-form span.error').removeClass('visible');
        var memberId = $('.request-password-by-data-form input[name="member-id"]').val();
        if (memberId == '') {
            $('.request-password-by-data-form input[name="member-id"]').addClass('error').next().addClass('visible');
        }
        var dob = $('.request-password-by-data-form input[name="dob"]').val();
        if (dob == '') {
            $('.request-password-by-data-form input[name="dob"]').addClass('error').next().addClass('visible');
        }
        var user = $('.request-password-by-data-form input[name="user"]').val();
        if (user == '') {
            $('.request-password-by-data-form input[name="user"]').addClass('error').next().addClass('visible');
        }
    }

    var requestByDataInactive = false;
    $('.request-password-by-data-form input[type="submit"]').click(function (e) {
        e.preventDefault();
        validateRequestByDataForm();
        if ($('.request-password-by-data-form span.error.visible').length == 0) {
            if (requestByDataInactive == false) {
                requestByDataInactive = true;
                var memberId = $('.request-password-by-data-form input[name="member-id"]').val();
                var dob = $('.request-password-by-data-form input[name="dob"]').val();
                var user = $('.request-password-by-data-form input[name="user"]').val();
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: 'action=request_password_by_data&user=' + user + '&member_id=' + memberId + '&dob=' + dob,
                    success: function (results) {
                        requestByDataInactive = false;
                        if (results.success == false) {
                            $('input[name="request-password-by-member-id"]').next().addClass('visible');
                        } else {
                            $('.request-password-by-data-form').fadeOut(250).prev().fadeOut(250).prev().fadeOut(250);
                            var successMessageHeight = $('.overlay .login .page-main-3 .success-message').show().css('height', 'auto').height();
                            $('.overlay .login .page-main-3 .success-message').css('height', '0');
                            $('.overlay .login .page-main-3 .success-message').animate({
                                opacity: 1,
                                height: successMessageHeight + 'px'
                            }, 500);
                        }
                    }
                });
            }
        }
    });
    hasClassOpen = false;
    $('body').on('click', '.courseplan .accordion .head span', function () {
        if ($(this).parent().parent().hasClass('open')) {
            hasClassOpen = true;
        } else {
            hasClassOpen = false;
        }
        $('.courseplan .accordion').removeClass('open');
        $('.courseplan .accordion .body').stop().slideUp(250);
        if (hasClassOpen == false) {
            $(this).parent().parent().addClass('open');
            $(this).parent().parent().find('.body').stop().slideDown(250);
            if ($(this).parent().parent().find('.body').scrollLeft() == 0) {
                $(this).parent().parent().find('.body').parent().find('.shadow.left').addClass('hide');
            } else {
                $(this).parent().parent().find('.body').parent().find('.shadow.left').removeClass('hide');
            }
            if ($(this).parent().parent().find('.body').scrollLeft() + $(this).parent().parent().find('.body').outerWidth() >= $(this).parent().parent().find('.body').parent().find('table').outerWidth()) {
                $(this).parent().parent().find('.body').parent().find('.shadow.right').addClass('hide');
            } else {
                $(this).parent().parent().find('.body').parent().find('.shadow.right').removeClass('hide');
            }
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=set_day_session&day=' + $(this).data('day'),
                success: function (results) {
                }
            });
        } else {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=set_day_session&day=false',
                success: function (results) {
                }
            });
        }
    });
    $('.infobox input[name="pricemodel"]').click(function () {
        var value = $(this).val();
        $.when($('.infobox .price').fadeOut(250)).done(function () {
            $('.infobox .price[data-pricemodel="' + value + '"]').fadeIn(250);
        });
    });
    $('.trainer .accordion .head').click(function () {
        if ($(this).parent().hasClass('open')) {
            var hasClassOpen = true;
        } else {
            var hasClassOpen = false;
        }
        $('.trainer .accordion').removeClass('open')
        $('.trainer .accordion p').stop().slideUp(250);
        if (hasClassOpen == false) {
            $(this).parent().addClass('open')
            $(this).parent().find('p').stop().slideDown(250);
        }
    });

    $('.close-overlay').click(function () {
        enableScrolling();
        $('.overlay').fadeOut(250, function () {
            $('.overlay').show();
            $('.page-main').hide();
            $('.page-main-1').show();
            $('.calendar').scrollTop(0);
            $('.calendar').scrollLeft(0);
            $('.week-switcher.prev').click();
            $('.overlay').hide();
            $('.appointment-picker .time').removeClass('active');
            $('.overlay .page-navigation .prev').addClass('inactive').hide();
            $('.overlay .page-navigation .next').removeClass('inactive').css('display', 'inline-block');
            $('.page-head').addClass('left').fadeIn(250);
            currentOverlayPage = 1;
        });
    });

    /* Sidebar */
    if ($(window).width() < 768) {
        $('.widget.course, .widget.service').addClass('mobile');
    }
    if ($('.widget.course .widget-box .button, .widget.service .widget-box .button').find('div span').length > 0) {
        $('.widget.course .widget-box .button, .widget.service .widget-box .button').find('div span').css({
            'top': '-' + ($('.widget.course .widget-box .button, .widget.service .widget-box .button').position().top + 41) + 'px',
            'bottom': '-' + ($('.widget.course, .widget.service').outerHeight() - $('.widget.course .widget-box .button, .widget.service .widget-box .button').position().top - $('.widget.course .widget-box .button, .widget.service .widget-box .button').outerHeight() - 79) + 'px'
        });
    }
    $('.widget.special, .widget.post, .widget.custom').hover(function () {
        $(this).find('.text').stop().slideDown(250);
    }, function () {
        $(this).find('.text').stop().slideUp(250);
    });

    /* Filter */
    $('#introbox .filter .button').click(function () {
        if ($(this).data('category') == 'all') {
            $('#introbox .filter .button').addClass('inactive');
            $('#introbox .filter .button[data-category="all"]').removeClass('inactive');
        } else {
            $(this).toggleClass('inactive');
            $('#introbox .filter .button[data-category="all"]').addClass('inactive');
            if ($('#introbox .filter .button:not(.inactive)').length == 0) {
                $('#introbox .filter .button[data-category="all"]').removeClass('inactive');
            }
        }
    });
    $('#introbox .studio-filter ul li').click(function () {
        if ($(this).hasClass('active')) {
            $('#introbox .studio-filter ul li').removeClass('active inactive');
        } else {
            $('#introbox .studio-filter ul li').removeClass('active').addClass('inactive');
            $(this).removeClass('inactive').addClass('active');
        }
    });
    $('#introbox .filter .button, #introbox .studio-filter ul li').click(function () {
        $.when($('.list.services .service').fadeOut(250)).done(function () {
            $('.list.services .service').addClass('hide studio-hide');
            if ($('#introbox .filter .button:not(.inactive)[data-category="all"]').length == 0) {
                $('#introbox .filter .button').each(function () {
                    if (!$(this).hasClass('inactive')) {
                        $('.list.services .service[data-categories~="' + $(this).data('category') + '"]').removeClass('hide');
                    }
                });
            } else {
                $('.list.services .service').removeClass('hide');
            }
            $('#introbox .studio-filter ul li').each(function () {
                if (!$(this).hasClass('inactive')) {
                    $('.list.services .service[data-studios~="' + $(this).data('studio') + '"]').removeClass('studio-hide');
                }
            });
            $('.list.services .service:not(.hide)').fadeIn(250);
        });
        $.when($('.teasers .teaser').fadeOut(250)).done(function () {
            $('.teasers .teaser').addClass('hide studio-hide');
            if ($('#introbox .filter .button:not(.inactive)[data-category="all"]').length == 0) {
                $('#introbox .filter .button').each(function () {
                    if (!$(this).hasClass('inactive')) {
                        $('.teasers .teaser[data-categories~="' + $(this).data('category') + '"]').removeClass('hide');
                    }
                });
            } else {
                $('.teasers .teaser').removeClass('hide');
            }
            $('#introbox .studio-filter ul li').each(function () {
                if (!$(this).hasClass('inactive')) {
                    $('.teasers .teaser[data-studios~="' + $(this).data('studio') + '"]').removeClass('studio-hide');
                }
            });
            $('.teasers .teaser:not(.hide):not(.studio-hide)').fadeIn(250);
        });
    });
    if ($('body').hasClass('page-template-template-services')) {
        var hash = window.location.hash;
        $('.filter ul li a').each(function () {
            if ('#' + $(this).data('category') == hash || '#' + $(this).data('category-name') == hash) {
                $(this).click();
                history.pushState("", document.title, window.location.pathname);
            }
        });
    }

    var $grid = $('.events .table-wrapper.has-filter .tbody').isotope({
        hiddenStyle: {
            opacity: 0
        },
        visibleStyle: {
            opacity: 1
        },
        transitionDuration: '0.5s'
    });

    $('.events .table-wrapper.has-filter .filter .button').click(function () {
        if ($(this).data('category') == 'all') {
            $('.events .table-wrapper .button').addClass('inactive');
            $('.events .table-wrapper .button[data-category="all"]').removeClass('inactive');
        } else {
            $(this).toggleClass('inactive');
            $('.events .table-wrapper .button[data-category="all"]').addClass('inactive');
            if ($('.events .table-wrapper .button:not(.inactive)').length == 0) {
                $('.events .table-wrapper .button[data-category="all"]').removeClass('inactive');
            }
        }

        if (!$('.events .filter .button[data-category="all"]').hasClass('inactive')) {
            $grid.isotope({
                filter: '[data-studios]'
            });
        } else {
            var studios = '';
            $('.events .filter .button:not([data-category="all"]):not(.inactive)').each(function () {
                studios += '[data-studios*="' + $(this).attr('data-category') + '"],';
            });
            studios = $.trim(studios).slice(0, -1);
            $grid.isotope({
                filter: studios
            });
        }
    });
    $('.events .table-wrapper.has-filter .show-more-mobile').click(function () {
        setTimeout(function () {
            $grid.isotope();
        }, 1);
    });

    /* News */
    function news() {
        var news = $('.content .news');
        news.each(function () {
            var thisEl = $(this);
            var filtersButton = $(this).find('.filters .button');

            function updateNews() {
                var teaser = thisEl.find('.teasers .teaser');
                if (filtersButton.filter('[data-category="all"]').hasClass('inactive') && filtersButton.filter(':not(.inactive)').length > 0) {
                    teaser.fadeOut(250);
                    setTimeout(function () {
                        teaser.removeClass('visible');
                        filtersButton.each(function () {
                            if (!$(this).hasClass('inactive')) {
                                teaser.filter('[data-categories~="' + $(this).data('category') + '"]').addClass('visible');
                            }
                        });
                        if ($(window).width() < 1023) {
                            teaser.filter('.visible').css('display', 'block').hide().fadeIn(250);
                        } else {
                            teaser.filter('.visible').css('display', 'flex').hide().fadeIn(250);
                        }
                    }, 250);
                } else {
                    teaser.fadeOut(250);
                    setTimeout(function () {
                        teaser.removeClass('visible');
                        if ($(window).width() <= 1023) {
                            teaser.css('display', 'block').hide().fadeIn(250);
                        } else {
                            teaser.css('display', 'flex').hide().fadeIn(250);
                        }
                    }, 250);
                }
            }

            filtersButton.click(function () {
                if ($(this).data('category') == 'all') {
                    filtersButton.addClass('inactive');
                    filtersButton.filter('[data-category="all"]').removeClass('inactive');
                } else {
                    $(this).toggleClass('inactive');
                    filtersButton.filter('[data-category="all"]').addClass('inactive');
                    if (filtersButton.filter(':not(.inactive)').length == 0) {
                        filtersButton.filter('[data-category="all"]').removeClass('inactive');
                    }
                }
                updateNews();
            });
        });
    }

    news();

    function newsEyecatcher() {
        var newsEyecatcher = $('.news-eyecatcher');
        newsEyecatcher.each(function () {
            var thisEl = $(this);
            if (Cookies.get('news_eyecatcher') != 'closed') {
                thisEl.fadeIn(250);
            }
            $(this).find('.eyecatcher-close').click(function () {
                thisEl.fadeOut(250);
                Cookies.set('news_eyecatcher', 'closed');
            });
        });
    }

    newsEyecatcher();

    /* Select2 */
    if ($(window).width() >= 768) {
        $('#introbox select, .widget.courseplan select, .overlay select, .newsletter-wrapper select, .price-models-select-studio select').select2({
            minimumResultsForSearch: Infinity
        });
    }
    $('#introbox.dark select').on('change', function () {
        window.location.href = this.value;
    });
    $('.price-models-select-studio select').on('change', function () {
        var prices = $('.prices');
        var price = prices.find('.price');
        price.hide();
        if (this.value !== 'none') {
            price.filter('[data-studios*="|' + this.value + '|"]').show();
        } else {
            price.filter('.price-placeholder').show();
        }
    });
    $('.page-template-template-myelements #introbox select, .page-template-template-myelements .overlay select, .page-template-template-checkins #introbox select, .widget.courseplan select').on('change', function () {
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: 'action=set_studio_session&studio=' + this.value,
            success: function (results) {
                window.location.href = window.location.href;
            }
        });
    });
    $('#introbox:not(.dark) select, .widget.courseplan select, .price-models-select-studio select').on('select2:open', function () {
        $('.select2-dropdown').show();
        $('.select2-dropdown').addClass('open light');
    });
    $('#introbox.dark select').on('select2:open', function () {
        $('.select2-dropdown').show();
        $('.select2-dropdown').addClass('open dark');
    });
    $('.overlay select').on('select2:open', function () {
        $('.select2-dropdown').show();
        $('.select2-dropdown').addClass('open transparent');
    });
    $('.newsletter-wrapper select').on('select2:open', function () {
        $('.select2-dropdown').show();
        $('.select2-dropdown').addClass('open');
    });

    function checkContactForm() {
        if ($('.contact-form select').length > 0) {
            $('.contact-form-wrapper select').select2({
                minimumResultsForSearch: Infinity
            });
            $('.content-container .contact-form-wrapper select').on('select2:open', function () {
                $('.select2-dropdown').show();
                $('.select2-dropdown').addClass('open');
            });
            $('.overlay .contact-form-wrapper select').on('select2:open', function () {
                $('.select2-dropdown').show();
                $('.select2-dropdown').addClass('open dark');
            });
            $('.change-form-wrapper select').on('change', function () {
                scrollToOverlaySelect($(this));
                $('.contact-form').addClass('inactive');
                if (this.value != 'none') {
                    $('.contact-form').addClass('inactive');
                    $('.contact-form[data-form-id="' + this.value + '"]').removeClass('inactive');
                }
            });
            $('.contact-form-wrapper select').on('change', function () {
                $(this).parent().parent().parent().parent().parent().next().find('select').addClass('chtest').prop('selectedIndex', $(this)[0].selectedIndex).trigger('change');
            });
            $('.change-form-wrapper select').on('change', function () {
                $('.contact-form').addClass('inactive');
                if (this.value != 'none') {
                    $('.contact-form').addClass('inactive');
                    $('.contact-form[data-form-id="' + this.value + '"]').removeClass('inactive');
                }
            });
            $('.w50').each(function () {
                $(this).parent().addClass('w50');
            });
            $('.contact-form-wrapper').each(function () {
                $(this).find('h3.empty').html($(this).find('.contact-form.first .html-wrap h3').html());
                $(this).find('h4.empty').html($(this).find('.contact-form.first .html-wrap h4').html());
                $(this).find('p.empty').html($(this).find('.contact-form.first .html-wrap p').html());
            });
            $('.contact-form .html-container').parent().remove();
            $('nf-field:nth-child(2)').each(function () {
                if ($(this).find('.nf-field-container').hasClass('listselect-container')) {
                    $(this).hide();
                }
            });
        } else {
            setTimeout(checkContactForm, 100);
        }
    }

    checkContactForm();

    /* Eyecatcher */
    if (Cookies.get('eyecatcher') != 'closed') {
        $('#slider-eyecatcher').fadeIn(250);
        $('.eyecatcher-close').click(function () {
            $(this).parent().fadeOut(250);
            Cookies.set('eyecatcher', 'closed');
        });
    }

    /* Studios */
    editInfowindow = function () {
        $('.gm-style-iw').parent().hide();
        $('.gm-style-iw').css('top', '0').css('left', '0').css('min-width', '100%');
        $('.gm-style-iw').find('div').css('overflow', 'visible');
        $('.gm-style-iw').prev().find('div').css('border', 'none').css('border-radius', '0').css('box-shadow', 'none');
        $('.gm-style-iw').prev().find('div:nth-child(2)').css('background', 'none');
        $('.gm-style-iw').next().remove();
        $('.gm-style-iw').parent().fadeIn(250);
    };

    /* General */
    $(window).bind('load', function () {
        var lines;
        if ($(window).width() > 1024) {
            $('.vc_col-sm-6:first-child:not(.right) h2, .vc_col-sm-6.left h2, .vc_col-sm-6:first-child:not(.right) h4, .vc_col-sm-6.left h4').each(function () {
                lines = $(this).height() / parseInt($(this).css('line-height'));
                for (var i = 1; i <= lines; i++) {
                    $(this).prepend('<span></span>');
                    lines = parseInt($(this).height() / parseInt($(this).css('line-height')));
                }
                $(this).closest('.vc_col-sm-6').next().find('.wpb_single_image, .wpb_video_wrapper').css('margin-top', '122px');
            });
        }
        $('.prettyphoto').unbind('click').removeAttr('data-rel').addClass('fancybox').removeClass('prettyphoto').attr('rel', 'group');
        $('.fancybox').each(function () {
            $(this).attr('title', $(this).find('img').attr('alt'));
        });
        $('.fancybox').fancybox({
            padding: 0,
            tpl: {
                closeBtn: '<div title="schließen" class="fancybox-item fancybox-close" href="javascript:;">schließen</div>',
                next: '<a title="nächstes Bild" class="fancybox-nav fancybox-next" href="javascript:;"><span>nächstes Bild</span></a>',
                prev: '<a title="vorheriges Bild" class="fancybox-nav fancybox-prev" href="javascript:;"><span>vorheriges Bild</span></a>'
            },
            openEffect: 'none',
            closeEffect: 'none',
            nextEffect: 'none',
            prevEffect: 'none',
            helpers: {
                overlay: {
                    closeClick: false,
                    speedOut: 0
                },
                title: {
                    type: 'outside'
                }
            }
        });
    });
    $('img').on('load', function () {
        if ($('.vc_col-sm-6:first-child:not(.right) .wpb_single_image img, .vc_col-sm-6.left .wpb_single_image img').length > 0) {
            $('.vc_col-sm-6:first-child:not(.right) .wpb_single_image img, .vc_col-sm-6.left .wpb_single_image img').each(function () {
                $(this).removeAttr('style');
                if ($(window).width() >= 767) {
                    var ratio = $(this).width() / $(this).height();
                    var offsetRight = $(window).width() - ($(this).offset().left + $(this).outerWidth());
                    var newWidth = offsetRight - 30;
                    if (newWidth / ratio <= 500) {
                        $(this).css('width', newWidth);
                        $(this).css('height', newWidth / ratio);
                    } else {
                        $(this).css('width', 500 * ratio);
                        $(this).css('height', 500);
                    }
                }
            });
        }
        if ($('.vc_col-sm-6:last-child:not(.left) .wpb_single_image img, .vc_col-sm-6.right .wpb_single_image img').length > 0) {
            $('.vc_col-sm-6:last-child:not(.left) .wpb_single_image img, .vc_col-sm-6.right .wpb_single_image img').each(function () {
                $(this).removeAttr('style');
                if ($(window).width() >= 767) {
                    var ratio = $(this).width() / $(this).height();
                    var newWidth = $(this).offset().left - 200 - 30;
                    if (newWidth / ratio <= 500) {
                        $(this).css('width', newWidth);
                        $(this).css('height', newWidth / ratio);
                    } else {
                        $(this).css('width', 500 * ratio);
                        $(this).css('height', 500);
                    }
                }
            });
        }
    });
    $(window).resize(function () {
        if ($('.vc_col-sm-6:first-child:not(.right) .wpb_single_image img, .vc_col-sm-6.left .wpb_single_image img').length > 0) {
            $('.vc_col-sm-6:first-child:not(.right) .wpb_single_image img, .vc_col-sm-6.left .wpb_single_image img').each(function () {
                $(this).removeAttr('style');
                if ($(window).width() >= 767) {
                    var ratio = $(this).width() / $(this).height();
                    var offsetRight = $(window).width() - ($(this).offset().left + $(this).outerWidth());
                    var newWidth = offsetRight - 30;
                    if (newWidth / ratio <= 500) {
                        $(this).css('width', newWidth);
                        $(this).css('height', newWidth / ratio);
                    } else {
                        $(this).css('width', 500 * ratio);
                        $(this).css('height', 500);
                    }
                }
            });
        }
        if ($('.vc_col-sm-6:last-child:not(.left) .wpb_single_image img, .vc_col-sm-6.right .wpb_single_image img').length > 0) {
            $('.vc_col-sm-6:last-child:not(.left) .wpb_single_image img, .vc_col-sm-6.right .wpb_single_image img').each(function () {
                $(this).removeAttr('style');
                if ($(window).width() >= 767) {
                    var ratio = $(this).width() / $(this).height();
                    var newWidth = $(this).offset().left - 200 - 30;
                    if (newWidth / ratio <= 500) {
                        $(this).css('width', newWidth);
                        $(this).css('height', newWidth / ratio);
                    } else {
                        $(this).css('width', 500 * ratio);
                        $(this).css('height', 500);
                    }
                }
            });
        }
        $('.tac-iframe').css('transform', 'none');
        $('.tac-iframe').css('margin-top', '0');
        $('.tac-wrapper').css('height', '454px');
        var availableWidth = $('.tac-wrapper').width();
        var availableHeight = $('.tac-wrapper').width();
        var contentWidth = $('.tac-iframe').width();
        var contentHeight = $('.tac-iframe').width();
        var scale = Math.min(
            availableWidth / contentWidth,
            availableHeight / contentHeight
        );
        if (scale < 1) {
            $('.tac-iframe').css('transform', 'scale(' + scale + ')');
            var heightBefore = $('.tac-wrapper').height();
            var heightAfter = $('.tac-wrapper').height() * scale;
            $('.tac-wrapper').css('height', $('.tac-wrapper').height() * scale);
            $('.tac-iframe').css('margin-top', '-' + ((heightBefore - heightAfter) / 2) + 'px')
        }
    });
    $(window).trigger('resize');
    $('.content-container hr, .cooperations hr, .specials-and-posts hr').each(function () {
        if ($(this).prev().css('text-align') == 'center') {
            $(this).css('text-align', 'center').css('margin-left', 'auto').css('margin-right', 'auto');
        }
    });
    $('.content-container h2, .content-container h4, .content-container h5').each(function () {
        if ($(this).css('text-align') == 'center') {
            $(this).parent().find('p').css('max-width', '750px').css('margin-left', 'auto').css('margin-right', 'auto');
        }
    });
    $('.courseplan button.inactive').click(function (e) {
        e.preventDefault();
    });
    $('.courseplan button.inactive').hover(function () {
        $('.info-tooltip.global-i').remove();
        var positionLeft = $(this).offset().left + $(this).outerWidth() / 2 - $(this).find('.info-tooltip').outerWidth() / 2;
        $(this).find('.info-tooltip').clone().appendTo('body').addClass('global-i').css('margin', '0').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top - $('.info-tooltip.global-i').outerHeight() - 10) + 'px');
    }, function () {
        $('.info-tooltip.global-i').fadeOut(250);
    });
    $('.courseplan .live').hover(function () {
        $('.info-tooltip.global').remove();
        var positionLeft = $(this).offset().left + $(this).outerWidth() / 2 - $(this).find('.info-tooltip').outerWidth() / 2;
        $(this).find('.info-tooltip').clone().appendTo('body').addClass('global').css('margin', '0').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top - $('.info-tooltip.global').outerHeight() - 10) + 'px');
    }, function () {
        $('.info-tooltip.global').fadeOut(250);
    });
    $('.info-tooltip:not(.more-infobox).global-i').on('hover', function () {
        $('.info-tooltip.global-i').fadeOut(250);
    });

    $('form.queue .info-tip span, form.unqueue .info-tip span').hover(function () {
        $('.info-tooltip.global').remove();
        var positionLeft = $(this).offset().left + $(this).outerWidth() / 2;
        $(this).find('.info-tooltip').clone().appendTo('body').addClass('global').css('bottom', 'auto').css('left', positionLeft + 'px').fadeIn(250).css('top', ($(this).offset().top - $('.info-tooltip.global').outerHeight() - 15) + 'px');
    }, function () {
        $('.info-tooltip.global').fadeOut(250);
    });
    $('.info-tooltip.global').on('hover', function () {
        $('.info-tooltip.global').fadeOut(250);
    });
    $('.infobox .info').hover(function () {
        $(this).find('span').stop().fadeIn(250);
    }, function () {
        $(this).find('span').stop().fadeOut(250);
    });
    $('a[href*="#login"]').click(function (e) {
        e.preventDefault();
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.login-information').show();
        $('.overlay').fadeIn(250);
    });
    $('a[data-login="online-plan"]').click(function (e) {
        e.preventDefault();
        $('<input />').attr('type', 'hidden').attr('name', 'login_online_plan').attr('value', '1').appendTo('header .login-form');
        $('<input />').attr('type', 'hidden').attr('name', 'online_course').attr('value', '1').appendTo('header .login-form');
        $('header .login-form').submit();
    });
    var hashLogin = window.location.hash;
    if (hashLogin == '#login') {
        if ($('header .login-form').length > 0) {
            disableScrolling();
            $('.overlay-wrapper').hide();
            $('.overlay-wrapper.login-information').show();
            $('.overlay').fadeIn(250);
        }
        history.pushState("", document.title, window.location.pathname);
    }
    $('a[href*="#logout"]').click(function (e) {
        e.preventDefault();
        $('header .logout-form button').click();
    });
    var hashLogout = window.location.hash;
    if (hashLogout == '#logout') {
        $('header .logout-form button').click();
    }
    $('a[href*="#kontakt"]').click(function (e) {
        e.preventDefault();
        $('.open-contact-overlay').click();
    });
    $('a[href*="#cookies"]').click(function (e) {
        e.preventDefault();
        window.BorlabsCookie.openCookiePreference();
    });
    $('a[href*="#summer22"]').click(function (e) {
        e.preventDefault();
        $('.open-summer-overlay').click();
    });
    var hashContact = window.location.hash;
    if (hashContact == '#kontakt') {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.contact').show();
        $('.overlay').fadeIn(250);
        history.pushState("", document.title, window.location.pathname);
    }
    if (hashContact == '#cookies') {
        setTimeout(function () {
            window.BorlabsCookie.openCookiePreference();
            history.pushState("", document.title, window.location.pathname);
        }, 500);
    }
    $('a[href*="#probetraining"]').click(function (e) {
        e.preventDefault();
        $('.open-trial-overlay').click();
    });
    var hashTrial = window.location.hash;
    if (hashTrial == '#probetraining') {
        disableScrolling();
        $('.overlay-wrapper').hide();
        $('.overlay-wrapper.trial').show();
        $('.overlay').fadeIn(250);
        history.pushState("", document.title, window.location.pathname);
    }
    var hashTrial = window.location.hash;
    if (hashTrial == '#beratungstermin') {
        $('a[href*="#beratungstermin"]').click();
        $('.overlay .infobox .button').click();
        history.pushState("", document.title, window.location.pathname);
    }
    $('a[href*="#mitglied-werden"]').click(function (e) {
        e.preventDefault();
        $('.open-appointment-overlay').click();
    });
    var hashNewMember = window.location.hash;
    if (hashNewMember == '#mitglied-werden') {
        $('a[href*="#mitglied-werden"]').click();
        history.pushState("", document.title, window.location.pathname);
    }
    $('a[href*="#24monate"]').click(function (e) {
        e.preventDefault();
        $('.select-pricemodel input[value="24months"]').prop('checked', true);
        $('.open-appointment-overlay').click();
        $.when($('.infobox .price').fadeOut(0)).done(function () {
            $('.infobox .price[data-pricemodel="24months"]').fadeIn(0);
        });
    });
    $('a[href*="#12monate"]').click(function (e) {
        e.preventDefault();
        $('.select-pricemodel input[value="12months"]').prop('checked', true);
        $('.open-appointment-overlay').click();
        $.when($('.infobox .price').fadeOut(0)).done(function () {
            $('.infobox .price[data-pricemodel="12months"]').fadeIn(0);
        });
    });
    $('a[href*="#6monate"]').click(function (e) {
        e.preventDefault();
        $('.select-pricemodel input[value="6months"]').prop('checked', true);
        $('.open-appointment-overlay').click();
        $.when($('.infobox .price').fadeOut(0)).done(function () {
            $('.infobox .price[data-pricemodel="6months"]').fadeIn(0);
        });
    });
    $('a[href*="#1monat"]').click(function (e) {
        e.preventDefault();
        $('.select-pricemodel input[value="1month"]').prop('checked', true);
        $('.open-appointment-overlay').click();
        $.when($('.infobox .price').fadeOut(0)).done(function () {
            $('.infobox .price[data-pricemodel="1month"]').fadeIn(0);
        });
    });
    $('a[href*="#youabo"]').click(function (e) {
        e.preventDefault();
        $('.select-pricemodel input[value="youabo"]').prop('checked', true);
        $('.open-appointment-overlay').click();
        $.when($('.infobox .price').fadeOut(0)).done(function () {
            $('.infobox .price[data-pricemodel="youabo"]').fadeIn(0);
        });
    });
    $('.anchor-navigation a').click(function () {
        var anchor = $(this).attr('data-anchor');
        if ($('#' + anchor).length > 0) {
            var offset = 0;
            if ($(window).width() <= 767) {
                offset = 88;
            }
            $('html, body').animate({scrollTop: $('#' + anchor).offset().top - 50 - 103 - offset}, 500);
        }
    });
    $(document).scroll(function () {
        var anchorNavigation = $('.anchor-navigation');
        if (anchorNavigation.length > 0) {
            var offset = 0;
            if ($(window).width() <= 767) {
                offset = 120;
            }
            if ($(window).scrollTop() >= $('#introbox').offset().top + $('#introbox').outerHeight() - offset) {
                anchorNavigation.addClass('sticky');
            } else {
                anchorNavigation.removeClass('sticky');
            }
        }
    });
    $('.tac-wrapper').css('height', '454px');
    var availableWidth = $('.tac-wrapper').width();
    var availableHeight = $('.tac-wrapper').width();
    var contentWidth = $('.tac-iframe').width();
    var contentHeight = $('.tac-iframe').width();
    var scale = Math.min(
        availableWidth / contentWidth,
        availableHeight / contentHeight
    );
    if (scale < 1) {
        $('.tac-iframe').css('transform', 'scale(' + scale + ')');
        var heightBefore = $('.tac-wrapper').height();
        var heightAfter = $('.tac-wrapper').height() * scale;
        $('.tac-wrapper').css('height', $('.tac-wrapper').height() * scale);
        $('.tac-iframe').css('margin-top', '-' + ((heightBefore - heightAfter) / 2) + 'px')
    }

    $('.load-map').each(function () {
        if (Cookies.get('load_map') == true || Cookies.get('load_map') == 'true') {
            var my_awesome_script = document.createElement('script');

            // LIVE
            my_awesome_script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA-wzqnf0a5TMYnlI7F-nYL-psLOOOhXe8&libraries=places&callback=initMap');

            // DEV
            // my_awesome_script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB-CCZ4iUPWj0KB9nuOwB08_77mROzmNxM&libraries=places&callback=initMap');

            document.head.appendChild(my_awesome_script);
        } else {
            $('#brlbs-content-blocker').show();
            $('.load-map').click(function () {
                var my_awesome_script = document.createElement('script');
                my_awesome_script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA-wzqnf0a5TMYnlI7F-nYL-psLOOOhXe8&libraries=places&callback=initMap');
                document.head.appendChild(my_awesome_script);
                $('#brlbs-content-blocker').remove();
                Cookies.set('load_map', true, {expires: 182});
            });
        }
    });

    if ($('.elements2go-shortcode.redirect').length > 0) {
        window.location.replace($('.elements2go-shortcode a.button').attr('href'));
    }

    /* Packages Height */
    function updatePackageHeights() {
        $('.list.packages .widget.package').css('height', 'auto');
        if ($(window).width() > 1260) {
            var count = 1;
            var height = 0;
            $('.list.packages .widget.package').each(function () {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
                if (count % 3 === 0) {
                    $('.list.packages .widget.package:nth-child(' + (count - 2) + ')').css('height', height + 'px');
                    $('.list.packages .widget.package:nth-child(' + (count - 1) + ')').css('height', height + 'px');
                    $('.list.packages .widget.package:nth-child(' + count + ')').css('height', height + 'px');
                    height = 0;
                }
                count++;
            });
        } else if ($(window).width() > 967) {
            var count = 1;
            var height = 0;
            $('.list.packages .widget.package').each(function () {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
                if (count % 2 === 0) {
                    $('.list.packages .widget.package:nth-child(' + (count - 1) + ')').css('height', height + 'px');
                    $('.list.packages .widget.package:nth-child(' + count + ')').css('height', height + 'px');
                    height = 0;
                }
                count++;
            });
        }
    }

    updatePackageHeights();
    $(window).resize(function () {
        updatePackageHeights();
    });

    /* Add to Homesceen */
    setTimeout(function () {
        function showHomescreenNotice() {
            if (Cookies.get('homescreen') != 'closed' && $('body').hasClass('home')) {
                addToHomescreen({
                    skipFirstVisit: false,
                    startDelay: 0,
                    lifespan: 0,
                    displayPace: 0,
                    maxDisplayCount: 9999,
                    icon: false,
                    onRemove: function () {
                        Cookies.set('homescreen', 'closed');
                    }
                });
            }
        }

        if ($('#cookie-notice').length == 0) {
            //showHomescreenNotice();
        }
        $('#cn-accept-cookie').click(function () {
            //showHomescreenNotice();
        });
    }, 1000);

    if ($('.widget.courseplan').length > 0) {
        var currentStudio = $('.widget.courseplan .change-studio option:checked').val();
        $.ajax({
            url: '/wp/wp-admin/admin-ajax.php',
            type: 'POST',
            data: 'action=get_courseplan_widget',
            success: function (response) {
                $('.widget.courseplan .widget-box').append(response);
            }
        });
    }

    $('.trial-table-mobile .toggle').click(function () {
        $(this).toggleClass('open');
        $(this).parent().find('ul').slideToggle(250);
    });

    // Pricing models
    $('.toggle-more-box').click(function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
            $(this).parent().find('.more-box').stop().slideDown(500);
        } else {
            $(this).parent().find('.more-box').stop().slideUp(500);
        }
    });

    // Version 2.0

    // Horizontal scroll
    var horizontalScroll = $('.horizontal-scroll');

    function initHorizontalScroll() {
        horizontalScroll.each(function () {
            if (!horizontalScroll.hasClass('initialized')) {
                $(this).css('position', 'relative');
                $(this).wrapInner('<div class="scroll-wrapper"></div>');
                var wrapper = $(this).find('.scroll-wrapper');
                wrapper.css('overflow', 'auto');
                $(this).append('<div class="shadow left"></div>')
                $(this).append('<div class="shadow right"></div>')
                $(this).addClass('initialized');
                $(window).resize(function () {
                    setScrollShadow();
                });
                wrapper.scroll(function () {
                    setScrollShadow();
                });
            }
        });
    }

    initHorizontalScroll();

    function setScrollShadow() {
        horizontalScroll.each(function () {
            var wrapper = $(this).find('.scroll-wrapper');
            if (wrapper.scrollLeft() <= 0) {
                $(this).find('.shadow.left').removeClass('visible');
            } else {
                $(this).find('.shadow.left').addClass('visible');
            }
            if (wrapper.scrollLeft() >= horizontalScroll.find('.scroll-wrapper > *:first-child').outerWidth() - wrapper.outerWidth()) {
                $(this).find('.shadow.right').removeClass('visible');
            } else {
                $(this).find('.shadow.right').addClass('visible');
            }
        });
    }

    // Overlays
    var overlayV1 = $('.overlay');
    var overlayV2 = overlayV1.find('.overlay-v2');

    function setOverlayPageNavigation(overlayID) {
        var thisOverlay = overlayV2.filter('[data-id="' + overlayID + '"]');
        var overlayPageNavigation = thisOverlay.find('.overlay-page-navigation');
        overlayPageNavigation.find('.prev').addClass('inactive hidden');
        overlayPageNavigation.find('.next').removeClass('inactive hidden');
    }

    function openOverlay(overlayID) {
        var thisOverlay = overlayV2.filter('[data-id="' + overlayID + '"]');
        if (thisOverlay.length > 0) {
            $('.overlay-wrapper').hide();


            disableScrolling();
            overlayV2.hide();
            thisOverlay.show();
            thisOverlay.find('.overlay-page').hide();
            thisOverlay.find('.overlay-page[data-page="1"]').show();
            thisOverlay.attr('data-current-page', 1);
            setOverlayPageNavigation(overlayID);
            overlayV1.fadeIn(250);
        }
    }

    function checkRequiredOverlayFields(overlayID) {
        var thisOverlay = overlayV2.filter('[data-id="' + overlayID + '"]');
        var currentOverlayPage = parseInt(thisOverlay.attr('data-current-page'));
        var thisOverlayPage = thisOverlay.find('.overlay-page[data-page="' + currentOverlayPage + '"]');
        var check = true;
        if (thisOverlayPage.find('select[name="select-studio"]').val() == 'none') {
            check = false;
        }
        return check;
    }

    function goToOverlayPage(overlayID, nextOverlayPage) {
        var thisOverlay = overlayV2.filter('[data-id="' + overlayID + '"]');
        var overlayPageNavigation = thisOverlay.find('.overlay-page-navigation');
        var currentOverlayPage = parseInt(thisOverlay.attr('data-current-page'));
        if (nextOverlayPage == 'prev') {
            nextOverlayPage = currentOverlayPage - 1;
        }
        if (nextOverlayPage == 'next') {
            nextOverlayPage = currentOverlayPage + 1;
        }
        var isFirstOverlayPage = false;
        if (nextOverlayPage <= 1) {
            isFirstOverlayPage = true;
        }
        var isLastOverlayPage = false;
        if (nextOverlayPage >= thisOverlay.attr('data-pages')) {
            isLastOverlayPage = true;
        }
        thisOverlay.attr('data-current-page', nextOverlayPage);
        overlayPageNavigation.addClass('fade-out');
        thisOverlay.find('[data-page="' + currentOverlayPage + '"]').fadeOut(250, function () {
            thisOverlay.find('[data-page="' + nextOverlayPage + '"]').fadeIn(250);
            overlayPageNavigation.find('.button').removeClass('inactive hidden');
            if (isFirstOverlayPage == true) {
                overlayPageNavigation.find('.prev').addClass('inactive hidden');
            }
            if (isLastOverlayPage == true) {
                overlayPageNavigation.find('.next').addClass('inactive hidden');
            }
            overlayPageNavigation.removeClass('fade-out');
        });
    }

    $('.overlay-page-navigation .prev').click(function () {
        var overlayID = $(this).parent().parent().attr('data-id');
        goToOverlayPage(overlayID, 'prev');
    });
    $('.overlay-page-navigation .next').click(function () {
        var overlayID = $(this).parent().parent().attr('data-id');
        if (checkRequiredOverlayFields(overlayID) == true) {
            goToOverlayPage(overlayID, 'next');
        }
    });
    $('a[href*="#betreutes-probetraining"]').click(function (e) {
        e.preventDefault();
        openOverlay('supervised-trial');
    });

    function scrollToOverlaySelect(elThis) {
        setTimeout(function () {
            $('.overlay-scroll').scrollTop(0);
            var viewportOffset = elThis.next()[0].getBoundingClientRect();
            $('.overlay-scroll').scrollTop(viewportOffset.top - 25);
        }, 1);
    }

    overlaySupervisedTrial = overlayV2.filter('[data-id="supervised-trial"]');
    overlaySupervisedTrial.find('select[name="select-studio"]').on('change', function () {
        scrollToOverlaySelect($(this));

        if (this.value == 'none') {
            overlaySupervisedTrial.find('.overlay-form').hide();
        } else {
            overlaySupervisedTrial.find('.overlay-form').show();
        }
    });

    function checkOverlayFormRequiredFields(formID) {
        var form = overlayV2.filter('[data-id="' + formID + '"]').find('.overlay-form');

        form.find('> .required input').removeClass('error');
        form.find('> .required input[type="checkbox"]').parent().removeClass('visible');
        form.find('> .required select.required').next().removeClass('error');
        form.find('> .required span.error').removeClass('visible');

        var valid = true;
        requiredWrapper = form.find('> .required');
        requiredWrapper.each(function () {
            var inputText = $(this).find('input[type="text"]');
            if (inputText.length > 0) {
                if (inputText.val() == '') {
                    inputText.addClass('error').next().addClass('visible');
                    valid = false;
                }
            }
            var inputEmail = $(this).find('input[type="email"]');
            if (inputEmail.length > 0) {
                var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
                if (!filter.test(inputEmail.val())) {
                    inputEmail.addClass('error').next().addClass('visible');
                    valid = false;
                }
            }
            var inputCheckbox = $(this).find('input[type="checkbox"]');
            if (inputCheckbox.length > 0) {
                if (!inputCheckbox.is(':checked')) {
                    inputCheckbox.parent().addClass('visible');
                    valid = false;
                }
            }
        });

        return valid;
    }

    function sendSupervisedTrialForm() {
        var formID = 'supervised-trial';
        if (checkOverlayFormRequiredFields(formID) == true) {
            var overlay = overlayV2.filter('[data-id="' + formID + '"]');
            var form = overlay.find('.overlay-form');
            var formInputSubmit = form.find('input[type="submit"]');
            formInputSubmit.addClass('sending');
            formInputSubmit.next().removeClass('visible');

            var formTitle = form.find('select[name="select-title"]').val();
            var formFirstname = form.find('input[name="firstname"]').val();
            var formLastname = form.find('input[name="lastname"]').val();
            var formEmail = form.find('input[name="email"]').val();
            var formPhone = form.find('input[name="phone"]').val();
            var formStudioId = overlay.find('select[name="select-studio"]').val();
            var newsletter = overlay.find('input[name="newsletter"]').is(':checked') ? 1 : 0;
            var formStudioName = overlay.find('select[name="select-studio"] option[value="' + formStudioId + '"]').data('slug');

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=save_supervised_trial&trial_title=' + formTitle + '&trial_firstname=' + formFirstname + '&trial_lastname=' + formLastname + '&trial_email=' + formEmail + '&trial_phone=' + formPhone + '&trial_studio=' + formStudioId + '&newsletter=' + newsletter,
                success: function (results) {
                    var obj = jQuery.parseJSON(results);
                    if (obj.success == true) {
                        overlay.find('.overlay-page > .text, .overlay-page > .overlay-form').fadeOut(250);
                        var overlaySuccessMessage = overlay.find('.overlay-page > .text.success-message');
                        var successMessageHeight = overlaySuccessMessage.show().css('height', 'auto').height();
                        overlaySuccessMessage.css('height', '0');
                        overlaySuccessMessage.animate({
                            opacity: 1,
                            height: successMessageHeight + 'px'
                        }, 500);
                        if (document.domain.indexOf('elements.com') >= 0 && window.BorlabsCookie.checkCookieGroupConsent('statistics') == true) {
                            fbq('track', 'CompleteRegistration');
                            ga('send', 'event', 'betreutes-probetraining', 'click', 'betreutes-probetraining-angefordert-' + formStudioName);
                            goog_report_conversion('https://www.elements.com/betreutes-probetraining');
                        }
                    } else {
                        formInputSubmit.removeClass('sending');
                        formInputSubmit.next().addClass('visible');
                    }
                }
            });
        }
    }

    overlayV2.filter('[data-id="supervised-trial"]').find('.overlay-form input[type="submit"]').click(function () {
        sendSupervisedTrialForm();
    });

    // Trigger
    $(window).trigger('resize');

})(jQuery); // Fully reference jQuery after this point.
